import sunpowerLogo from '@/images/top-solar-manufacturers/sunpower-best-solar-panels.webp';
import sunpowerLogoFallback from '@/images/top-solar-manufacturers/sunpower-best-solar-panels.png';
import recLogo from '@/images/top-solar-manufacturers/rec-best-solar-panels.webp';
import recLogoFallback from '@/images/top-solar-manufacturers/rec-best-solar-panels.png';
import lgLogo from '@/images/top-solar-manufacturers/mission-solar-logo.jpg';
import lgFallbackLogo from '@/images/top-solar-manufacturers/mission-solar-logo.jpg';
import solariaLogo from '@/images/top-solar-manufacturers/solaria-best-solar-panels.webp';
import solariaFallbackLogo from '@/images/top-solar-manufacturers/lg-best-solar-panels.png';
import qcellsLogo from '@/images/top-solar-manufacturers/q-cells-best-solar-panels.webp';
import qcellsFallbackLogo from '@/images/top-solar-manufacturers/q-cells-best-solar-panels.webp';
import panasonicLogo from 'images/top-solar-manufacturers/panasonic.jpg';
import silfabLogo from 'images/top-solar-manufacturers/silfab.png';
import aptosLogo from 'images/top-solar-manufacturers/aptos.png';

import lg440w from '@/images/top-solar-panel-wattage/440w-LGNeON-RSeriesLG-440QAC-A6.webp';
import qcell from '@/images/top-solar-panel-wattage/400-HanwhaQ-CellsPeakDUO400-AC.webp';
import solaria400w from '@/images/top-solar-panel-wattage/solaria400w.webp';
import lg395 from '@/images/top-solar-panel-wattage/395w-LGNeON.webp';
import lg370 from '@/images/top-solar-panel-wattage/370w-LGNeON.webp';
import mSeries435 from '@/images/top-solar-panel-wattage/energypal-solar-panel-sunpower-m-series-m435-m420.webp';
import aSeries from '@/images/top-solar-panel-wattage/energypal-solar-panels-sunpower-spr-a430-a450-com.webp';
import xSeries from '@/images/top-solar-panel-wattage/energypal-solar-panels-sunpower-x-series-x22-370w.webp';

import Model3 from '@/images/best-electric-vehicles/teslaModel3.webp';
import ModelY from '@/images/best-electric-vehicles/teslaModelY.png';
import ModelS from '@/images/best-electric-vehicles/teslaModelS.jpeg';
import Bolt from '@/images/best-electric-vehicles/chevorletBolt.jpeg';
import MachE from '@/images/best-electric-vehicles/fordMachE.jpg';
import SleekPanel from 'images/best-electric-vehicles/solarpanel.png';
import ID4 from 'images/best-electric-vehicles/id4.jpeg';
import froniusLogo from '@/images/top-inverter-manufacturers/fronius.webp';
// import froniusLogoFallback from '@/images/top-inverter-manufacturers/fronius.png';
import froniusProduct from '@/images/top-inverter-manufacturers/fronius-product.webp';
import froniusProductFallback from '@/images/top-inverter-manufacturers/fronius-product.png';

import solaredgeLogo from '@/images/top-inverter-manufacturers/solar-edge.webp';
// import solaredgeLogoFallback from "@/images/top-inverter-manufacturers/solar-edge.png";
import solaredgeProduct from '@/images/top-inverter-manufacturers/solaredge-product.webp';
import solaredgeProductFallback from '@/images/top-inverter-manufacturers/solaredge-product.png';

import smaLogo from '@/images/top-inverter-manufacturers/sma.webp';
// import smaLogoFallback from "@/images/top-inverter-manufacturers/sma.png";
import smaProduct from '@/images/top-inverter-manufacturers/sma-product.webp';
import smaProductFallback from '@/images/top-inverter-manufacturers/sma-product.png';
import TeslaEnergy from 'images/installer-reviews/tesla-energy-logo.webp';
import enphaseLogo from '@/images/top-inverter-manufacturers/enphase.webp';
// import enphaseLogoFallback from "@/images/top-inverter-manufacturers/enphase.png";
import enphaseProduct from '@/images/top-inverter-manufacturers/enphase-product.webp';
import enphaseProductFallback from '@/images/top-inverter-manufacturers/enphase-product.png';

import huaweiLogo from '@/images/top-inverter-manufacturers/huawei.webp';
// import huaweiLogoFallback from "@/images/top-inverter-manufacturers/huawei.png";
import huaweiProduct from '@/images/top-inverter-manufacturers/huawei-product.webp';
import huaweiProductFallback from '@/images/top-inverter-manufacturers/huawei-product.png';

import generacProduct from '@/images/top-inverter-manufacturers/generac-product.webp';
import generacLogo from '@/images/top-inverter-manufacturers/generac.png';

// import sunpowerLogo from '@/images/top-inverter-manufacturers/sunpower.png';
import sunpowerProduct from '@/images/top-inverter-manufacturers/sunpower-product.webp';

import SolarPower from '@/images/right-solution/house-1.png';
import SolarBattery from '@/images/right-solution/house-2.png';
import SolarHome from '@/images/right-solution/house-3.png';
import { Review } from './types';

import Arizona from 'images/map/Arizona.svg';
import California from 'images/map/California.svg';
import Colorado from 'images/map/Colorado.svg';
import Connecticut from 'images/map/Connecticut.svg';
import Delaware from 'images/map/Delaware.svg';
import Florida from 'images/map/Florida.svg';
import Georgia from 'images/map/Georgia.svg';
import Idaho from 'images/map/Idaho.svg';
import Illinois from 'images/map/Illinois.svg';
import Indiana from 'images/map/Indiana.svg';
import Maine from 'images/map/Maine.svg';
import Mississippi from 'images/map/Mississippi.svg';
import Maryland from 'images/map/Maryland.svg';
import Massachusetts from 'images/map/Massachusetts.svg';
import Michigan from 'images/map/Michigan.svg';
import Minnesota from 'images/map/Minnesota.svg';
import Missouri from 'images/map/Missouri.svg';
import Nevada from 'images/map/Nevada.svg';
import NewHampshire from 'images/map/NewHampshire.svg';
import NewYork from 'images/map/New York.svg';
import NewJersey from 'images/map/NewJersey.svg';
import NewMexico from 'images/map/NewMexico.svg';
import NorthCarolina from 'images/map/NorthCarolina.svg';
import Ohio from 'images/map/Ohio.svg';
import Oregon from 'images/map/Oregon.svg';
import Pennsylvania from 'images/map/Pennsylvania.svg';
import RhodeIsland from 'images/map/RhodeIsland.svg';
import SouthCarolina from 'images/map/SouthCarolina.svg';
import Tennessee from 'images/map/Tennessee.svg';
import Texas from 'images/map/Texas.svg';
import Utah from 'images/map/Utah.svg';
import Vermont from 'images/map/Vermont.svg';
import Virginia from 'images/map/Virginia.svg';
import Kansas from 'images/map/Kansas.svg';
import Kentucky from 'images/map/Kentucky.svg';
import Iowa from 'images/map/Iowa.svg';
import Washington from 'images/map/Washington.svg';
import WashingtonDC from 'images/map/WashingtonDC.svg';
import Wisconsin from 'images/map/Wisconsin.svg';
import Oklahoma from 'images/map/Oklahoma.svg';
import Louisiana from 'images/map/Louisiana.svg';

import Ontario from 'images/map/Ontario.png';
import Quebec from 'images/map/Quebec.png';
import NovaScotia from 'images/map/NovaScotia.png';
import NewBrunswick from 'images/map/NewBrunswick.png';
import Manitoba from 'images/map/Manitoba.png';
import BritishColumbia from 'images/map/BritishColumbia.png';
import PrinceEdwardIsland from 'images/map/PrinceEdwardIsland.png';
import Saskatchewan from 'images/map/Saskatchewan.png';
import Alberta from 'images/map/Alberta.png';
import NewfoundlandandLabrador from 'images/map/NewfoundlandandLabrador.png';

import Sunpower from 'images/installer-reviews/sunpower.png';
import Sunnova from 'images/installer-reviews/sunnova.png';
import BlueRaven from 'images/installer-reviews/BlueRavenSolar.webp';
import TitanSolar from 'images/installer-reviews/titansolar.png';
import Suntuity from 'images/installer-reviews/SuntuitySolar.png';
import Palmetto from 'images/installer-reviews/Palmetto.webp';
import Axia from 'images/installer-reviews/axiasolar.png';
import CompleteSolar from 'images/installer-reviews/CompleteSolar.png';
import { StaticImageData } from 'next/image';

export const topInverterManufacturers = [
  {
    name: 'Enphase',
    slug: 'enphase-energy',
    product: enphaseProduct,
    productFallback: enphaseProductFallback,
    logo: enphaseLogo,
    points: [
      'Efficiency up to 96.5%',
      '25 year warranty',
      'Designed in USA, assembled internationally in Mexico and India',
      'Enlighten app is free for system owners. Requires additional hardware to monitor consumption',
    ],
  },
  {
    name: 'SolarEdge',
    slug: 'solaredge-technologies',
    product: solaredgeProduct,
    productFallback: solaredgeProductFallback,
    logo: solaredgeLogo,
    points: [
      'Efficiency up to 99%',
      '12 year Warranty on Inverters, warranty extension available.  25 year warranty on Optimizers',
      'Manufactured in Hungary and China',
      'Addition of Optional WiFi enabled inverters can provide panel level monitoring. SolarEdge monitoring system generally reviewed as one of the best available',
    ],
  },
  // {
  //   name: 'Fronius',
  //   slug: 'fronius-usa-llc',
  //   product: froniusProduct,
  //   productFallback: froniusProductFallback,
  //   logo: froniusLogo,
  //   points: [
  //     'Efficiency up to 98%',
  //     '5 year Standard Warranty, 10 year warranty free of charge if registered online',
  //     'Manufactured in Austria',
  //     'Need Fronius Smart Meter to enable monitoring of consumption and generation. Fronius Solarweb app is highly rated but only available with a premium subscription',
  //   ],
  // },
  {
    name: 'Generac',
    slug: 'generac',
    product: generacProduct,
    productFallback: smaProductFallback,
    logo: generacLogo,
    points: [
      'Efficiency up to 97.5%',
      '10 year warranty',
      'Free system monitoring included via PWRview Web Portal and Mobile App',
      'Manufactured in the USA',
    ],
  },
  // {
  //   name: 'SunPower',
  //   slug: 'sunpower',
  //   product: sunpowerProduct,
  //   productFallback: smaProductFallback,
  //   logo: sunpowerLogo,
  //   points: [
  //     'Efficiency up to 97%',
  //     '25 year warranty',
  //     'Manufactured in USA, Mexico, Philippines',
  //     'System monitering available via the mySunPower app',
  //   ],
  // },
  // {
  //   name: 'SMA',
  //   slug: 'sma-america',
  //   product: smaProduct,
  //   productFallback: smaProductFallback,
  //   logo: smaLogo,
  //   points: [
  //     'Efficiency up to 97%',
  //     'Optional 10-20 year warranty',
  //     'Designed and Manufactured in Germany',
  //     'Free online monitoring in the Sunny portal, but full consumption and solar monitoring requires expensive Sunny home manager 2.0',
  //   ],
  // },
  {
    name: 'Huawei',
    slug: 'huawei-technologies-usa',
    product: huaweiProduct,
    productFallback: huaweiProductFallback,
    logo: huaweiLogo,
    points: [
      'Efficiency up to 98.6%',
      'Warranty 5-10 years depending on model',
      'Designed and Manufactured in China',
      'FusionSolar app available through direct connection to WiFi network      ',
    ],
  },
];

export const SunpowerVsRec = [
  {
    name: 'SunPower',
    slug: 'sunpower',
    webp: sunpowerLogo,
    png: sunpowerLogoFallback,
    points: [
      'Efficiency up to 22.8%',
      '25-year warranty, 92% production guarantee',
      'Made in USA, Mexico, Philippines',
    ],
  },
  {
    name: 'REC Solar',
    slug: 'rec',
    webp: recLogo,
    png: recLogoFallback,
    points: [
      'Efficiency up to  21.9%',
      '25-year warranty, 92% production guarantee',
      'Made in Singapore',
    ],
  },
];

export const SunpowerVsQCells = [
  {
    name: 'SunPower',
    slug: 'sunpower',
    webp: sunpowerLogo,
    png: sunpowerLogoFallback,
    points: [
      'Efficiency up to 22.8%',
      '25-year warranty, 92% production guarantee',
      'Made in USA, Mexico, Philippines',
    ],
  },
  {
    name: 'Q CELLS',
    slug: 'q-cells',
    webp: qcellsLogo,
    png: qcellsFallbackLogo,
    points: [
      'Efficiency up to 20.3%',
      '25-year warranty, 85% production guarantee',
      'Made in South Korea (previously German company)',
    ],
  },
];

export const topSolarManufacturers = [
  {
    name: 'SunPower',
    slug: 'sunpower',
    webp: sunpowerLogo,
    png: sunpowerLogoFallback,
    points: [
      'Efficiency up to 22.8%',
      '25-year warranty, 92% production guarantee',
      'Made in USA, Mexico, Philippines',
    ],
  },
  {
    name: 'REC Solar',
    slug: 'rec',
    webp: recLogo,
    png: recLogoFallback,
    points: [
      'Efficiency up to  21.9%',
      '25-year warranty, 92% production guarantee',
      'Made in Singapore',
    ],
  },
  {
    name: 'Q CELLS',
    slug: 'q-cells',
    webp: qcellsLogo,
    png: qcellsFallbackLogo,
    points: [
      'Efficiency up to 20.3%',
      '25-year warranty, 85% production guarantee',
      'Made in South Korea (previously German company)',
    ],
  },
  {
    name: 'Solaria',
    slug: 'solaria',
    webp: solariaLogo,
    png: solariaFallbackLogo,
    points: [
      'Efficiency up to 20.4%',
      '25-year warranty, 88% production guarantee',
      'Made in USA (Fremont, CA)',
    ],
  },
  {
    name: 'Panasonic',
    slug: 'panasonic',
    webp: panasonicLogo,
    png: panasonicLogo,
    points: [
      'Efficiency up to 22.2%',
      '25-year warranty, 92% production guarantee',
      'Made in Japan, Malaysia, and the United States.',
    ],
  },
  {
    name: 'Silfab',
    slug: 'silfab',
    webp: silfabLogo,
    png: silfabLogo,
    points: [
      'Efficiency up to 21.4%',
      '25-year warranty, 30-year 82.6% production guarantee',
      'Made in USA and Canada',
    ],
  },
  {
    name: 'Aptos',
    slug: 'aptos-solar-technology',
    webp: aptosLogo,
    png: aptosLogo,
    points: [
      'Efficiency up to 20.6%',
      '25-year warranty, 30-year 82.4% production guarantee',
      'Made in Vietnam',
    ],
  },
];
export const BestSolarManufacturers = [
  {
    name: 'REC Solar',
    slug: 'rec',
    webp: recLogo,
    png: recLogoFallback,
    efficiency: 'Up to 21.9%',
    warranty: '25-year comprehensive warranty with a 92% production guarantee',
    manufacturing: 'Singapore',
    features:
      'Innovative solar technology and sustainable manufacturing practices',
  },
  {
    name: 'Q CELLS',
    slug: 'q-cells',
    webp: qcellsLogo,
    png: qcellsFallbackLogo,
    efficiency: 'Up to 20.3%',
    warranty: '25-year warranty and an 85% production guarantee',
    manufacturing: 'South Korea (originally a German company)',
    features:
      'Reliable and high-quality solar panels, suitable for a wide range of climatic conditions',
  },
  {
    name: 'Solaria',
    slug: 'solaria',
    webp: solariaLogo,
    png: solariaFallbackLogo,
    efficiency: 'Up to 20.4%',
    warranty: '25-year warranty with an 88% production guarantee',
    manufacturing: 'USA (Fremont, CA)',
    features:
      'Panels designed for high performance and aesthetics, ideal for residential systems',
  },
  {
    name: 'Panasonic',
    slug: 'panasonic',
    webp: panasonicLogo,
    png: panasonicLogo,
    efficiency: 'Up to 22.2%',
    warranty: '25-year warranty, offering a 92% production guarantee',
    manufacturing: 'Japan, Malaysia, and the United States',
    features: 'Durability and high energy yield, even in low light conditions',
  },
  {
    name: 'Silfab',
    slug: 'silfab',
    webp: silfabLogo,
    png: silfabLogo,
    efficiency: 'Up to 21.4%',
    warranty:
      '25-year warranty with a unique 30-year 82.6% production guarantee',
    manufacturing: 'USA and Canada',
    features:
      'High-efficiency, North American-made solar panels with a strong emphasis on quality control',
  },
  {
    name: 'Aptos',
    slug: 'aptos-solar-technology',
    webp: aptosLogo,
    png: aptosLogo,
    efficiency: 'Up to 20.6%',
    warranty: '25-year warranty and a 30-year 82.4% production guarantee',
    manufacturing: 'Vietnam',
    features: 'Cost-effective and efficient solar solutions',
  },
];

export const bestSolarPanelWattage = [
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
  {
    company: 'Aptos Solar',
    panel: 'DNA 144 - 440W',
    wattage: '440',
    warranty: 'f Years',
    effiency: 'f%',
    type: 'monof',
  },
];

export const topSolarPanelWattage = [
  {
    name: '440w - LG NeON-R Series LG-440QAC-A6',
    webp: lg440w,
  },
  {
    name: '435 - SunPower M-Series SPR-M435-G-AC',
    webp: mSeries435,
  },
  {
    name: '425 - SunPower A-Series SPR-A425-W-AC',
    webp: mSeries435,
  },
  {
    name: '420 - SunPower A-Series SPR-A420-W-AC',
    webp: aSeries,
  },
  { name: '400 - Solaria PowerXT-400-PM-AC (400w)', webp: solaria400w },
  {
    name: '400 - SunPower A-Series SPR-A400-W-AC',
    webp: aSeries,
  },
  {
    name: '400 - Hanwha Q-Cells Peak DUO 400-AC',
    webp: qcell,
  },
  {
    name: '395 - LG NeON-R Series LG-395Q1C-A6',
    webp: lg395,
  },
  {
    name: '370 - SunPower X-Series SPR-X370-E-AC',
    webp: xSeries,
  },
  {
    name: '370w - LG NeON-R Series LG370Q1C-V5',
    webp: lg370,
  },
];

// export const getUniqueTopSolarManufacturers = (query:string) => {
//   return topSolarManufacturers.filter((el) => query !== el.slug);
// };

export const features = [
  {
    href: '',
    name: 'Solar Power',
    image: SolarPower,
    description: 'Lowers the cost of power for your home',
    points: [
      'High efficiency solar panels',
      'Professional installation',
      'Energy monitoring equipment',
      '25-year equipment warranty',
    ],
  },
  {
    href: '',
    name: 'Solar + Partial Home Backup',
    image: SolarBattery,
    description: 'Stay powered during utility blackouts',
    points: [
      'Includes everything in Solar Power package',
      'Backup battery for critical loads',
      'Store & use excess solar power',
      'Additional government incentives',
    ],
  },
  {
    href: '',
    name: 'Solar + Whole Home Backup',
    image: SolarHome,
    description: 'Security with ultimate independence',
    points: [
      'Includes everything in Solar + Partial Backup package',
      'Higher capacity home batteries',
      '24/7 off-grid capability',
      'Maximum savings and protection',
    ],
  },
];

export const reviews: Review[] = [
  {
    name: 'Marisa Toriggino',
    comment: `Kevo was always very respectful of my time and my questions. He was careful with his communication, which helped me to trust him, and even eventually understand what was the best for me. I am very happy with my decision to use Energy Pal and have already told a few friends about my experience.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV4eqfSShqUOpUenJztIgpPIdmxLAxnVJh4UBtc0Jx0wvl4wc0=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'David South',
    comment: `Proposal from EnergyPal was comprehensive and easy to understand. Price was very competetive and panels and equipment was quality. I recommend including EnergyPal for a quote if you are shopping for solar systems.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLk1F-bWkyMoLPaNM9twA6NrZtxx4YQfAxdmAdxHpFGbL88qQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Katherine Ames',
    comment: `Jesse is an excellent representative for Energy Pal. The company is very easy to work with and very helpful to answer any questions customers have. They aren’t pushy at all that’s a big plus.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIILdWGiIHVzNM23r4EvnnRhMAbu4lJw235ucf08EkYypPDCw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jon Fragosa',
    comment: `Yes, I thought Caleb from energy Pal was thorough, we discussed a preliminary plan, made some adjustments and I am looking forward to the new design, very good presentation...looking forward to working with them.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJG9d47jRnTQVZhZf4qHQLnL3wtwONeDr0Ahg4ppSAok5MX7Q=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Stunda',
    comment: `I recently worked with Jesse Agrey, Energy Pal to install 27 solar panels on my house. Jesse recommended Green Brilliance and was instrumental in explaining the process, addressing my numerous questions and concerns and acting as the primary contact throughout the installation process. Frankly, without Jesse's involvement I do not think I would elected to move forward with the project. It took several months, somewhat due to my reluctance to move forward with such an expensive project until I felt comfortable and had a basic understanding of the process. Though I believe Green Brilliance could have done a better job communicating again Jesse is what kept me and the project on track. Approx 7 months later we have a functioning solar panel system installed,because we missed the higher production summer months, it is harder to determine whether the system will produce the electricity expected but overall I am pleased with the job and highly recommend Jesse and Energy Pal to "quarterback" your solar panel purchase.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJeUxJC8JEDCCtZbNv1kuf4aLcO5iu_q880TP5DLuzpHg9SNQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Devon Miller',
    comment: `Matthew Kosydar did an amazing job helping me research companies that could meet my roofing and power needs within my Zip Code.

Even though my local solar companies didn't give me all the details I wanted, this consultation service helped me research 3 out of the 5 companies I looked into. Thus was a gigantic boon and aid to my time and efforts.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIvjtM8D0HD-G066suwfVfIS7oMqDF2LWVXzeb1wjCWyrSfVQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mandel',
    comment: `Wow!! An honest company with fair pricing. Sales representative would not answers my questions until he fully understood the questions and the answers to my questions. Several times he spent a day or to verifying his answers before he advised me. Best, by faar, experiance.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLT35QI7XbTv-dKTO7w1AYGkUbjHh1Eo6pI_E7FC27LVC0K=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Minh V.',
    comment: `Great experience with Kevo. He was polite and very professional. He took the time to explain every step of the process in a clear and thorough manner, making sure we fully understood all the details. We didn’t end up working together due to some specific considerations related to our roof.
But I wont hesitate to recommend them to anyone in need of their services.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVChDsJAZPC0ITr_TqStIGTkTR-P5BDFs5N7BaD0s-feh2W47o=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dinesh Solanki',
    comment: `Great company. No pushy calls. Just great experience. Explained pros and cons of different options. Will definitely recommend.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJ5mQtPnpHVsmWNTEP8GV3n_gKx_Z2FxWh6VchGfh3tIHVUhQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Yuanqi Zhu',
    comment: `Kevo is super knowledgeable on the details of solar installations, definitely 5 stars experience!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKB1LX77XETlWX8RMUhDkJKShZP1vXsHH7TxxUXiOhTgkrTMg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'Philip OKeefe',
    comment: `Chris was like finding a native when lost in the forest of Solar panels. His explanations and recommendations were clear, concise and filled with comparisons among the different options. I could not recommend him any more highly.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK766cyspwVvBYiRiu4q-tJWidvzxvnYNPbksTdXmzyQ3jU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'D.B. Mahbod',
    comment: `I worked with Brian Weaver at EnergyPal. Brian was knowledgeable and provided in depth analysis of my choice with panels and batteries. He understood my needs and offered a wide variety of options from panels, to solar inverters, to battery types; as well detailed financial cost/benefit analysis. After a month of working with another vendor that caused frustration and sometimes offered incorrect advice and information, it was wonderful to speak with Brian that had so much domain knowledge. For everyone seeking to install Solar system, understand the existing market place, and gain independence from utility companies, I highly recommend working with Brian and EnergyPal.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJb7LJPd6rPVqwnAbEO6aazW9tGNn2Bc4isB233TL34-IEHSQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joey Zemba',
    comment: `Jesse is by far the most knowledgeable representative in the solar industry that I've spoken with out of the four companies I interviewed relative to going solar. Every element from a practical perspective is included in Jesse's proposal and the home owner is of clear mind in the decision making process. EnergyPal is hands down the right company for me and should be for you too!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUjguZnTpIyljR_EtAplPlgOzHLghnPodIKhF2I6wUwqBCsr7GT=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Robert Reilly',
    comment: `Brian was very helpful and knowledgeable in providing all of the solar options that would be good for me. I look forward to working with Energypal soon!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLDn8D4oAeQw75bX-Ha12KTmqHUJMToE5z4-sxjToL6_9yJCg=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kim Wetzel',
    comment: `Stephanie was, delightful, knowledgeable, and easy to work with! I couldn't ask for anyone better!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXbrSa6TbXI-dfM9z7pC0zDBIt0CwP0HYszoHCQ_OnZN549nO1g=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Charles Huffman',
    comment: `Jesse at EnergyPal was very helpful getting us started with solar energy. He reached out to us when something was happening. Enjoying the benefits of solar energy. Chuck and Sue`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJQYR2FnFvTX-Gv_L_ryRJsxyq2BDW-tWlvBm9oI8cv9d5v0Q=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Peter Gibson',
    comment: `Alex impressed us from start to finish. He was very professional, knowledgeable and accommodating in directing our project. He excels in his people skills. We would not hesitate to recommend him for your solar project.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJQYR2FnFvTX-Gv_L_ryRJsxyq2BDW-tWlvBm9oI8cv9d5v0Q=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'https://www.google.com/maps/contrib/111074878186807964738/reviews?hl=en',
    comment: `My solar is not actually up yet but so far the process has been great. I highly recommend Kevo as a consultant to figure out the best situation for any upcoming project. I went with EnergyPal because they don’t represent just one solar company. They work with several solar companies and choose the right one for your situation.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWSv_PQWDeS0gbN6MM6BeW-AmkB80gBrW--zSY9JJx8odVgJFf8zA=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dean Giebelhausen',
    comment: `I have been working with Kevo. I was pretty well set to go with another solar company and was trying to get some information from a different company. I have researched several solar companies. I ended up on EnergyPal’s
website by mistake. Kevo called me and we had several conversations. It was not my intent to go with EnergyPal in the beginning but Kevo was very knowledgeable and answered my questions well without pressure. We covered some very in depth questions and answers. I feel better represented with Kevo and EnergyPal. There are a lot of bad reviews out there with some other solar companies but EnergyPal is rated well. I am just starting the process and have been contacted by Carlene on the EnergyPal project support team. So far everything is going very well. I am looking forward to working with them. I will follow up as the project progresses.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJSsKlBX4s2yKi7NBsyxAoNXHG8WYQTF45m3GyLY8q0huvDHw=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joe Hile',
    comment: `Very knowledgeable and helpful on looking into getting solar panels. Willing to assist in any way he can. Definitely one to call if you are looking to go solar!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWZOc8EWuPQ7U5lnZItpbKkz2NTw8RAGYPKAu7Gxpnc2-r9Pv_g8A=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kevin Kyger',
    comment: `Alex did a great job in building a plan for my solar power system.
I had spent a couple of weeks searching the internet trying to learn what parts were required and their size/capacity requirements.
Alex took my power requirements and tailored a system to fit my roof. He took the roof size, slope, and sun orientation into account and provided a list of components, price (including tax incentives), and contacts for local installers and inspectors.
All that's left is to give the plans to an installation team .`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLchsOwoKk5ZL1CE8aHucSbjuMPOXz5122u70J9xpbpOuUrDA=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ron Brill',
    comment: `I discussed a solar project with Jessie Agrey with Energy pal today and couldn't be more impressed. I'm researching this project and he gave me answers and information others couldn't. There was no sales pressure, only a desire that I fully understood the project completely. Before you purchase a Solar system you need to speak with the folks at Energy Pal. Their project tools are top notch and prices competitive.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL8cyHnwJEa_LN9m_eNQoipnU8tYmNTqBhgFk6wgkyfGWfGEA=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Guru Prasad',
    comment: `Energypal helped us to get the best deal for our Solar panel installation with prompt turn around and patience with all approvals from authorities. Happy working with Energypal.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV82yHmypbrPGMGU9jVriJO689XKZxMm5DTuKgnm9zGweA9vqIl=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John-Eric Gabagat',
    comment: `The Energy Advisor, Gordan Dumka, provided an exceptional experience in my search for a solar panel and energy storage system. I appreciate how he took the time to understand our needs and followed up regularly. He was very patient and put together many proposals for comparison. Gord was easy to reach and responsive via phone, text, or email. For unrelated reasons, I ended up going with a local company, but Gord was truly a pleasure to work with.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJ-MXCmGGsjWHkvf4tABZ89gUjUDSWiKXmFyD8p4yOQbsx5DQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Carmelita Dominguez',
    comment: `I experienced very good vibes from Kevo, at Energy Pals, He was very easy to talk to, very knowledgeable, and friendly to work with, He stayed on top of the information we needed, and was very prompt with the coming instructions and information. Kevo was readily available to contact for any concerns or questions. I look forward to working with Kevo , from Energy Pals, in the future.👍🥰`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUsGQuhbB9xllQj2VP_uGx6Bmszr5Hn0V7CN9TQmwS-FnHs29uP=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'arunasene',
    comment: `Robert Healey is an outstanding solar expert who guided us through the process of adopting solar. His knowledge about solar energy is outstanding. He was able to answer any question I had about going solar. There was no high pressure sales, just genuine interest in finding the best product for our needs. In the end, although we did not use his company because we were more than halfway through working with other vendors, the story may have been different if Rob had come into the picture earlier. I could not have asked for a better sales rep than Rob.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjViMrU68WJkL8AAwMUC5CXg_nWg6Hl58Jf2AKjYk6ADAfEW3uk=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'edward soto',
    comment: `Robert Healy was my consultant at energy pals he was highly knowledable and excellent to work with he went out of his way to put together a perfect solar panel package for me that was most affordable`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJSm5jY5a3NAbGbWVEo9QFqwOzq7E7QRSzgAEWhNO16YOpszw=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Heidi Tam',
    comment: `Caleb Siu did an excellent job. My solar & Roof project has been working for almost 2 years. I have been working with a few customer service representatives on this project, but my project was stalled and did not move on. Finally, Caleb picked up the project and now it is finally completed. I am happy with his working attitude. Even when he was on vacation he let me know and still replied to my text message.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJJlhDTc2oMQ28aaqaU5nS5ZxU_hSkFIXnjnfcwSbVfUceRpQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Donna Deatrick',
    comment: `Matt was very patient and very understanding of making such a change….and showing me the savings I could have… at my age I live on a fixed income and this change to solar could make a huge benefit for me…to stay in my Home.. So I’m looking forward to this…it gives me more hope financially. Matt is very calm, patient as I said, and will answer whatever you ask ….so I’m thankful…`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLILTefX7AvG9-Spf2BFwEGdqA6DFrREZwoZzMXFbPlnOihzw=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jane Cannon',
    comment: `Lincoln Panasay has been extremely helpful with exploring solar options, explaining state tax initiatives and helping with solar credits. Three years ago he helped us to find the best manufacturers, breaking down cost and helped us through the install process all the way to the finish line. He is still helping me three years later, answering questions that I have on my system. Thanks Lincoln! It’s like having my own case manager for solar! Our system produces enough to cover all of our electric use. The credits we get from NJ for our production cover most of the loan!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVmQi4pDzBfC6Cr7jmPMGeZJ3JqaJ9mYIjaJVdEd1RQV4WEd1y9=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kevin Walker',
    comment: `Mitch was very helpful and informative. He answered all my questions and addressed my concerns immediately. Getting Solar was one of the best decisions I’ve made`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKNQ57DVppbF2O5R2FeiyFGgy1fJ5VGE_4G2d5drP3TezKWTw=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Andrew McMillen',
    comment: `Jesse did such a great job explaining options and providing exceptional details about solar benefits. I learned a lot from the conversation and think they are a great company to work with.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV5428Wn6zJC3ixuqLpoh-TvV8B6NSnxr334yRTGO07V6jFFkNF=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Allen Hindin',
    comment: `Brian Weaver was a ray of sunshine, in the midst of fog.
He is what we needed, a competent coach.
Brian answered all of our questions in a clear and concise manner, allowing us to make informed decisions. We never felt as if we were the subject of a sales presentation.

EnergyPal should be the first next stop, after anyone decides to investigate the benefits of going solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJTdgJlSxWSgO1LQ26gunZAidgGmQqoXcFCEcB3C4tU1-763Q=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Esther Poli',
    comment: `Rob Healy is an exceptional customer service sales rep! He went out of his way to research a solar company that would fit my needs, and explained to me everything involved in setting up solar at my residence. Greatly appreciative of his patience and professionalism. Thank you Rob!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLKkQgTF28lpbDGu86Nv1FjKvJ7sKk3c-smdNv7JNaQ80il=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Gregory Johnson',
    comment: `My experience with Kevo Terzian of EnergyPal was terrific. Kevo was very knowledgeable on all things solar. I never felt he recommended anything that wasn't in our best interest. If I have a need for solar in the future I would definitely contact Kevo.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXO322xww6dHd6QyvU9XYE2mdTpkYy1Re6DX8C_fEnZM6xa2hbP=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Wilson',
    comment: `My sales person was Robert Healy. He's a very patient and kind guy who helped me go through all the solar options. EnergyPal is awesome, good way to go green and save some $$$. Just go for it!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUUeKHVAGePUJ4LL_nIeeZxiEMqR3qLV_AW3ILtlaUBPE3zZI4=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jeff Lau',
    comment: `Working with Bruce Howard made my first foray into the solar space a great experience. I learned a lot from him and I wholeheartedly recommend EnergyPal's services to anyone looking to install solar panels onto their home.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjW36hFrbaPNn25-8Xhzz10BMUZFpEMd4BcasX6Gyj_v9NGtR0oiXw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Darin M',
    comment: `Simon Chen was great to work with as I explored my options. I found him to be friendly, knowledgeable, and very accommodating to any questions or concerns I had. I received several quotes from various companies and the ones from Simon were priced competitively and were transparent regarding the costs and potential savings.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKL5lO_98tGytfmhtMogjlGnGIn3huxHlQb8OwxvVZU-IAJjQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Marlon Bryan',
    comment: `5 Stars doesn't begin to describe what it was like to work with Amanda Swan. We couldn't have had a better steward and guide throughout the solar process than Amanda. Amanda does not conduct herself like a regular "salesperson." She works with a unique degree of diligence, professionalism, insightfulness, patience, and warmth.

Amamda invested her time into taking us through the solar process; ensured that we understood the nuts and bolts; and answered our questions.

As a communicator, she is THE BEST.
If you're Type A and need someone who tells you what you need to know, as soon as you need to know it, so you're not anxious about what you don't know... Amanda is the one to keep you informed and calm. Amanda was on top of every part of the process, from designing our system, choosing the best solar installer, and as a liason between us and our installer.

Absolute pleasure to work with, and I can't wait to send referrals to Amanda Swan. Our system is up and producing, and we're very satisfied.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWTl5QYQAabV_Wtx5FNDJI8qPjpbHTEA7gSJ0ts22gqsoZ383s=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dave Murphy',
    comment: `I did a lot of research and spoke with more than a dozen solar companies trying to find the right match. To be honest, the solar industry is the wild west and it was very difficult and time consuming to meet with and speak to all of the different companies I looked into.

The representatives at EnergyPal were straightforward, intelligent, answered all of my questions and always followed up with me. In particular, Caleb Siu was always responsive and helpful throughout the process.

The installation was fast, smooth, and the solar panels are beautiful top of the line panels. I am waiting for sign off by my local building inspector, transmission of documents to Eversource, and installation of a new meter to make the system operational.

My experience so far with EnergyPal has been very good, and I highly recommend them.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWQ5qR_xe_7bWbofgvqYIPtGQ9FUNyfo6d-6gL9eryWx_r66BMo=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bilyana Radulova',
    comment: `I recently consulted with Kevo regarding solar panel installations, and I couldn't be more impressed with his expertise and service. Kevo patiently answered all my questions, explained the entire process from start to finish, and outlined various options available, from budget-friendly to premium solutions. He also provided insightful comparisons of different product brands, ensuring I understood the quality and performance differences.
What stood out most was Kevo's dedication to customer satisfaction. He spent a generous 90 minutes with me, ensuring all my concerns were addressed thoroughly. I left our meeting feeling confident and well-informed, thanks to Kevo's professionalism and expertise.
I highly recommend Kevo for anyone considering solar panel installations. His knowledge and commitment make him a valuable resource in navigating energy-efficient solutions for your home.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUkt7Tzd26B7p3gsrdqZrbyW5INbmDySWn-RiG1XWbuN65pb_q7=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Tai-Ying Liu',
    comment: `Shaqeel was well prepared before each meeting. Familiar with the material he presented. Polite and professional attitude makes him a good customer contact.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUpK3w_lJ9FbdpPi6AvPmosOi7A8Klww2REOn-l2uYaJrlt0YA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jessie Gunn',
    comment: `AAA +++,Alex Nacinovich provided an in depth proposal to meet my solar energy needs. No high pressure sales, just the right information to make an informed decision.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXdwkBgqht7ZvNCCGMYe3e1iMwuMBX9Fu4VkNTfAYaAgfsmxAg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Ruppel',
    comment: `Alex was able to explain the technology and the financial benefits of solar and how it applied to my individual needs and wants. Time well spent!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJLECsnuVrwT_oYh9bSXdI4FJttsiAkzl7udVGMVrjv9jOD=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Timothy Bedell',
    comment: `Bruce Howard provided all I could ask for. He was patient, knowledgeble, and very willing to to provided background information necessary to answer all my guestions. I think his knowledge made me feel comfortable without being pushy. HIs guidance was greatly appreciated. I couldn't have been introduced to EnergyPal by anyone more cordial. I thank him for his help.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLMJyvzsEqfQHcdn-K7Rzz3icUisKCW3j7NcKH3uG1jAEfMrw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Robert Donahue',
    comment: `My experience dealing with EnergyPal and especially Chris Norseth was a great experience. Chris explained in detail how the Solar system operates and my options for battery use or back-up supply. Chris showed me the layout options and panel suggestion for optimal power production and battery storage. Going through the steps of what to epect when I made the decision to install Solar Panels was clearly explained.
He walked me through the forms as I was filling them out and while communicating with the installation company. The service and professionalism was top notch 5 Star Service from start to finish. I will be reommending EnergyPal and Chris Norseth to everyone I know looking to install a Solar Syatem.
Robert Donahue, Oakdale, CA`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL1ACPhf6Fj8mbn6T7cKNWjWgkhG1QK7y6MZ1J2gb8e4b1pHg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'garyswauger',
    comment: `Aidan made helpful suggestions on applying for the Medical Baseline Program and followed up to see if I was qualified and then provided a solar and battery backup package that makes great sense. Thank you, Aidan.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJNBEgp4TXdj_4KmkozfcRcdymSsgVAisROI69F6MIiCMbBVA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'K Lai',
    comment: `Getting solar panels and backup battery is quite an undertaking. Needless to say, having a honest straight forward consultant is the key.
Simon Chen is one of these energy consultant that's friendly professional and honest! He fully explains and gives you several options to benefit you as a consumer and there's no hard sale technique or forcing you to commit to anything.
As far as I'm concerned, I have solar already in place and I needed questions regarding other issues. Simon answered all my questions and I really appreciate his honesty.
Even though I didn't use him for any solar project needs at this time. I have no reservation in calling Simon and using him if needed in the future, plus I have no issue in referring to friends and families, knowing they will get top notch service from Simon.
Thanks`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKNOHqGV-VcnE0Ri7m0OwmNCM1Z_yt2sgIY70tcZNIY8liYzQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kevin Gorton',
    comment: `Robert Healey was professional, courteous, and thorough. He represented the solar company completely and with zeal. When I rejected the best offer from the first solar company, he found another solar company and presented that company's offer with the same effort. Even when I rejected that offer in favor of another company's offer, Robert offered to come up with a better offer. Although I didn't take him up on it, he remained professional and courteous.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIbl0Z8YRR-2o4SfZFeM_aB8dlapm1NiPR0xPpGJsNJFhhSMw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Sharon Cheung',
    comment: `Robert provided detailed and comprehensive information about solar for my house. He went through the solar plan with me and answered my questions patiently. He provided options for funding and no pressure for making a purchase. I would definitely like to work with him again for solar when I have money saved for it.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKIVCJj_QUYpiAWEDF48CQ8IluMa5GfzrGFSHyw9VjntLQ5=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alex Hessel',
    comment: `Robert with EnergyPal is a pleasure to work with. He is professional, courteous, resourceful, and knowledgeable. I wish everyone who works in sales were like Robert.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjX0Aypw42SbMAILKeEJF4WmMj9eP7mkLdcJTMiQBC57C3YCRYk=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kathryn Hanson',
    comment: `Kevo Terzian was very thorough, and patiently explained all stages and aspects of the process. He generated several options that would best suit the needs of the home. Outstanding job!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUEsL0JOdUXvlF35uz9sqHIryNQQUfGgtUdK44xNbQa8L_YDc2E=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Marie Fiorante',
    comment: `Amanda was such a pleasure to work with. We can't say enough about her professionalism and empathetic personality.  Thank you Amanda for being amazing.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocI-RD_7Qap5LGMJ1yMUOlPEWXrMkZfHNzdzpwQO7GjROykZzQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Albert Sulzer',
    comment: `Kevo of EnergyPal was extremely helpful and informative.  He gave me great advice regarding my solar project and was always readily available to answer questions, and never pressured me during the process.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK8j1iQh6lq8Av_z1y_ib45BVdOB0NFZiMyMfDgd8M07x1PRA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'William Moeller',
    comment: `Had an excellent experience with Kevo at EnergyPal to get price quotes and finalize our Solar installation plans. We did a good deal of research before meeting with Kevo, so we were up-to-speed with solar in general. He was very personable and knowledgeable and did a great explaining procedures and options in understandable detail. Kevo was able to provide multiple quotes from high quality suppliers to ensure we got the most value for our investment. And we loved that EnergyPal would be with us at every step - brokering, project managing, and customer service - until project completion!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXmhX0fkvenmvheKSbUVTIJCfHrmw9iIM-xFpNw0A36MiqoUUw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Keith Hamilton',
    comment: `My wife and I have been researching the feasibility of installing Solar Panels for our 100% electric-heated and air-conditioned home. We were fortunate to have Simon Chen as our contact, as he devoted a substantial amount of his time to providing us with the most current and credible information that one can hope to receive from a professional. If you are researching the pros and cons of installing Solar Panels in your home or business, we confidently recommend Simon Chen as someone that you can trust to navigate you through this critically important process.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUIQRcYi5hu_v1KJlAtkTqLs1od6BmtYA0X58dmpvWll9Eg-lk9=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Nirmala Thuraisingam',
    comment: `Kevo is our contact person at EnergyPal. He is very friendly, helpful, thorough, great listener and professional in educating us about the benefits of power of solar energy.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUeryRc2xZL_5byxh-fqrfbF4S54T_MN5OzRoNsBchQTyHSqU8u=w120-h120-p-rp-mo-ba2-br100',
    type: 'google',
  },
  {
    name: 'Alex Zubarev',
    comment: `I had a very good experience with the whole process. Big thanks to Sheldon Sinnott who was on the top of every question / request. Great response, great service. He did go above and beyond to accommodate every request. Great job! Thank you.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVpBO5WmzygVKqQlOUneudM8RkcHou9JdVHSn0uzzAG6tmznEWA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Amy Ceney',
    comment: `Caleb was great about keeping us in the loop and helping everything run smoothly- our system is running really well.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJoZjylXP7HikK4EXZ5KjU39iYz3ulKHFgheUZ0xF9EHLrEJg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Stephen Welford',
    comment: `Brian was attentive, knowledgeable and extremely helpful, especially in ensuring that I understood all the facets of solar power and systems.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIEbgsikFdGoNYaO4MJksiTYZjnPiSrmPO_TlJx7zPiWda9UQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Keem',
    comment: `Glen Duncan was clear, professional, candid in his presentation of solar options.  He answered all questions clearly and succinctly. I highly recommend Glean as a fair advisor/representative of solar options.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIqfNA1IMBGJ-i2qN6AebdHKDSRovAoPx-t_uS8woRL1Bn_WQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'George Morcos',
    comment: `Robert at EnergyPal has gone above and beyond to help me with the solar system of my choice and to understand and compare the different systems and get the system that best fits my needs.
I really appreciate his help, time and support.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocILnADFndc_ahLLeL6lM1dqm5O-9kXg37dNNMUPJlwX-WXpKg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Leran Nodel',
    comment: `Jesse was very knowledgeable and explained everything super thoroughly. The service was great and everything came together well. Highly recommend!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXsHZ8b514In6-3kUOGl7ipZIkYOvWTHYaapMNZk-JGiwiiawwU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alix Shor',
    comment: `Scott Pawletzki was very helpful with a design of our system.  He not only explained the advantages of each provider but also went over the disadvantages.  We are moving to a new for us area so have had no experience with the local electricity provider.  Scott was able to provide a picture of what the electric bill would look like along with how the solar system would help mitigate the cost.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLyV2EeA5fUfJJwDWzmOC4eVTwksVPXBJI3yh9oLYTXNbucMQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ruth Ann Mcgarvey',
    comment: `Every conversation we have had with Chad has been informative and he has been able to answer our questions. Chad is also very friendly. If everyone is as knowledgeable and friendly as Chad having our solar panels installed will be a positive experience.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJf_t9BqIGBkUqylBLQFvL9sEjzMcIFpFKoCP5xnaMGLRLB-Q=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patrick Cali',
    comment: `Excellent overall experience. Brian Weaver was the advisor that I worked with. He was very knowledgeable and understood my needs. Answered all questions by providing facts. The process was painless and was able to chose a system that met my needs and finances. Very PROFESSIONAL approach by Brian and much appreciated. Highly recommend anyone looking for a solar system to contact E.nergyPal.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKe0afDlXPG0QSWCXcFZPoDSPj9Jmnvvu_CI3ARL6MUMbHgjA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Melissa Belagardi',
    comment: `We can't say enough positive things about Shaqeel. We had done our due diligence before meeting with him, and there was no comparison. He has made an incredibly daunting process smooth and majorly anxiety-reducing. Knowledgeable, honest, accommodating, no pressure...the list goes on. We have been very happy to be paired up with him and working with EnergyPal thus far in our solar journey! Highly recommend.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV80BvlUNWglCvwOWdzxvlR9Viu3zhVWT769328fKRyOVKadjP_kA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cheryl Gould',
    comment: `Mike Levy could not have been more helpful and attentive to my needs throughout the process. I fully relied on his expertise and experience. He was a delight to work with and I highly recommend him!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL0fHQ7RbUGRGBKBxrznuK1gTe7x1ME6IDm521bezP013oFYA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dave Weakley',
    comment: `Stephanie was very helpful throughout the preliminary design and pricing process. Her efforts went above and beyond which had a huge impact on me. She worked very closely with me on several occasions to be sure my questions were answered fully and she did extra leg work to get the information I needed. Such as contacting my township for information on a ground array to be sure all codes would be met. Stephanie was timely with replies and very patient because of the complexity of my situation.  In the end, I decided that because of my age not to follow through with the purchase at this time. I would certainly recommend the company to anyone thinking of going solar at this time. Stephanie also knew her products and was able to provide multiple finance options. Again thank you Stephanie!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJx7qNvxei63184VBYhztZEXLTFYGonTYQYIr0wJDv_whhaYw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bill Ganz',
    comment: `Shaq at “Solarpal” has been extraordinarily patient and supportive to our needs. As the president of our homeowners association (PGT/HOA) here in California Shaq has absolutely help us navigate this process like an absolute industry expert. His insight to this industry and his ability to provide so much insight and how to take advantage of incentives and inducements to lower the cost and operations well understanding the complexities of these agreements on all sides. So far, we feel very confident that he is the most knowledgeable person and most supportive person we have encountered in the solar installation and integration industry.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjX_fiwXmp0aV1SWWHnRUMB6Y58tQEvVc8sne3pCu99NVkyEPjRa4w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'James Dunstan',
    comment: `I was referred to Alex Nicol of Energy Pals by my son who had worked with him in selecting the solar energy system for his home, and was very pleased with help and advice he had provided.  I was amazed at the time and effort Alex applied in developing several options that met my requirements for minimal utility reliance and whole-house backup capability at prices that were substantially lower than I had been able to find on my own.  I recommend contacting Alex if you are considering a solar energy system for your home.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJt_ZLcltxZSjzt54dpLKckKzKJ5zVceonGvgZEnX4T98soCg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'don pannell',
    comment: `Jesse Agrey from EnergyPal is very professional at what he does. He does an outstanding Job of explaining how the Solar Panels & batteries works in detail an will stop at nothing during his busy day to answer questions if needed Thanks Jesse.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKFernbYKYlbsYH-rYQ5ZtuJV8ErbWY2I6LR7ZhirlRBPYwQA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Stefanie Coleman',
    comment: `Rob is very helpful and very smart.  Heexplains everything very well and made me feel comfortable with this solar agreement.  He is very kind and patient and is taking time to secure that all of my questions are answered.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLeR0dmcGuP2xabEvwTy3T0lxU2IUsQI0jAPvXIs98f8HAfCg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kenny Lunsford',
    comment: `I have been very hesitant to purchase solar due to distrust of how the industry presents itself. We have had companies knocking on our door on Sunday nights after 8 pm. Sales person after sales person, I just did not know who to go with. Finally after suffering through the immense amount of changes with PG&E, I called EnergyPal and spoke with Aidan Gay. This young man explain the process so well and worked to build a trusting relationship all over the phone. Aidan never tried to get pushy or use sales tactics that have been tried on me and my family since the CAMP Fire and the rebuild of our home. Last night I made the decision to pull the trigger and signed the agreement with Aidan by my side we spoke to the lender. I highly recommend calling EnergyPal and if you do ask for Aidan Gay. I promise you can't go wrong and you will not feel pressured or hurried. I do not write a lot of reviews but I am happy to write this one. Which ever way you decide to go best wishes, however you really want to give this company a chance.
Kenny Lunsford- Paradise ,Ca.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWgX2svCV8gAj-mAUM09AR5HmJk_7Ev7Bp_XhKj_64XDjfCCY2b=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alysa Schnepf',
    comment: `Simon was a really great rep and answered a lot of questions with ease.  Super easy going and easy to work with.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXxRI1uXrhshgJdNZinpDIGNrpPg49_ediZLWPviBojGS3U__zx=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mike Schmidt',
    comment: `Chris Lee is very knowledgeable and is quick to answer any and all questions`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK77icglOxca6CYzxUaGpxemXWROLx4CJ0JFK4g6gG6feSvrQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Abraham Diaz',
    comment: `Simon has been very helpful in finding the hardware and contractor that would meet my needs. He has bent over backwards to answer my questions and stayed up late to discuss best options. Thanks!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXSVRNw7Zq5xQcRiPSIPC4zEN0R4Tgfj41BmVZ3eDXopJQFnYuV=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Adam Jones',
    comment: `Just had my initial consultation with Matthew Kosydar and it was great!  He was patient with me and answered all of my questions.  He was knowledgeable regarding the different electricity markets and what are appropriate installs for different areas.  Looking forward working with him further.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVsz_BwqyxzrE7LR0dVUc8qHNzdC7d6GxNSRKC6XpgotGGxE1t1=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Nala Harmon',
    comment: `Shaqueel is a fabulous customer service representative specialist with understanding and compassion for his clients needs.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVgeAUVpMTMixd4HvLLoLPNeXGda3gt-uQq8F2T-6p-LZVxMh2J=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Merrie Jo Rodriguez',
    comment: `Not being familiar with Solar, Chad took the time to show me online our home and what panels we would need to generate our energy. Also the raising cost of electricity from local vs savings from Solar.  This is our new future.  Thanks Chad.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJV6wLWJOIA79uRoZOE5wROEtdrW4SXui5161HvvAoKkMGdTQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Lorna Bolosan',
    comment: `It was fantastic and thanks Simon Chen.
Got all my solar energy questions completely answered on my satisfaction.Enjoyed talking to you..
Feel like talking to a family member.
Highly recommended! And I will surely tell all my friends if ever they need solar You’re the men!!!!
Can’t wait to see the outcome.
Thanks again for all the information.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJBIx26dpeVb47poxc9dD-_NixpuaONgJ14y1HutAGBUNqTAZA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Chris',
    comment: `Tyler was so very helpful and patient. I had a great experience even though I chose not to follow through with the plan simply due to my own circumstances. I look forward to working with him again!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjX2_T3B8onLi_p59KYUSrQUSpWQ77IvllNAQSrz-5Ja3ymcLPCu=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christopher Laird',
    comment: `In my quest to move towards solar power for my home Chad (EnergyPal) was extremely helpful in filling in the blanks. He provided excellent answers to dozens of questions I had. In the end, I decided solar power made perfect sense.  My solar power system will supply 101% of  my electrical needs for years to come.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJS4DKa7-mCdRtnR10wPhCQBRG4HSRtKTuTBXlUdhG3LFRAyg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Betty Martin',
    comment: `I am considering the addition of a solar battery to my system and wanted more information.  Chad Smith,  a representative from Energy Pal, was very knowledgeable and provided me with a wealth of information.  He was very patient with the myriad questions I had. In addition, he helped me determine what system I had and what would be compatible with it.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU-JMFe6cxyKS-i0aVD7pH2UIsGkP7m7-V11DohUqHRp7l9Buzy=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alisa Sinclair',
    comment: `Daniel was amazing! He was extremely helpful, transparent, and explained things well. He went above and beyond to show us all of our options! He was always flexible on meeting times based around my schedule and life! I appreciated his approach to customer service and I never once felt pressured by him like I had by previous Solar Salespeople. Although I have decided to wait on purchasing solar, I requested he stay in touch if new programs/options come his way and he has done just that. Moving forward, I will only work with Daniel for my solar needs and he will receive all my referrals! 10/10 stars for him! Thanks Daniel!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJW1FR9_Kg5gtlgiKV3D3Im2hdAv902ExnJuyW5mjqRytt3Mw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'tjmeyers2000',
    comment: `Jesse was more than informative and an excellent guide to make quite an expensive endeavour an easy process. The installation was quick and professional and was completed within 21 days of signing the contract. Thank You Jessie for saving me a lot of money and expediting the process.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK5FfoY9CaUyf7txnz_gMSCLH_JMslfsIZUCkL6X-3BRbh8Qw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joan Tuttle',
    comment: `I'm excited to get my solar panels installed.  Chad Smith was a fountain of information and was most helpful in getting the process started.  I look forward to working with him and the rest of the team.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJb136WaeDVk_dFF10ySkQbysv3H5ewNTC7MyRKL4OQEVLeFQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Phil Stein',
    comment: `With minimal knowledge of the mechanics or logistics involved in converting our new home to solar power, we feel fortunate to have found Energy Advisor, Matthew Kosydar of EnergyPal here in the ether. He is a pleasure to communicate with and provided us with the detailed, comprehensive technical information we needed to ask knowledgeable questions and make informed choices. Though the math ended up not working for us because of age and current finances, we came away from our experience as much more educated consumers. With an abiding interest in a sustainable planet, we would enthusiastically encourage anyone with similar interests to talk to Matthew.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKIZIRq3LI0OIqAoZrYprVJbOYshGN7bUB2enqUzlQ_gl0uJg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alberto Millan',
    comment: `Gordan Dumka was very helpful and knowledgeable through my solar process. Any questions I had he was able to answer. We were in constant communication and couldn’t ask for a better service representative to help me through the solar process. Will definitely recommend to my family and friends! Thank you Gordan!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLopiVx8_sWXKkLIH2d0oHM7chRDmuGvnhrY71QlcuVearRlA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patricia C. Trampler',
    comment: `I wish we could have gone solar. Not enough room. Matthew Kosydar was wonderful he tried everything. Spent a lot of time trying to figure out, it just didn't work. If you have the chance to work with him you will be pleased.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLp5YPbKLgL2QmUEzwak8AK5BEP-1yQo0oMCM0KWgAVBEuPKw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alberto Millan',
    comment: `Gordan Dumka was very helpful and knowledgeable through my solar process. Any questions I had he was able to answer. We were in constant communication and couldn’t ask for a better service representative to help me through the solar process. Will definitely recommend to my family and friends! Thank you Gordan!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLfP0htKK95I61cBVM3NR-xtDfG8i2YTirqkxSUpsd0=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alicia Winter',
    comment: `Tyler was very knowledgeable and answered all of my many, many questions. He didn't pressure me, neither did his helpfulness flag in the face of my unrelenting request for different types of lease scenarios. He was exceedingly helpful in providing accurate and timely information.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjW1z7cqTerju49JB5nyJl_FpTnQet6zigYjUcC7xTzWgS8=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ciaran Traynor',
    comment: `Working with Tyler Schofield made the entire process a lot less stressful. As with many solar companies, things can definitely go wrong that are out of our control (especially dealing with getting city approvals). Tyler was professional, friendly and extremely responsive. I would highly recommend working with Tyler and will be referring any of my contacts in need of solar to his services.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXFe7fxi2h0tRwz2W9XAohJHw5b1U0XuiDYxYEkEBatTu4=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cynthia Lamon',
    comment: `Jake is extremely knowledgeable! Jake at EnergyPal was my second opinion on a quote I got from another outfit. Literally cut the cost of the project in half with the same equipment and capacity. Thank God I called Jake at EnergyPal!!!!.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLbiA9r_cMMu0Pmp0kFcBvK-Yzeu5SHAc6mlexupvdC=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Darrell Mansur',
    comment: `Daniel Fiske made a heroic effort to help me with a request to convert my patio cover into a solar pergola. He came up with a design that would fit using bifacial panels along with two batteries that could provide emergency backup for my home and well pumps. We had several calls and back and forth messages that helped me understand the design and installation plans. Unfortunately, late into this process I discovered that my patio cover was not engineered and permitted to accommodate solar panels. I had to cancel the project. Daniel was very understanding. With his knowledge of this application, I strongly recommend him to other customers who do not want roof-top solar and are starting fresh with a new patio cover, solar pergola design. Thanks, again, Daniel!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL9sOVuTQwU7GEc5o_CvbLPfW5Q67fL5eUSh3zwngM8=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Gerhard Wahl',
    comment: `I have worked with Tyler Schofield on the pre-planning of my future Solar System. He is very responsive, got all concerns  addressed and is up to date on the latest products available, keeping quality and cost a high priority. He also worked with my Grandson, a Engineer for a major cable company, which is producing items for the Solar Industry and up to the latest developments in that field. I can highly recommend working with him.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVArY-IYtel-1meDkU7UweT-j8Fb5KWysT8kdE3qM29Ig=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mariano Lalica',
    comment: `Kevo with Energy Pal is an excellent representative for this company and the solar solutions of the future. He is very knowledgeable and passionate about solar energy.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVocp1aeb2M1Khti1CHxq6VjxQLmH2c9v1FhirBMyKrBJs=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Emma Hofmann',
    comment: `Caleb Siu was awesome to work with regarding my solar project. From purchase to install, Caleb was at every step of the way. He was the project manager from start to finish. He was very responsive to my emails, phone calls, and texts. I would highly recommend Caleb and ESP for your solar projects`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLBCSWUDCFhb2EqQuyUv-eR4HaYe8gNPOQst5GecAJf=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bob Paull',
    comment: `Anton Donets with Energy Pal was an amazing guide for us when we had our solar panels installed. I did liaison work as an officer in the Marine Corps and know how complex such coordination can be. Anton had his hand on the pulse of the project from start to finish. I highly recommend Energy Pal.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXjra2O26COluFVpxTgbr4IeK0ABotH1kk44t9WXqUanQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Stephen Dettle',
    comment: `We had Solar at our old house...but KEVO taught us more in 1/2 hour than anything we ever knew. We are getting bids on our upcoming ADU addition...and these Salesmen are Freaking out,because we're asking questions that Kevo allready told us the answers too....and they can't answer half of them...this guy separates the Knowledgeable from the Posers ! He does the math right in front of you,so we're ALL on the same page.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU7cuTD66GUNPoIub7WKyMuJMV1tQhwj9nmS_6HyS1C4A9G=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cheng Zhu',
    comment: `Matthew did a good job to introduce how solar electric power will be generated from panel. And what's my option for the panels on the roof, explain the cost , credit,  project steps, warranty and followup after the meeting. Thank you for kindness and time!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJgZMHJ0uSO25kDjsvRm2B1f9n2eSZA8wfm3UocgtPZ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'SGSSGS100',
    comment: `I’ve got a solar system on my roof. I was looking to expand the system for my new EV. Alex was super helpful explaining to me the economics of NEM3.0 and helped me arrive at the decision that makes the most sense for me. Moreover, he told me about the electricity rate plans that may be more economical with EV that I wasn’t aware of. Really appreciate his time educating me. Five stars for sure!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKwWGAk2qGKMdjS5Q03MHJF7oXRjx_n380ll4WejCTl=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'VÂN La NGUYỄN',
    comment: `I worked with Simon  He was knowledgeable, accessible and patient. I would recommend anyone seriously considering going solar,   highly recommend working with Simon ,`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVjGBaKxFCdRZlUIUl2EPr5_ETXmHuFfV4j0bSUZnOcIR4B=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Hsueh',
    comment: `Working with Kevo is quite pleasant. He is very knowledgeable on solar power stuff. He is patient, friendly and informative, not pushing for a sale. The solution he recommended to me demonstrates that he has taken into consideration of the client's specific situation. I look forward to seeing a smooth project completion.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJ5L8igAEla0LKLHQ-2Rz-psduY1UEmHpN2TBzcQ3qU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Scott',
    comment: `I worked with Brian Weaver who was very knowledgeable about residential solar and the local industry. Brian was very helpful as he provided me the time I needed to understand all of the specifics I desired to make an informative decision. I recommend Energy Pal for their expertise and for providing a cost effective solution!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocI-YQlEJPQS2L6SZvsjYpSjCGf2LgEvLzM8LQp6l-w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'michael dawley',
    comment: `Took much of Alex's time getting completely educated on solar
panels installation. He was knowledgeable, courteous and
patient. I was totally satisfied with this interaction.   MIKE D
`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLz53fUzvRlkGMlivkk1YbmNwwM2d3rbR4oj-AXrDQM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rosalie Gottfried',
    comment: `I found Dan to be very helpful.  He provided me with a lot of information that allowed me to make a better informed decision regarding my plans.  He was willing to share his knowledge with me and I'm very appreciative of his time and concern.  Thank you, Dan.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLRTpBe5E3QxJvkHnlBonJsEIm-wmWVPdxFj7q75Ygn=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christian Morales',
    comment: `Going Solar can feel like a complicated process, but not with EnergyPal! Mr. Alex Nicol from EnergyPal was extremely knowledgeable and extremely patient with me.  Any and all questions regarding state and federal tax credits, the different solar panels and/or options available were meticulously answered.  I had and have zero doubts about EnergyPal and Alex.  If you are thinking about going Solar for your home Alex Nicol from EnergyPal can give you all the guidance necessary to make a smart decision without any of the cheesy sales pitches or pressure.  He is truly an expert in his craft.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocI6jgVM5UUW9SxIzAMFXmByKH2goihIe-IVofydmYRP=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Andy Wilson',
    comment: `Just spoke with Matthew on my first foray into solar power for my home. Very knowledgeable,  laid out everything, easy to understand, answered all my questions, was a pleasure to converse with. Gave me plenty to digest and I feel confident in  asking the right questions as I go forward. Thanks Matthew, will speak again soon.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKL0mPxxroFDg_dvUhiwxt9g5C6O37Cw3wr1IuLkGpG=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'paul walters',
    comment: `Daniel is extremely knowledgeable of both solar and the different purchase/Lease options. Zero pressure sales, answered all questions, even though im a contractor and homeowner, information is kinda difficult to maneuver through and  Daniel was right there with any information i needed or to explain Solar language. This is the guy to use for the no stress guided tour of Solar and smooth transition into a contract if you choose to do so.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJtl3d4QahF2hcuvmUc6lJfsg0tT4J31TvN_Vttv9MS=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'George Sanguinetti',
    comment: `Shack, Is very knowledgeable, patient, informative, friendly and genial. He is technically savvy as well. He cordially answered all of my questions, of which I had plenty. 👍`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLEIkKbYXBwbTLwkxJxrtf3yN5i8DalHoUcgbb2-3Y2=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joe Henderson',
    comment: `Matthew was great to work with in getting all the details for a potential solar solution.  He covered all the needed material for me and was able to answer all my questions!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL-IL3lYCp6JqXHo_PfhwlRNLIiZXgwN3IBMR3Sjdmb=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joy Byrd',
    comment: `Brian Weaver with EnergyPal contacted me regarding solar energy.  I told him what my situation was and he was very supportive and patient with me because I had difficulty in understanding the technology.  He was very pleasant and offered several options for me to choose from.  I feel that he really helped me gain a better understanding of this technology.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVxwn7SK7Zd40LMrOnucQGJ0dihZ3gjnp00vflP9v2kalI=w120-h120-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'Ronda Pindzola',
    comment: `I have been working with Energy pal to have solar panels installed on my house.
Specifically Dylan is my contact and he found me a very good deal for the panels and microinverters.  He even arranged to have emphase micro inverters installed instead of the Hyperion ones in the initial contract, for the same price. He has been with us every step of the way and has provided a lot of information and advice.
It is beneficial to have a personal contact that you can text to help you through all the hoops, including navigating the lengthy contracts that need to be signed, when getting solar panels.
`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJEozPZAOP4boI4lJ4Ahy65v6OqRG3anS5QtP1ZQ_T1=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jerry Gustavus',
    comment: `Glen from Energy Pal was very professional and out of the other 5 other companies I had contacted and had conversations with Glen had the best plan and best price for my Solar solutions and I would truly recommend him to my neighbors and anyone else interested!!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIA7rs5RXZwZqhZyilelvYZBqJUT0jai-KCFp8Dkqqk=w60-h60-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Gerry Pflugh',
    comment: `I spoke to Brian Weaver today, he was extremely helpful and very knowledgeable about solar power. I had questions about my home but I am also the treasurer of my HOA and we were talking about pricing for over 800 units.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIhyC4166qhq_kw8ieVsQPKqCevGB__S4iJOrALihhI=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rob Timmers',
    comment: `Very thorough and knowledgeable about solar.  Great to work with and no pressure to buy.  Stephanie D. was great to work with and recommend working with her on any future project.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJODegRSd1lqNfyR9Nynto-PDPrG_vGJ331QCthEtCE=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Tom Taatjes',
    comment: `Arjun was very helpful as I explored the possibility of installing solar panels on my house. He is one of the most knowledgeable and helpful of the people I worked with and you will get straight and honest info from him.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIB0weI-jEB27RTcdnz16lHFLQJevRLkVKEAYkudtX2=w60-h60-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'Lynn Dodds',
    comment: `I had a preliminary assessment review and design proposal done. It was done quickly, efficiently, and courteously with no hard-sell techniques. My kind of company.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK3rsHR_vdseyt0Gwlscz0vPttSU_cZsj6Do0qX4rT4=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'A Albanese',
    comment: `I want to start by saying, huge thanks to Simon Chen our solar consultant at EnergyPal who took the time to reach out and inquire on our solar needs. Shout out Simon for taking the time and your help on getting us set up.

Not going to lie, at first we were super skeptical on blindly trusting a company we knew nothing about. However we decided to give them a shot.

We took a chance and I’m very glad we did. Within a matter of days Simon provided a personalized system layout and breakdown of all the information we needed to understand what system best suits our home and needs. His professionalism, attention to detail and knowledge was comforting and above par. Very polite, mindful and patient.

Simon didn’t try to sugarcoat or up sale anything, he was straightforward and took the time to explain every detail to our understanding. He gave us several options and found us a reputable solar provider and installer that has a great reputation and is very experienced. He then told us EnergyPals part in the process and provided step by step instructions or what to expect moving forward. Also reassured us that he would be personally overseeing our project start to finish.

Overall so far it has been a thorough and painless process and we are super pleased with his work and the progress we’ve made.

Thank you Simon and EnergyPal. Definitely thankful we are moving forward with you guys, your service is already proven it’s worth!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVTZkPqtyf0OadiTZedGqSOYQvQq1s8WKJ4ARyWJIkII6M=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'C.J. Speakman',
    comment: `Aidan Gay is about Service Excellence; respectful, courteous, follow through, and follow up. I highly recommend checking with EnergyPal to learn about your options for attaining Solar Energy for your home. CJSpeakman`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWZEkilK9LfMsiZM_9OzJUz2MOjfc-ytZDc-PLbuB8VLms=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jose Navarro',
    comment: `I had an excellent experience working with Simon while exploring solar options. His knowledge and guidance significantly expanded my understanding of solar energy. I appreciate his expertise and would recommend his assistance to others seeking information on solar solutions.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKQhcI4LV8L7NmBtPO8xVSSeWWCZyD_cm4AtxAad3bo=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Sylvester Bryant',
    comment: `Alex with EnergyPal worked deligently on my behalf to address my needs and expectations for a solar system for our home.  I am completely satisfied with the process through EnergyPal and Alex in providing the right solar panel product/system and installation company to achieve the best results at an affordable price.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLn86eZgb08jnkhsl7DDPIVW-WbdZQ_koMjRdWYfB7J=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Michael Mitchell Sr.',
    comment: `Energy Pal was Very helpful with the process of solar power and informing me of its benefits, I recommend their service to all looking for a long range savings!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVlAG9clQXXes6hoCI49rsmeA3ryV2-mQJ5T0ANI4d9Fx5v=w60-h60-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'henil jain',
    comment: `Glen is knowledgeable and professional. He answered all my questions and was transparent about the expectations of the project. We are still evaluating if solar is right for us but I appreciate Glen's information, it will help us in making the decision`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV1Q0PAi7ksEK-E9D0dFz2h_rCKDjVT9niMzvHRYre5SA=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Larissa',
    comment: `I had a wonderful conversation with Kevo, energy advisor. He very thoroughly answered all my questions about solar and got back to me with a detailed plan and precise cost metrics for my specific house, taking into consideration my current energy consumption, the layout of my roof, monthly averages and so forth so I could make an informed decision about solar moving forward. This was very appreciated.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWNjD73dc3CbdKrwJfrKOXphU5RjKusXq98ywo79LdHjQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ginny Sher',
    comment: `Daniel Fiske was very helpful and although things didn't work out for us due to our style of roofing and local utility company, he was honest in explaining the details and let us know the pros and cons of our situation. I wouldn't hesitate to call him for help with our solar needs.  He was pleasant and professional.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVxUaUqobUal9OS6YBPDsjTqXVzxcxx7PIps47siSMgCQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Harry Jabourian',
    comment: `I had negative thoughts and ideas about solar that does not do anything to save me financially until I received a phone call from Mr. Mike and we stayed on the phone for few hours until he made sure that I understood everything  about how the solar system works compared with other companies. He made clear the differences. In addition he mentioned sun power solar company rating is 4.9.out of 5
He reviewed my utility bill with me and showed that i will be saving about 63%
On my utility bill if I had solar
Mike the representative is very passionate about solar system and  he is trying to  make my life easier by saving me financially. My payment for the lease of the solar is going to be minimal I will recommend every one should go solar
Thanks for all you do.
Greatly appreciated.
`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLAjy3ABbH1jf6BaGFXoyyE_vwGBiWdWjUrcAmJN-yq=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Therrien',
    comment: `Spencer Strandholt was the outstanding rep who walked through the entire contract process. He was honest, shared some excllent EXCEL formulas with me and as could be a design engineer if he chose to. He shows great empathy for his customers. I was lucky to have him`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKZ5qrZk00FzoaVR0ZzX7WNOABvpHrWPIqgvHA6O5D8=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Reb Botelho',
    comment: `Thinking about Solar? Do the assessment with Kevo Terzian from EnergyPal.
This gentleman gave me a short but valuable presentation. Answered all my questions, gave plenty of time to
think about it. Did NOT call me 10
X day. These solar sales people are
savages.They will call you 10 times a day. NOT Kevo and EnergyPal. The concept and product sells it self. Kevo did an outstsnding job letting me his availability (which is all the time) and explaining solar benefits and gaps if any. Do yourself a favor and call Kevo. He is smart, and professional. Come on we all think about solar especially when you get you PGE bill. Check it out with Kevo from EnergyPal.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWoUkq4i8WWc-IDY1N433V5lYzgnO88MRu5eC6HFVnYDQ=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Steven Kradjian',
    comment: `Glen is exceptionally well informed about solar technology and the solar industry. He is an engineer and sales rep. Took time over two scheduled calls to explain. I respect and appreciate his style and approach.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIgHZ2c777dE4nZ6J2FEZI9OJNOpDWezxq9lR3vzXIk=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bob Chase',
    comment: `Simon was very easy to work with. Answered all questions and concerns in a timely manner.  Thank you. Would recommend`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKn_598kiCTULSpJB_I0TzV4WWehgQvKuVBH2XN7SNS=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ellie Fierro',
    comment: `I began the process with uncertainty but quickly got all my questions answered. I got clear and understandable information that led me to a positive a decision. Thank you Amanda!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKQAL4tL1UXO5V0V9HvD32aZ_ZUK98BOCsEH66SPPy2=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Nastasia S',
    comment: `I want to commend Amanda Swan for her exceptional customer service skills.Her ability to actively listen, understand my concerns, and provide thoughtful solutions truly stood out. Amanda demonstrated a rare combination of empathy and efficiency, making my entire experience remarkably positive. Her dedication to customer satisfaction is evident, and I appreciate the outstanding service she provided.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWHESC5wubZDajC3xB1Lh_At8Bnx_U8ZBv8fNf9R6U3qwk=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: `Carmela D'Amico`,
    comment: `I recently spoke with Bryce Hayes about adding solar panels to our house.  He was fantastic, well informed and obviously an expert in his field.  He took the time to educate me on solar panels and even explained my electric bill. He patiently explained the process and offered a couple suggestions.  Even though solar panels might not be very effective on our house he still provided helpful and honest solutions.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL5cUcaCJI0V3m0YF5JI_vWJFYdX_3bPJPLGJAM_I-N=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Darlene Nichols',
    comment: `Simon customer care , intellect and professionalism in helping me decide on a system was beyond excellent .He explained everything in great detailed to make sure I understood the benefit of solar. Initially,  I was hesitant because I was previously told I had to remove my palm trees.  And that's not true! If you are lucky to engage with Simon you won't be disappointed . He will ensure all of your Solar needs are met.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK_DwG_2iipXVHq4_GTqEcsq8PtqmKKTEFUi18HDTbi=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christina Lafont',
    comment: `I was really pleased with the response time of Energy Pal and specifically  the patience that Caleb Siu had with explaining things to me about solar panels and just as important how technology has improved. He did an excellent job explaining the importance of the panels being current with technology. Caleb answered my questions  as many times as I asked, very patiently.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKNuNuG4d0UYd7sZozdtJIsKE9D-6PjES0aXgop6g3W=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mansoor Syed',
    comment: `Soroush is a very nice and polite person to talk to. He was on my side and explained me all the options that he offered and what best suited me. He was not pushy or rushing through the products. He did a great amount of research before he spoke to me with the best options of solar for my home. I thank him and appreciate all his help and recommend him to everyone who is looking into solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLojHxTz-jgbaI0K-JDEdbmNs6Lu_ZfuyBVSMyYKnfo=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cary',
    comment: `Jedidiah was an absolute pleasure to work with. I felt like he constantly had my best interests in mind and was able to work through a variety options with us.  He was very patient and answered all questions that we had and had a wealth of knowledge.  I highly recommend working with Jedidiah and avoid the unnecessary high pressure sales tactics of working with individual solar companies, Jedidiah does this for you and can negotiate the best rates?`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL1zcMuesnTiqzpYaP7ofKq7SHLM07_M-6INoRAX49CpWs=w60-h60-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Tommy ONeill',
    comment: `I worked with Alex Nacinovich, Energy Advisor, over the course of several weeks to not only design a system that would meet my family's needs for decades, but took many deep-dives to better understand the many aspects of the project including system technical design, cost, schedule, performance, risks, warranties, and incentives. Alex was extremely professional, knowledgeable and courteous throughout the entire process and wish every business experiences was the same!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjX2SYSTlqEBVfwde7JPIZeZd2wSajtLYD7QEPm3MswLbDQa=w60-h60-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Adam Rogers',
    comment: `Mike Levy was and still is our go to guy when it comes to asking questions about solar. He is very patient and truly knowledgeable.We talked to a lot of solar providers. He gave the best deal out of all the other companies. Even they said they would take the deal. Thanks again Mike!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIlKIkvRUZ_nV5tC-j6ibkJ86M4CNWPSvClPQY2FjCe=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Staci Taylor',
    comment: `Arjun was kind, patient and very knowledgeable about all aspects of going solar. He prepared well for our meeting, and brought precise info about my specific project needs so nothing was abstract or obscure. I recommend working with Arjun at EnergyPal if you’re thinking of going solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU15xrTUgMuUR8xtMEW7ZNL9KbDc4HHk0_1iUriiZYEjP8=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Chuck Middleton',
    comment: `I’m just starting the process but I already love EnergyPal. They have the best process and prices that I have found. Soroush is great to work with. He’s an excellent communicator and problem solver.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKbTihLlkOqrh2iA_YjmWrAkPJfOWIcVYqzE_EF4qjL=w60-h60-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Nancee Ellsworth',
    comment: `Simon made this entire experience a breeze. He was friendly and easy to work with. He answered all of my questions clearly and was very patient with me. I never felt rushed or pushed in any way. The best part was that Simon was able to do everything online and on my schedule. EnergyPal seemed to have the best equipment and service and different options from which to choose. I am convinced that this was the best way to go fro me.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjW7Svwj0w6VPj5Uv5djDE7F3iQ_MqMKHljr_9LAUkncpQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Raymond “Ray” Smigelski',
    comment: `The representative I talked with named Arjun Manohar was fantastic... very professional, courteous, respectful, knowledgeable & truly worked at a solar solution to maximize our home's power needs.  Thank you Arjun!!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUrC877CvkuzPZv14cG4rN6HZeq4XVxeYp6CkDnHdylxrlL=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Antaya',
    comment: `After researching and meeting solar installers for weeks, we were contacted by Chad at Energy Pal. Chad was straightforward, made sense of this dizzying field filled with so many companies, and directed us to a high quality company. After researching his recommendations, we confirmed they were spot on and went with SunPower. The rate we were able to receive by going through EnergyPal turned out to be the lowest of all! Chad was polite, thorough, knowledgable and easy to work with. Recommend without reservation.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL4EoK_yXshqmMuSj6fvVCi-cVXvLW4MK0iY8hradOe=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jeanetta Brown',
    comment: `I contacted EnergyPal and got connected with Dylan. He was very thorough, detail oriented, and polite. Dylan was very patient and answered all of my questions! He made me feel confident and comfortable with getting solar panels for my home.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLd1Q6eDFbVs6nUCCbz1dmVkYawum5RX9gUYCwbQWvH=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patricia DeCosta',
    comment: `Spencer was extremely helpful and patient.  I did not know much about solar  panels and he walked me through the process until I understood and felt comfortable making a decision.  He helped me understand all of the quotes I received and never got upset when I asked the same questions repeatedly!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLznuBM3z8KWByC_StAinBjTE1ZDnQFJbb80Z11xQ7Z=w120-h120-p-rp-mo-br100s',
    type: 'google',
  },
  {
    name: 'Matt Downham',
    comment: `Andrew Bardauskas at EnergyPal is the reason I decided to go Solar. He took his time in explaining every detail of how the process works, what my options were, and what factors I should consider before making any decisions. His ability to make things simple was the reason I felt confident making this decision. I cannot say enough good things about his service and his willingness to take the time to make sure you understand everything. On top of that, he was able to get me a lease at an amazing price that that was nowhere close to the quotes I received from other vendors. I highly recommend speaking to him if you are considering going Solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUqNCLKLaoIP2FuixUkGVgD7vTai449jdsI-qK-2l645mg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Brian Marchand',
    comment: `Caleb has provided me with two projects over the past 2 years. The first project was a success and due to changing our heating system a year ago we are now looking at a second system to offset our electric usage. Caleb is very knowledgeable and has been able to provide everything I have needed to complete my decisions.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocImu0hk2semgxPNoMQSbzrv97vrkFd4bjOnzVZgzkGz=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Greg Knittel',
    comment: `Simon was great. Recommend him highly. Excellent knowledge and helped out quite a lot with my energy needs - friendly - helped me realize I did not actually need solar - he is not pushy and wants to make sure you don't get some expensive solar panels - if it is not what helps you`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUISUOZBVmJ6U-8P-NYdtT5PcUnBJ3VSATfiqbwJlg2ues=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Linda Jarratt',
    comment: `I am pleased with process of adding solar to my house. Simon was able to explain the saving, service and process. I would recommend EnergyPal and Simon expressly, for anyone who is thinking about adding solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUkgV0RQ1x9QVRKwCC2ai-tt1Q4M-qWi1d_oPK3SX5mB4M=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Eric Fine',
    comment: `Caleb was very kind and understanding in his approach to speaking with my wife and I. He clearly explained the different solar panel plans to us and how the system is set up. We appreciate the time he spent with us on the phone for it was very informative.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWW8Mbsm1UBFMrwSdlSYql1P7QygP_tbeiu1QN_Gm665AM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Linda Hoffdahl',
    comment: `I was looking for a solar program and was connected to Aidan Gay.  Aidan is very upbeat, professional, eager to help, and has the best listening skills I have encountered in a while.  Aidan not only listened, he worked timelessly on addressing every item I thought I wanted, he addressed every question I had, he looked into several different scenarios to assist me in the best possible way for me.  Aidan is a very reliable and honest person, and I appreciate him and EnergyPal and will definitely refer Aidan and EnergyPal to any of my friends.  Thank you Aidan.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocISL_wD2NmHk3sLhReZiZhSs6Xu4MqK-M_S56JsQfiC=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Otilio Ramos',
    comment: `Knowledgeable, professional and timely courteous leading edge information was the most productive use of my time to help us make the best decision.  Invaluable information that I would not otherwise have found even with the best of internet access and research.  Thank you!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocILu0PBH9EPDmK2A3b-IQFKpjCmj6cGmMtXDgXfN8y3=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Piccolomini',
    comment: `Bret was an amazing help and always thoughtful, and he continues to be a valuable asset as we progress through the process.  Very highly recommend him and his team.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocKIPsEq5bjUTt9r-KMI-v-NiVmMWO9_JnLvHmWNh9NP=w120-h120-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'Harry Barber',
    comment: `Matt was extremely knowledgeable.  He handled the entire process seamlessly and answered all of my questions in succinct, clean language.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJZo3Ew0h7GEKyyKj4mzP_UHixFG-eNBjK9UwniSVaf=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Simone Young',
    comment: `Stephanie was excellent. Informative, professional, courteous, and not pushy.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIDSExD3uSHdg0A5zhGFPYdN7ATdgqGIYPg-qk2VVlL=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Terry Kristek',
    comment: `Alejandro answered all my questions was very friendly and knowledgable.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJ0uhMt-U1NtgpBAVexkTjCk73oE1yCAd8wKy-fQSbl=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Akers',
    comment: `My wife and I had been researching solar companies with little success.  We contacted Energy Pal and spoke with Spencer.  He used our information to generate a system proposal with several purchase options.  We decided to purchase the system and the engineering study and installation were scheduled.  All of this was done without any in person visits.  Easy and fast.  The installation was flawless and we now enjoy no bills from our local power company.  Energy Pal is the only company I would recommend for a solar power solution.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocL5-cGmyRDJXljehileH1112bk_s5C3xylCaCA_MIQp=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Carol Cole',
    comment: `My experience was wonderful Anton Donets and Kinson Tam were very informative and every question I had was answered. They both made me feel very confident of my decision. The system is up and running perfectly. The installers were very neat and efficient. And extremely polite. And they had it installed in one day.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVVwetHOo118H0SRPtHG4abR_NfQqOewK_4XqEyZaia=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kenneth OHara',
    comment: `I very much appreciated the advice EnergyPal offered as I decided between several different solar project proposals from multiple companies.  Discussions with the EnergyPal representative gave me insight into the potential upsides and downsides presented by each plan.  It was great to have the perspective from someone with years of experience and detailed knowledge of the solar panel industry.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIOHDN5hUCGzjERJmj4XZFnckkOh5BqfYWDZduWAoFn=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Douglas Palmer',
    comment: `The associate dealing with my account (David Perry) has been great to work with and has taken care of almost all communications with the installer. Quick responses, accurate information, and a good attitude. What more could you ask for?`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVPzaUIDjZnZ5RxpZ5HsrxKCftEyjoMwB0RpYCLxUrh9DUa=w120-h120-p-rp-mo-ba2-br100',
    type: 'google',
  },
  {
    name: 'Rodman Gibbs',
    comment: `Bret from Energy Pal provided us with excellent service during our recent solar system purchase. Even when we just included him with a backup copy of our email to Sunnova he checked with them to ensure they acted in our best interest. His representation for us made the endeavor easy. Sunnova was responsive but Bret’s personalized concern for us made a huge difference.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXEXJiPqRan6c9gg-0FuDL9WeG9ODXIpFAr4U9BXNfcNas=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Darcie Vafidis',
    comment: `Simon Chen at EnergyPal has been very helpful and patient throughout our decision-making process to go solar. He’s been very reliable with following up on how the project is moving forward. I highly recommend Simon and EnergyPal to anyone interested in solar. We spoke with two other very well-known companies who weren’t nearly as helpful or willing to listen to what we wanted versus what they wanted to sell us.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIvm_3kt7jcJz4vcClI57TkeTcfnQInqHhlZ8yt-8jF=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Lake Worth',
    comment: `For me, EnergyPal is Cale. . He worked diligently with me to design a good system, meeting our needs at a great price. He was patient, and professional. I would recommend EnergyPal to anyone looking for a Solar system at the best price available.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocK59LQ68MeFR1laDhp2kX4LUC3giIcCH6h09P5RBd1B=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'James McMillan',
    comment: `From the first contact with Brett we found him to be very professional and knowledgeable on the solar system that we purchased. He worked very closely with us and answered all of our questions. He went above and beyond to help us understand how the system works. We would highly recommend Brett for any of your solar needs.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocI79vIPRl2NcNCYxpg2MP0EY2K9xodmNyAOoyK4tN0P=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Donald Barclay',
    comment: `A very good experience. No hard sell at all. The representative I worked for is friendly and knowledgable. I already had solar with one company, but with Energy Pal I was able to work with a different provider to add more solar and a house battery at a better rate than I would have got if I had gone with my existing provider. I like that my monthly payment will stay at the same rate for the duration of the contract.

Having a house battery is great when there is a blackout. We've had the power go out a couple of times, and the house battery kicked in so fast that I didn't have to reset the clock on the microwave. The one thing to understand is that whole-house air conditioning systems draw too much power to run on a house battery. Not a deal breaker, just a fact of life.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUG5EVGdiAomwzqzy6O4Y9BeHXHsaryaasdW-qySaHMgQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christopher Guido',
    comment: `Had an excellent time working with Nathan at EnergyPal.  He helped me navigate the process just in time to get set up with NEM2.0 in California which was a challenging and busy time to get solar installed.  All work was completed for both my project and another individual I referred in a timely manner (especially considering the mad rush at the time of application to get onto NEM2.0).  I would highly recommend reaching out to EneryPal if you are considering solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLZExxeuRJ5ECzIdETHsZ3s6RQa6yJxPj-zvsCc22k1=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rodney Purcell',
    comment: `I want to thank Bret for his. Excellent service.  I really felt he had my interest in mind and was very professional and extremely knowledgeable.  Because of him and the confidence I had about his honesty I purchased a solar system.  I live in a very warm part of the country where energy cost per month have skyrocketed.  I have gotten two bills from the energy company total 40.00 my neighbor are paying well over 400.00 per month.  Thank You Bret I went from a sceptic of solar to a 100 percent believer. On a fixed income I saved a few thousand.  Thank you Bret !!!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIcNLkcVsr9IprQcBXIG3mKXNj5T2x9w0r1N8cCmGWo=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rachid essakhi',
    comment: `Brett is one of the best in my list of customer support! He's been so patient, professional, and knowledgeable. I have seen few similar offers from other companies, but I did choose your company because of Brett's great customer service. He never lost his temper, and patiently answered my repeated questions and made sure i understand the process. I will definitely recommend you to anyone as long as you have representatives at his skills.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU_c9znOKH2B3_4cT43H2AyhPz0pvBTlAswIFAsAQUy6q8=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Teresa Stoner',
    comment: `EnergyPal has been so great to deal with. They communicate with us every step of the way. Kevo is awesome, thoughtful and extremely helpful. I would recommend them to anyone.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjXB7YXV2SSO9l4oq9vYimNHaqd_59CGnZM_3JvVQx07DXk=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Zach Curry',
    comment: `I have been looking into solar for a few years. I have probably done a dozen solar quotes. Keeping up with the pricing and tax credits. Seeing when I will be able to move forward. I could never get a straight answer for the final cost due to factors like roof repair, etc with other companies. So I have been hesitant to pull the trigger without know the full cost. My sales consultant David Perry was extremely helpful. He was able to get me a solar and roof quote. Now I really have an understanding of what the project is going to cost and can start saving. Looking forward to generating my own solar energy in the near future.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWo0q0W0TYLlGJhBoDnZLWInboZTv3yo9mZAcUoXztoR42n=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Dale Melville',
    comment: `Bret Robertson (with EnergyPal) exceeded my expectations for responsive service, clear communications, and proactive follow-up throughout the purchase process, PGE application, and project completion….and I have high expectations!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVEpmH7ojgBSHE9heFgECAwNkVLriNK9oLOY4Mea8lgbPs=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Robert Flory',
    comment: `Bret is very knowledgeable in regards to solar.  He is a true professional, and it shows in his work ethic.  He was there for me from start to finish; answering every question I had (and I had many), and he wasn't afraid to resolve an issue if and when it came up.  He checked in with me every step of the way to make sure I was satisfied.  I would not hesitate to use his services again in the future.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUPqU1lQVFoFZQhppX59QBKXxJdLEdG5R6W8eJyZ329jA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Robert C',
    comment: `Jesse has been fantastic to work with! He is extremely knowledgeable, patient and assisted me through the process the whole way through! I would definitely recommend going with him if you want to get a solar power system installed! Quite frankly, there is no other option out there!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLzr97fsLfnPqi5VszanF-XXqAzVdjMrWzfa4IL0zr9=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'kam patel',
    comment: `I have been working with Jesse Agrey over past 6 months, he has true gentlemen I walking me through different options, option which best suits my need. He was very patience and kind with my changing requirement. I will definitely recommend him..`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJ5V1_Oce56TGizO5Isn_OqKDJ85iQqHoJdr_Hugvd-=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jane Anderson',
    comment: `Ali Mazaheri is Awesome! He is endlessly patient and terrific at working the process and dealing with the complexity for the customer. Ali was recommended to us and we referred him to a number of close friends and family members. We are delighted with the results and could not have got here without Ali’s expertise, diligence and calm persistence. Thank you!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocLEBgASisjtDItags9p37Bn8Xogm8vWsdf50OEovQOy=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Michael Thomasma',
    comment: `Even though he was unable to connect me with an installerin my area, he took the time to educate me on what important points to look for. I was very impressed with the customer service I received from Elijah. I would highly recommend them to anyone looking for a great customer experience.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVWiZitrEYg05bfitRMTMkhhB-4mye1aFfMzU1zmDpm0aM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Norm McCarthy',
    comment: `I had an amazing experience working with Mike Levy at EnergyPal . After getting quotes from multiple competitors they had the best package overall and my experience with Mike was by far the best. He was able to offer me prices from some of their installer partners that beat out the direct offers that I had received from those same companies!
He is extremely knowledgeable, patient, and responsive, and I never felt as though he was trying to "sell me." On the other hand, I still felt as though he wanted to do everything to win my business, which is a difficult balance to acheive. Mike is a true professional and a tremendous asset to EnergyPal, and I would highly recommend working with Mike and the EngeryPal team to assist with your solar project.
Sincerely,
Norm M.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV7bRTlk0OAXAEosnaRm510c8vlcNi9KClxEJoYyk7d47g=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Gore',
    comment: `Mike was great. He did everything possible to assure a smooth installation. He helped us find the best solar system to meet our needs. Everyone has been great, they system provides exceeds our expectations`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjV2iJbc2v1e356DFqImoOyKdgen_akbyuxUen4v7XCoCg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Daniel Fuoti',
    comment: `Jesse Agrey is an awesome Energy Advisor! Jesse patiently walked me through all of my options and answered any questions I had to make me comfortable with my final decision. Thank you Jesse!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWU6knc-QTXwVF6zCVqVvuPX148tg8WSJaCn-q2oJGihke0=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Nick Tinio',
    comment: `I'm thrilled to leave a 5-star review for Suniel with Energy Pal! From the start of my solar panel installation to the finish, his dedication was exceptional. Suniel's patience in addressing all my questions made the process stress-free. With his attentive approach and thorough oversight, I couldn't be happier with the outcome. Thank you, Suniel, for making this experience seamless and for going above and beyond! If you're thinking about solar panels installed, I highly recommend Suniel Dardi with Energy Pal. His expertise and service is top-notch. Go green and save on energy bills!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocJUzp7dAV-tHKZQbRSCHKy419AjnJ6molbc_m6v4S9i=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Lisa Verchereau',
    comment: `Bret has made going Solar easy so far.  He did his part getting all the numbers to work and finding the right installer for my project.  I will write more when the Solar is up and running.  It is a good feeling to know I am going to reduce my carbon footprint.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVISMEHA4vtDXMbRn4l0Ds1Zt-coaRFTv4Eh9pj-VWdLw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Garrett Ridge',
    comment: `Easy scheduling and meeting setup with screenshare. Jesse Agrey was very informative, explaining the specifics of net-metering and panel configuration. They shared shade models of my roof and showed where to place panels for maximum energy production. Gave me pricing from multiple installers and was great to talk with. If you are looking to go solar, I would definitely recommend EnergyPal`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocI5k7nqsezNC0cOi--RNccBoGBo1H2wctk0fSEi0xCr=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Virginia Miller',
    comment: `Jesse Agrey is knowledgeable and very helpful. Because we have no south facing roofs, we’re not sure how to proceed, but so far Energy Pal has exceeded expectations!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjW0HrhZ2eq91KV8c01xN8Kth6ZCr3oukakhzufUmrnBzw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ehab Zahriyeh',
    comment: `Spoke with an EnergyPal rep (Guy McVey) a few times. Out of all of the competitors, he was the one who explained the process, and more importantly, the financials around solar.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWyKMOoz2QdGo6d8YxMY1GQNj6zyiCZYcCyuTpMyTO0amo=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Janet Keller',
    comment: `Working with Energy Pal has been the best thing I could do for developing solar for my home. Lior was my agent and he had detailed information to respond to all my questions. He referred me to several companies he thought could support what I needed and he helped me choose among them. He was knowledgeable about the state policies, SCE developments and the technology itself. He made the process of getting into a completely new feature of my home understandable and actually pleasant and exciting. He has promised a long term relationship throughout the project and I will hold him to that and post again as we move ahead. So now 5 months later my project is complete and working perfectly. I am generating way more energy than I need right now. Lior took me through the final phases and will be available as time goes by. I am set  and Energy Pal made it all possible!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUgHrDyGT-2HITOuUSRUFKUr2gWZt27Qsfh3U286A9WUVY=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ketan Shah',
    comment: `Had an excellent experience with Zeyad Morsy. He was very professional and took the time to listen to me to and spent the time to look at several options I had quotes  from many companies. He beat the price on any quotes I brought to him. Very knowledgeable and would happily use them on my next installation. Excellent customer service and very personable. No sales pressure, had several options and prices to choose from. With only a few days left, he made sure that I met the NEW2.0 program deadline.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/ACg8ocIQY6ktwycS1hgKFiNWzOb-FNh1Jgz_xTPSnxyKUaXU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Deepika Chaudhary',
    comment: `They have a wonderful team of people who helps you understand the whole process, gives you the best options available and guide you at every step of the process. I had a great experience working with Anton Donets, he is very knowledgeable and helpful and is available for you to answer any queries that you may have.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUw15L4yZ1jwlDjT8Q_fAVaVZ_ediMDkmmIougtq1m83N4=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'MADHAV NENE',
    comment: `Anton-adonets did an excellent job of explaining the benefits of solar.  In our case we did not have financial benefit in switching to Solar, however information Anton provided was excellent to understand our status.  Thanks for his expertise and enthusiasm in communication.  Good luck to him!!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVWxX1O4JJKRLoQrmAh_OksqCE4Bgrse0hhBX9F2XbxLw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mohammad Ali',
    comment: `I recently had the pleasure of working with Simon Chen, a sales consultant at Energy Pal, to install a solar system on my home. Simon was extremely helpful and knowledgeable, and he made the entire process incredibly easy. I knew very little about solar energy before I started working with Simon, but he took the time to explain everything to me in detail. He answered all of my questions patiently and thoroughly, and he helped me to choose the right solar system for my needs. Simon was also very helpful with the solar energy and incentives process. He helped me to understand all of the different incentives that were available to me, and he helped me to apply for them. I highly recommend Energy Pal and Simon Chen to anyone who is considering installing a solar system. Simon is a true professional, and he is committed to helping his customers get the best possible solar experience.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWai-x3lRCAIO7mdQgzNNUIaPHX6uWb5Zbt5r73A7sv51X7=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Todd Benton',
    comment: `Kyle Warsimage at EnergyPal has been a pleasure to work with from start to finish. He has been super responsive whenever I had a question or issue. We got a new EV which is why we wanted to add on to our existing solar. And even under NEM 3 new rules we are still going to save a lot of money. Let him show you what the numbers look like for you and if it works out better for you, go for it.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWx31Gt17PXp-unn7E-tplwvUCSrOUTTTZdqtnXC43MjMs=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Almosta Ranch',
    comment: `It has been a great experience working with Mike Levy of EnergyPal. All of my questions have been answered, there hasn't been any feeling of pressure or rush to sign. They are very thorough and have a plan in place and a go to person for everything. Mike Levy has been a delight to work with, I highly recommend him if you are thinking of buying or leasing solar. I leased my solar and I am ready to say goodbye to my skyrocketing electric bills!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjWyUempEQvR1hiDQEwPKA15VsvS59nfC2it5TAoFv3_Ag=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Juan Fabregas',
    comment: `I want to leave this recommendation because the support and treatment I received from Neil were truly outstanding. He was very professional, friendly, and warm. His effort and interest in our project were evident!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjU1fG3CQnvSYYioJoK_OfYOOcD2VsoZ0qcNdO8rIAnwLCc=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Justus George',
    comment: `Caleb was a excellent reviewer of the product and details and the first company to give me documentation of all the companies I spoke with. The others sent the salesman and described things and then left their business cars. Felt better afterwards.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVFld5CV5Y1J3q2bs39n_x81ezTpuZF2Pg6mJmId-29CCX9=w120-h120-p-rp-mo-ba4-br100',
    type: 'google',
  },
  {
    name: 'Kamal Mani',
    comment: `EnergyPal did an excellent job explaining the cost and technical details to consider solar for your house. Amanda answered all my questions clearly and helped me understand the nuances. Highly recommend them for solar needs.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVkCIz32cQZ_BPFaBECbfZE90CFqPOuA6d41dCb7aGLO4M=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Daniel Marshall',
    comment: `My experience with Titan Solar/EnergyPal was better than I expected. Professional and courteous interactions beginning with the sales personnel to the installation crew. Titan Solar/EnergyPal informed me, walked me through every step of the process, and kept me updated on all modifications. The installation team was more than professional and courteous, they took pride in their work and in customer satisfaction by explaining the next steps in the process and walking me through the operations of the solar system. I highly recommend this company to anyone for their solar installation.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjVWtyFlEZsqcdww7GlXPQQ9Fnrpnsuj60q6dYdLXjoYFNs=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Hans Verbeten',
    comment: `Elijah is an excellent solar consultant to work with. He came in with estimate about 50% under the first solar consultant I worked with. Elijah started off with an honest assessment of whether I would actually save any money given my already low rates. I really appreciated his honest and knowledgeable review of my particular situation. I highly recommend working with Elijah Hassan.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ALV-UjUqRY4LVPeIxdS15EJ9A5L8L1E0_cOBqe6myf2fIqZ4uCQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'David Oberan',
    comment:
      'Had an excellent experience with Kevo. He was very professional and took the time to listen to me to and spent the time to look at several options I had from many companies. He beat the price on any quotes I brought to him. Very knowledgeable and would happily use them on my next installation. Excellent customer service and very personable. Zero pressure sales and had several options and prices to choose from.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcMG-wX-yWGwVICDzVRhXVgYzSrRqnzJxfKcmNyUwvk=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Parag Garg',
    comment:
      'Worked with Dylan Wiederspohn through all the phases of the project: initial assessment to system deployment. Found him to be a very knowledgeable and helpful person. With only a few days left, he made sure that I met the NEW2.0 program deadline. All throughout he made sure that I was updated with the status and the next steps. I am already recommending him to my friends and family.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtd5C-H7XRIozNpV9F3r1raEiscklJiQFHcLs0eQLBpZ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Seamus Conlin',
    comment:
      'Lincoln was fantastic to work with. He was very knowledgeable and worked with me to find the best value for our project. If I ever had any questions he responded immediately and he put everything in easy to understand terms and perspective. I highly recommend working with him, you will be amazed and pleased with his work!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteyCUIndK36rEmaxb-i_VstN3GjYPTRfv4b9wqFie4w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Daniel Ashton',
    comment:
      'Caleb was great. He adjusted the initial quote several times as we discussed what I was looking for to suit my situation and gave good recommendations on battery options for me to research and inform my decision.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfVG1_kVpZVcfQhRCH4nydNFUND310FwSdKvcG4a0rE=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Valerie Pacino',
    comment:
      'Great experience with EnergyPal. Couldn’t speak highly enough of Suniel and his approach to customer service. Looking forward to our solar-powered home far into the future.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSR3Jx3gNjM53ZThCa1eEjeo-fkQ9IMZwErxIF98-3NzLE=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Chet Manczak',
    comment:
      'Guy has been a huge factor in - and excellent teacher during my solar energy journey. Absolutely outstanding pairing of stellar customer service with passion for clean solar energy. I look forward to my new system installation, clean power generation, and of course reduced reliance on fossil fuel power. Lower electricity bills will be great as well!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMS7fZwUSGv9FSGP9QHCotHJoXnuIwZwv0l4oD4iMLnv9Q=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bateau Ivre',
    comment:
      'In the current crowded Solar sales guys,  if you had ONE contact to chose to talk about Solar options, please reach out to Mathieu Dumas. Extremely knowledgeable, courteous, working with you the best options, not counting his hours and delivering very good advice. A TOP advisor - coming from a 30+ year Sales Exec. Best, Patrice',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcs17cdF0K3gxWkJLMiuNif827_ZaH-8fox7szbkmDZ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dale Evilsizer',
    comment:
      'First time solar project. I got 3 quotes and Kevo was helpful beyond my expectation and got the best deal for our family. Worked hard and long hours to get the what we needed. I look forward to a long relationship for future projects.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtdHQ9YKEQak7NXmCVnkCQXgwNOrb8lnRozu2bEU0bBm=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'andrew schmitz',
    comment:
      'Mike Levy knows how to listen, and he was extremely thorough and knowledgeable. My wife and I were extremely satisfied with his assistance as we talked through all the complex issues.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtd51DcCC62lSAIsNpqbdJiEDb7f_-X6eLz9zemt7DDPpg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jaclyn Updegrove',
    comment:
      'Angie was extremely helpful and knowledgeable.  She provided great feedback and options for our home.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMTfpNRL1gvhm_dXg2Kl8Uaa3wK-AScgPGtLA-epoIzfpuU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'David Archer',
    comment:
      'So far the sales and purchase process has gone very smoothly; Alireza and Ben clearly explained the various programs to choose from, the pricing, and the installation process. I have dealt previously with SunPower and they are the most professional company you will find out there. I will follow up with my next review after installation.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfZdwdRpvf-x2W58_uCm3Kbgfqo20lP_x88FqYFa2Bx=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cheng Chuah',
    comment: `What a refreshing experience it was to have Suneil Dardi as a solar consultant for my installation project! Unlike many other consultants, Suneil took his time to answer every question - he was patient, never making me feel the pressure to go solar. He really exemplified the idea that going "solar sells itself," like he was there only to facilitate it! Suneil was there more to help me understand the principles of getting solar energy and the practical (and financial) aspects of solar installation, especially at this time with the offer of the battery. Suneil was the consultant who made it clear and easy for me to commit when I've been looking into solar installation since before Covid! Anyone who's still on the fence about going solar should consult  with Suneil Dardi. He can help you see that it's a no-brainer!`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQ0-CrWOlspgNtPKcYL5ms_CXB19BP-qv_88wJjBz3Pdw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patrick Crews',
    comment:
      'I have been researching solar for over 2 months and have talked to numerous companies and while they all had good and not so good qualities I can without reservation state that Nooraz was the best and most thorough of all the representatives I’ve encountered. I highly recommend Nooraz and Energy Pal for your solar needs',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQ4KrNTfibDeQUlUNyhpCXjDFS5DNU_8ROZNJxnT-ESw0M=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jade Larsen-willis',
    comment:
      'Kevo was very knowledgeable and informative. Answered any and all questions I had in regard to the process from start to finish.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcNqyhrOFLTt1NtfKxFvsoSfbsX1VUf-6ynsOgYbUaY=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'scott mitchell',
    comment:
      'Energy Pal was very easy to work with. Chris was friendly, knowledgeable and extremely helpful in our decision to use Energy Pal for our solar installation.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtf-3MAzDSsy2X_nEOKkfrk-jfzN3-8sqtej9i4qby0=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alfredo A',
    comment: `My EnergyPal consultant Caleb was fantastic! He is very knowledgable, answered all my quedtions and was able build mutiple quotes based on a number of possible scenarios based on my family's current amd future needs.`,
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtdDIfYMXH7qTI-p9AIBiwr-rg56FarEK66AONWIlgOt=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Josh Z',
    comment:
      "I've been working with Kevo at EnergyPal to get my solar package and cost to where I wanted it to be. The deal is done and Kevo was a pleasure to work with! If you want the best deal ask for Kevo. Tell him Josh Z sent you!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMScvytMbFkRe5rKNteiKuZSLRla8ax6n7TSRzt6tq-jIA=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Miriam Piñon',
    comment:
      'Caleb was very helpful and patient re: answering my questions. His presentation was clear, informative and engaging. I learned a great deal about solar generally and your services in particular. I hope that I get to work with Caleb. Thanks',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtdcZ3Bg1wOeGsgd28qFbvUVoKzBj6KRpn6QeMEOO5f-=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'PATTI SHIPLEY',
    comment:
      "I appreciate Jake's patience with me while I fumbled around trying to navigate the agreement and my wife's phone. He was very knowledgeable about the questions I had.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtc1AdMNTd1MgY9uNA7VbWwELfVq0lAcTHHbHxecJlA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ambersmelody',
    comment:
      'Kevo was my agent at MyEnergyPal. Kevo was professional, knowledgeable and incredibly helpful. I was deciding whether to purchase or finance solar panels for my home. Kevo took the time to walk me through all of the specifics and also was able to match every competitor. He was patient and thorough (much more than I can say for other agents and companies). I have already shared his contact information with a friend and I’m looking forward to the referral program. I’m glad that he has been with me during the process, it makes me confident in the service that I’ll receive in the future!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMRiLdL1CJgKqTpScjZNzgWSGG1y5Oz5VXOEb1yxf3zWI9A=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Hilary Rak',
    comment:
      'Jake and Lincoln are not only very knowledgeable but personable as well. They are honest and patient. Jake gave me all the time I needed while deciding which company I wanted to go with.  That meant the world to me.  Going solar was an easy choice, but choosing the right company took time.  Thanks EnergyPal for taking such good care of me!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteTBaIgmamEmTccyLgsEVCRqdIVOjDcU6xSIjTNBidZ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Steven Draher',
    comment:
      'Super helpful in explaining all the options and working late around our hours. He lowered our power bill each month.  He knows his stuff. 👍👌🏼',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSp6FGi4rPwm9vszaOtkZnveiw_zc9peRudVKsWD1wg55Y=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Henry Ha',
    comment:
      'Looking for a solar panel company is no easy task. With so many different companies and brands, I didn’t know where to start. When Suniel Dardi from EnergyPal contacted me, I knew this was my calling. He explained to me everything I needed to know about applying for solar and didn’t sway me one way towards a particular company or brand. His opinions were unbiased unlike other solar panel companies who only tell you what they want you to hear. Suniel guided me through the finance and application process from A-Z. When one option didn’t work, he didn’t stop there. He compared other finance and solar companies until it made sense for me. Suniel’s expertise in solar panels and communication skills are next to none and I would definitely recommend him to any one who is trying to dip their feet into solar!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfE-GoIcWb5wHHPRwN0cyjhyptUZApUDRBcZGnrxGd3=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jazzie Jackson',
    comment:
      'The Representative Chris Norseth was very informative, and patient I signed the agreement of my purchase with perfect understanding of my products, warranties, and he made me feel extremely comfortable by extending the ability to correspond with him if I have any confusion of understanding.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQEj9MBAPvkA0_XN4KH01oKP0YELJLhwEIZWFQk0I8CBp2d=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Tammy Smith',
    comment:
      "We haven't gotten the solar panels yet we just signed up for them. But Tyler was a tremendous help to us. He took the time to explain everything that was going to be done and how much we would save. I was doing this for my mother but I really think it's going to be a great and better idea then I expected. Thank you Tyler for all your help.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtckbvFPkfwitrVhmVCredlZ2R8n8rh6L2jiBxVpJBZ-=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Trinh Nguyen',
    comment:
      "Chris Lee has done a great job to present the deal with different options. He explains each option in details clearly and quickly. I'm so impressed of his presentation. His clear explanation has helped me make a decision fitting our financial status.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQFSJ2pd5tQ21QIIXPsRYBjnUOkOWS-VWEaau1IHDNdC08=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Adriana Sherri',
    comment:
      'They are very helpful and explain everything that you need to get the right  solar panels for your home thanks again Matthew',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMS7TIEleoclNoRfSTIMJuubtrviDxHm8bcNo4DP6PAhv1s=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'robert zaczek',
    comment:
      'I spoke to four or five solar energy vendors.  Each of the company representatives were informative and helpful.  However, each had a specific point of view of what they considered my best solar system and financing options.  Of all of the project managers I spoke to, Mike Levy from EnergyPal had the most balanced view since he was representing a number of solar providers and thus could offer his views of a much wider scope of systems and financing.  He was incredibly helpful on the options available and presented me with what I considered the best price and sourcing available to me based on my needs in Connecticut.  I made the choice of relying on Mike at EnergyPal partnered with the specific vendor Elite Solar Pros, a local company in Connecticut, for building my solar system.  I am very happy with my choice.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcIxHtE8Db1ax_OUCtovLxolX0Iw0d5M98vaSzBd1CM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Suzanne Bouffard-Mahon',
    comment:
      'Jesse Agrey has made our solar company research and decision making a extremely less stressful experience than it started to be. We are just at the beginning stages, but I feel comfortable..',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtdZDdRnnzVWlBXZSoqx7NN_uoVDl4WZBqAboihugkIK=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rajkumar Chinnaswamy',
    comment:
      'We got our Solar system installed recently. We went with EnergyPal through a referral from a friend. I have to say the whole experience was just great. Lior from EnergyPal helped us choose the right system for our needs, offered choice of panels from various manufacturers and spent a good amount of time explaining the pros/cons in great detail. Lior never for once posed himself as a Sales person, left the choices to be made entirely to us. He was honest in explaining the reality of the NEM2 mad rush situation and kept us informed all the way. I would gladly recommend EnergyPal to anyone planning to go Solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtd_f7ZghM46scY9K5c2d0_QjSlLpS86uxuzD4KYZg41=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Steffan Ginete',
    comment:
      'My shopping experience with Kyle W of Energypal has been outstanding so far. Kyle is knowledgeable patient and easy going. Had tons of questions about the lease program but Kyle W. answered all of them. We are now in the process of getting solar for my hone.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtd-6WMDhovharZA8edPxeCilffDMae40_kcZXZL5OiO=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Karen Knowles',
    comment:
      'Kevin explained the solar panel process to me thoroughly. I had a lot of questions and he had good, science based answers for all of them. It was my first experience shopping for a solar set up so I was apprehensive about doing it. He made me feel at ease with all the information!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcBKAp1QMoSeotjoodeJsRYlmvVgzTOIPA4IBYF7HuR=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Rios',
    comment:
      "My wife and I recently had the pleasure of working with Mr. Kevo Terzian, an Energy Advisor from Energy Pal, and we cannot express enough how impressed we were with his knowledge and expertise in the field of solar power. From the very beginning of our interaction, Mr. Terzian demonstrated an unparalleled level of professionalism, making the entire process of transitioning to solar power a breeze.  Mr. Terzian took the time to understand our family’s specific energy needs and goals. He patiently listened to our concerns and answered all our questions, providing detailed explanations about the benefits of solar power.  He analyzed our energy consumption patterns, assessed our roof’s potential for solar panel installation, and created a customized solar energy system that is perfectly suited for our requirements. His expertise in selecting the right solar panels, inverters, and even battery storage solutions ensured that we received maximum efficiency and long-term savings.  He also guided us through the paperwork and all that is involved regarding all the necessary permits and utility interconnection processes. Furthermore, Mr. Terzian went above and beyond by providing comprehensive information about available government incentives, tax credits, and financing options. His expertise in navigating these financial aspects was instrumental in making solar power a financially viable choice for us.  We were pleasantly surprised by how much money we could save over the years through reduced electricity bills. Mr. Terzian's expertise and professionalism are truly commendable. If you’re thinking of going solar, look no further than Mr. Kevo Terzian and Energy Pal for an exceptional experience!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMS0O0Oj_qIepBiZVR8gStsDa5HMcW5c6eR3oGZ4iuunatg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joe Proman',
    comment:
      'I can say with absolutely NO reservations that Mr. Mike Levy is an outstanding person. His demeanor is such that I never thought of him as a salesperson but more like a close friend that was trying his best to do what was best for me. I think he is honorable and truthful, having great integrity and caring for his clients. I will recommend him to anyone thinking about solar and as I have had over 200 employees in my former business before retiring, I would hire him in a second if I still had my business. I felt he was on my side the whole way and for that I am truly grateful. Thank you Mike for your kind thoughtful way. It was a pleasure!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcjIliqJvRl2EkgzoLapTWnK62iellPsMNg6mdIqfQM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dave Buckowski',
    comment:
      'Working with  EnergyPal’s Justin Dickinson was fantastic and enjoyable. He is a very skilled technical sales engineer with deep knowledge in the PV industry. Very fast follow up and follow through! He is definitely a real asset to the company.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcT0LW-q0jDRKmjrivnkWAg_lFOfXXFEZFTb-UaPVN9=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Stephan Demmer',
    comment:
      'After being advised and guided by EnergyPal (Anton Donets, great advisor, very nice and knowladgeble person), Nexus Energy Systems just finished the installation of the solar panels on our roof, they did an amazing good job, the well skilled technicians are clearly experienced and not only that, they have a good eye for details and did a perfect clean install. I can recommend EnergyPal, Anton and Nexus for your solar system and auxiliary equipment, great team work, well done guys !!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcurS3T8DVhm58404vtG4u-RU4zTEZ1Pz7hLceIlyW7Xw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Deborah Minns',
    comment:
      'Calib was very thorough explaining everything and all the options clearly.  I have a much better understanding of a very complicated industry.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteSabNK-fOCTuGHqd8YR8HimNG1wnAmjHqccKV2gI3F=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Lori Weaver',
    comment:
      'I worked with Neil Pranjivan, who was super. His presentation was excellent as he explained every question I asked.  He was very transparent about everything.....pricing, quality of product, reputation is super, honesty, integrity and can be trusted.  That means a lot to me.  Neil and his team are great.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtflNrIjqP3AgjjSKr-6LjhwxmM1Py6IuAoAtri4oKjW=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Thao Hoang',
    comment:
      'Angie was very supportive and provide all the necessary information prior to signing us up. Overall a positive experience and recommended her to a few family members that plan to get solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfe1V4a4Y2ywhBEWTqrL5h_1qZ6FzMzQrblb4QwC_8I=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Sue Leifield',
    comment:
      'After buying a home in sunny Tucson, we considered adding solar panels. Noorez Rehmat, Energy Advisor at EnergyPal, was super helpful in walking us through the lease vs. buy solar options, and at obtaining quotes from suppliers and installers with high customer ratings. He responded immediately to all our questions which helped us evaluate the potential benefits vs. costs. As we only intend to own the Tucson house for a short time, and the roof area is not large enough to generate a significant percentage of the required power, we ultimately opted against solar. We highly recommend using expert Noorez Rehmat to advise you if you are considering solar power.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSFUC-yfgce9CMaJwTzM-_lTL_G5K-Dl9ImnFK1aJNwxks=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'James Phelps (jphelps)',
    comment:
      "Solar was very intimidating to step into but Energy Pal was able to answer all my questions, do the research for me and walk me through the whole process. It's been a great experience working with them and solar is not the headache I thought it might be.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtePnvaYZZIg3iPvLhQXE0NsN2RKN9A2mAW0JLuzX5oF=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'L HC',
    comment:
      "I spoke with a lot of people about Solar panels. I chose to work with EnergyPal because of Bret Robertson's professionalism. I appreciated Bret's approach that going solae is a win-win for everyone. He was also kind and patient. Thank you!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQLnu6P5jjShmjzlzp_kOeuD-su1TPkKn-96WxJ91CceIA=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Dawah',
    comment:
      'Very smooth process so far. Terrell is very pleasant to work with. He answers questions openly and honestly and continued working with us until we decided on the best package for our needs. Definitely recommend this company.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSwvLQtzIeoKeAkGy7B0xBQMLZwn4YO9oIrrcT3aG0FZYU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Elizabeth Petrach',
    comment:
      'I had the pleasure working with Keenan Ladd. He went above and beyond for me. Super friendly and had the pleasure of working with him as well. If you need or looking into solar for your home definitely speak to Keenan Ladd. He will get you want your looking for and need. Thank you Keenan for all you have done for my family.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfNfYrO7XvrSmkgF_p-NLAGZFfnc6o1XiXK05V9hlUM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Sid Griest',
    comment:
      'I was extremely impressed with the professionalism of Kevin Terzian.  His presentations were thorough, punctual, accurate with quick responses for the various options presented to educate me on my solar options, engineering and all equipment details I requested.  He was personable and polite and made every effort to provide an ideal customer interface for Energy Pal.  I was impressed with the technological speed or all the digital interfaces the company has provided to reduce the time and effort of what would normally require many hours of interface and multiple meetings into a rapid two hours of virtual meetings in a single day.  I really appreciated the provision of all the background data and equipment specs for my engineering evaluation.  Great job by all concerned.  Sid',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfDv2v_xhPXM9CgbP5qVkwQcxbtsoByJHylJOTyqasf=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'P W',
    comment:
      'My experience with EnergyPal was smooth and informative. Mike Levy is exceptionally knowledgeable. Very patient and courteous. The email correspondence with links to their company for signing documents was very professional and easy to understand and follow. The website and app are laid out perfectly.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfFHdeyvfpv0MJpR-q1fcP9ICYmoKvZqheseGTiqWd-1Q=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Valerie Morretta',
    comment:
      'I need a Kevo in all areas of my life!!!  We interviewed many solar companies and Kevo Terzian with EnergyPal was the only one who was completely transparent about his role in the solar purchasing experience. He helped talk through the things that were making it difficult to make a decision after narrowing down to two providers, without any pressure. When I reached back out to everyone else (who presented themselves as solar providers) to inform them that we chose another provider and would be working with EnergyPal, it was only then that they confessed to not being the direct provider and tried offering to switch to the provider we chose. This absolutely validated our decision to work with Kevo and EnergyPal for our solar purchase. While "honesty is the best policy" is always true, with such a major investment it should be the ONLY policy! Kevo is the only one who provided us with this experience and we look forward to continuing to work with him and referring him to our friends and family.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSGrGu7RhnHaC-mJDmbqMfPL8-N9zlYB9QCMsUsF8InCw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Lake Worth',
    comment:
      'For me, EnergyPal is Kyle Austin. He worked diligently with me to design a good system, meeting our needs at a great price. He was patient, and professional. I would recommend EnergyPal to anyone looking for a Solar system at the best price available.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtc9BvXPproYwQcfoe_0DHPLob4Jy4_-an6ds13jtAwl=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Yoga Prabhu',
    comment:
      'It was great working with Simon for our solar project. He did his best explaining us all steps of the project clearly and helping us to go solar with very minimal effort from our side. He made sure to follow up with our project coordinator and keep us updated on the process.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMTE0USM6JJdvinzwGh5V_VVfTKK2JFkTcd4-3SuPTCKKQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'buck rogers',
    comment:
      'Energypal was very helpful when i decided to go solar. my counselor, lincoln panasy, gladly offered his technical expertise & answered any questions i came up with. he was easygoing & helped me to be very comfortable with a new endeavor that most of my acquaintances had no knowledge of & were very sceptical. the savings are noticeable, & i feel good to be making my small contribution to a safer, cleaner future for my children. thank you, energypal, for all your help!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcU_miMCRdfDtOvyO8VKp0U_PDnQ5w79qUqjtOirhnw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patrick Brennan',
    comment:
      'My meeting with Yagana was absolutely awesome she is an excellent asset to your business and organization, I believe if you have her train representative/presenters you will have an unstoppable team. Thank you for the opportunity to do business with you...',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQfPUvpf7WibahRiSevB4e7jj7XANK0UDM-HnJCAEcp0A=w120-h120-p-rp-mo-ba2-br100',
    type: 'google',
  },
  {
    name: 'Ronald Silva',
    comment:
      'I found Simon to be to be helpful and proficient in the Solar Industry. He was very efficient at explaining plainly what was required to meet my needs.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfyx-S5LmG43r-8RUxkt6_RwkD3o2s4EQ37AdKrAe-p=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Oded Strich',
    comment:
      'The consultant Andrew Bardauskas was the most informative, honest, and transparent of all the Solar vendors who I talked to. he did not inflate the facts and did not over promise. Thank you Andrew',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteRbCipykfNq064EdldOTNeSFdENwmVtjjxq8hxb8hI=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Julia Giddens',
    comment:
      "Kev Terzian comes highly recommended.  I wasn't sure if I wanted or needed solar. He took his time and explained the units and resources that were available. I was impress by his professionalism, honesty and patience. He was so informative. That I knew exactly what I wanted including type of panels. He actually works for the customer.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQMVtuiXKXKVHIb3O2LQh-WuqVKWiGhHvoTPVZLHjEAHYU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'john kittoe',
    comment:
      'Kevo really knows his stuff around solar panels worked with us well and setting up a package for solar system thank you kevo',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtf0KkGUDFOuuDlzTphSJREqejQ4xMCGAnR2mCb6LaMM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Karen Luttik',
    comment:
      "We were very happy with EnergyPal's Bret Robertson's step by step assistance in this whole process. We live in the Wilmington MA area, and Bret really knows all the details concerning rebates and which materials we could best choose. We are in the beginning  process of this project still and have decided to go ahead with this organisation and Bret after considering many options. I would recommend Mr. Robertson and Energy Pal to others as well. Thank you very much!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQsH06Thzh2fOwzlJHt2IX9el0wZN1fZq7BMBgO3TrA5J4=w120-h120-p-rp-mo-ba2-br100',
    type: 'google',
  },
  {
    name: 'bflyswithhawks',
    comment:
      'Yagana Samim was my customer service representative and she was extremely helpful in providing me with information about solar energy, product and cost options, and the comparative value in investing in solar. She was respectful and followed up appropriately. I highly recommend Yagana Samim for all your solar questions and purchases. She is honest and invested in your needs. Santa Rosa, CA customer, Brenda',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSVSCUnsaKM5RYLty1SYN_ZmzheAHpAR3MCa6gqN84Ze2Q=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dan Archer',
    comment:
      'Working with Kyle Austin was a pleasure. I was always in favor of meeting face to face, but with Kyle on the phone explaining, answering my questions and making changes to the design it was so easy that I felt comfortable with just doing it over the phone. And when he did not have an answer he would get back to me the next day and provide information I was looking for. If you want a knowledgeable and patient solar advisor, ask for Kyle Austin. He never rushed our conversations or got tired of redesigning the system for me. I felt he was on my side of the table and that is why I highly recommend Kyle.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtehUvLlDkzT40WUyzOanHFl_jOhH5M3b-M3C1vz2Kog=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Brian Walsh',
    comment:
      'I have been in the market for a solar for a while now. Amanda Swan has been heading shoulders above everybody as far as my customer experience goes. She was very knowledgeable and patient with me. She listened to all my questions and answered every single one of them in terms I can understand. At times she even brought up subjects that I had not yet considered. If you are in the market for solar I would strongly recommend giving Amanda a call',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcksLdSn4HrJfAzlTldTYEX1OOSLU8a1P11wj3S4jwq=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Susan Way',
    comment:
      'Yehudi was very professional & knowledgeable. He showed up on time. He explained the program very well & he even looked into extra things we asked him about. Really, couldn’t ask for a better experience!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtf4IG5g-CnDG9KTXDSG69KvGSIVUQKS0683fnN24fvm=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Wesley Campos',
    comment:
      'If you are even remotely considering solar panels, you need to schedule a consultation with David Perry! David was extremely thorough, helped to answer all 1,000 of my questions, and was not a pushy salesman at all! In fact, David was totally honest with me about the costs, savings, loan terms, and took the time to make sure I understood each option. I highly recommend David Perry to anyone considering solar!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSpsjNEdSelVmWJYSViSfsq3DlsV9JLobbr5c5yhg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'James Anderson',
    comment:
      "Kofi Kuma was wonderful in my shopping for a solar system. He gave me several options and didn't mind my changing my mind on which system to choose.  Outstanding customer service.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMS4qHvG99zSag1LYZr1sX9Hbjk8dkoFG7whQ5m5vg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Eugene Yuzhuk',
    comment:
      'Guy McVey at EnergyPal was just an extraordinaire representative for  the company. You can count on most detailed explanations, understanding of your personal situation concerning the project, coordinating between departments and a prompt follow up on everything. It was a pleasure working with him.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtckeqArMq0LrfGpCLtYsrh63_SkSOtR8ziaWYFT=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Leon Gortler',
    comment:
      'Caleb Siu was very clear in describing the project, the savings and the long-term costs.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcuBoL_AbYJ8j-dZ3xJjDKLWM-kHWdlFJk-2MlW=w120-h120-p-rp-mo-br100',
    type: 'google',
  },

  {
    name: 'Virginia Jaquez',
    comment:
      'Craig was very informed and explained what I needed to know in order to understand what EnergyPal is offering.  Thanks!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMTqJpFt8QibZ3CuQ33Pp4MKL8yKPHsQ-EDuykNUIg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Chris Balboni',
    comment:
      "Yehudi is a true solar professional. It was a pleasure working with him. I wouldn't hesitate to recommend his services !",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTte3AUOv-_otYlMdCwNnBYoxmCWtp5A3GEaZoP2B=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Janet McMains',
    comment:
      'Suniel was so helpful. He Answered all of my questions and gave input that helped me know what I needed. Great company.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteKv1ikE1c5Agco5Y7uV1eRvUrLSYL2RZSA5OFo=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Carol Dederick',
    comment:
      'Caleb Siu was very helpful in explaining the solar panel information for me. It is quite a complicated process but he was able to  simplify it so now I have a better understanding of how it works.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtdB843YBKAtAFXLgivn_uf7WFpBCMWIsb1dEQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Clifford Harris',
    comment:
      'Caleb, did an excellent job explaining all the different options for Solar ownership.  I would recommend him to anyone looking for advice and information.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQgyGy7XUSTmSpn4QR_TzhcDVX54_IVVzqyV2MeCg=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Steve Holt',
    comment:
      'Lincoln and Energy Pal really listened to what we wanted and was even able to help finance a new roof in order to get solar panels on our house. We are bid fans of the team and how everything was handled.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtczdeYEpghyqMKmwl-oA6LrFR3CK1jWQ9tGZZc=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Norman Bergeron',
    comment:
      'Caleb Siu is extremely knowledgeable and professional with regards to his solar products. EnergyPal seems to be a good company to work with and If I choose to go solar, I would strongly consider EnergyPal',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQzG9SPGNNzZUPv6v5Hfe9uvmOOMJl4f8PYB52S=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Blake Geiger',
    comment:
      'Suniel from EnergyPal was awesome! He was extremely professional, knowledgeable, and helpful during the whole process of determining which solar system option to go with. He was very patient with me while I made the final decision. If you’re considering Solar I highly recommend reaching out to Suniel with Energypal. He will help you make an informed decision. Thanks for your help Suniel!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtfccm47KMbjNew_R78RplW6FWkvVo3IeSdK5-w7=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jose Vega',
    comment:
      'My experience with trying to see if solar was for us this go around (looked previously 3 time) Our experience with EnergyPal representative Kevo Terzian. He was very helpful in letting us know all the aspects of what solar would give us and what to expect as well as informative in the tax credits, how the credits work with TEP and also did what he needed to make us comfortable with using EnergyPal. Thank you Kevo for you work ethic and not giving up on us.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSFJmOPgC1HR3W6K28s8nKTBd9I7P0-DMaIoAPrLw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kathleen Walsh',
    comment:
      'I enjoyed working with Matthew Fisher when I was researching installation of solar panels at my home. Although I did not ultimately go with the proposal Matthew offered me, I wanted to because of his helpful, knowledgeable professionalism. Matthew was easy to work with. He understood what I wanted and came up with a plan that met my needs. He understood that in such a competitive business not every bid wins. He was courteous while exploring with me the basis of my decision but did not push inappropriately. I would definitely work with Matthew again if I am doing any additional solar projects.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcD9l3AfgH7lx4fpt7ee_YAcyyPGBISNINVS9M9=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Aleta White',
    comment:
      'Energy Pal representative (Mike) was very knowledgeable. and informative. All information was understandable and clear. All incentives and disadvantages were laid out precisely. for making a determination. Very happy to have talked to him.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtcvK626A12BkD1NZ0QkN-_pRCmizVg99xInuPI1=w120-h120-p-rp-mo-ba2-br100',
    type: 'google',
  },
  {
    name: 'Sam Burns',
    comment:
      'Lincoln was very helpful when I first got into looking at Solar Panel. all the information that I ever needed I received from him. I like dealing with him very professional and yes I did sign up and lease solar panels. I am very happy with them and the cost.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTte5MDpZcL1YBmc3Z-qj1NyJf1kUa3CYVlLz6-sc=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: '李一峰',
    comment:
      'Zeyad is fantastic. He is hard-working, diligent, professional and tenacious to the most minuscule details in finding the most suitable plans and best deals for clients.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMQBu6DGVyD1fdCnXVK09C8S8h5242wPLC5yuaBf_xw=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Tri Truong',
    comment:
      "My EnergyPal contact was Angie V and she made the process seamless and painless. Angie was able to talk me through the different solar options and recommend a system that was most appropriate for my family's current and future energy usage. She provided honest assessment of the system size and options and did not try to push us to purchase components that were unnecessary or un-economical. For example, I asked her about including batteries in our system and Angie recommended that we wait because battery prices are very high at this time. Angie also made sure that the solar installation process continued to progress at a good pace by keeping in communicating with the solar panel provider. Overall, I had a great experience with EnergyPal in general and Angie in particular.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AD_cMMSxoGCHd8wWuM-4zhRRCFl9yBOaqbagwL_APXk-r0A=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jeff Sweeney',
    comment:
      'I purchased my solar system from EnergyPal. They provided the installation company that had issues with the installation.   So happy I had Energypal to help resolve the problems. Without EnergyPal, I would still not have my solar permit from the City. So big thank you to Ben Cummings, Melissa Peart, and Ian Hilborn greatly appreciate everything you have done. Also, exceedingly pleased, Ben offered me SolarInsure an extended warranty, adding another peace of mind! 5 star review all around.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTteqm1cMeEQPAVJ7bMA9cnks1x-HxFNMrQM2L424=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Langevin',
    comment:
      'Caleb was methodical and patient.  He answered all my questions and quietly quelled my skepticism.  I have had bad experiences with other solar companies with high pressure sales, but my experience with Caleb renewed my faith in the industry.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AAcHTtd5iSPl64FY9jSl3z6ufNWllaa6aUL6QCZllxuz=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bill Burke',
    comment:
      'Chad Rose at Energypal has been the best solar rep out the many many many that I spoke with. I literally have shopped most companies and he was able to secure me the best deal possible for my situation.  I cannot thank Chad and Energy Pal enough for such a great experience.  I would highly recommend them to everyone interested in saving money and going green.  Thanks Chad...',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5RLd6jpuZS96IYE60QCnBabpgR1DGkm72izGmEDWzU=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Todd Tanner',
    comment:
      'I had an awesome visit with Simon. He answered all my questions and shared a thorough overview of the system he felt would be best for me and my needs. I’m looking forward to working with Simon on my solar project.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZP3gPURNvyeLNgXp78zjln8DiU_nR04yxBXcDO=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Lizbeth Rosenfeld',
    comment:
      'Spencer Strandholt was extremely knowledgeable and very good at explaining the various options that might suit our needs. He asked additional questions and was then able to fine tune our quote so it truly matched our current situation, as well as provide insight how we might expand our system with growing future needs. He understood that we would be seeking multiple quotes and remained very low key, which was much appreciated. Great job Spencer!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYoVgme4WS4eZvhzIICU6RRbtPZirji-xLIcxO5=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Cordero',
    comment:
      'Kofi our Rep., was great! The panel installers came in and installed the panels in one day. After investigating 5 different solar companies they gave me the best price.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5Sj4RtTyYUAwUgu634lHq2VZOUfiIlf2Yd7qzGw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Elizabeth Murphy',
    comment:
      'My representative Shelbi was fantastic! She was very concerned about my needs and my considerations. I have several large trees and didn’t want the panels on the front of my house. She worked very hard to address everything needed and I believe this company is honest and trustworthy just from my experience with this representative.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYjuG8gx_LY1_as86IHr4O6_79i50Qv97SHTROHSQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kenia Haroldsen',
    comment:
      'Kevo was a great guide in helping us getting our solar system installed. He showed us every step of the process. He was always professional, accurate and patient sending us different quotes and options for our budget. I highly recommend working with him and Infinity Energy Solar!!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5RKsbgKKZgtBTELiUcC_RaCWMZOD7z2E1Lk58-xKVw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Vicky Gee',
    comment:
      'Caleb did a great job explaining everything. Not too pushy and seemed to have my best interest in mind. Thanks so much!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5RQl1qntDZI-FaaFt7tq8HDsGCd-3SCY7j45Xdoew=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Pappy',
    comment:
      'Anton was friendly and very informative.  He satisfactorily answered all of our questions. His display during our meeting was very helpful.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5TLCbjxBIr_f7ruotrsy9EjPjT9AjmcqXmLfRGheQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Joseph Biraglia',
    comment:
      'Caleb, was fantastic!  Clear, concise and complete explanations of the entire process and relative costs and savings.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxajyLKignaiIMI5ZxniKEnoNkHLuHDlvuYgZJil=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Max Sachuk',
    comment:
      'Lincoln is Super helpful. Before installation we went through different options and he thoughtfully explained all details and nuances. Because of him I think I got really good deal compared to other companies. Got panels installed at the end of 2019. Everything is working great!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5QewIBXBixOBREIOe7Xc5_F5dzlMHiek7bsTozCVA=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Ron Stein',
    comment:
      "We contacted Lincoln Panasy at EnergyPal upon the recommendation of our son and daughter-in-law to assist us in working with Sun Power to provide a solar electric system for our residence. We started this activity in late February 2023 with a desire to have the necessary documentation complete by mid-April. Lincoln and his colleague Elijah Hassan did a superb job in coordinating with Sun Power to produce the design, complete the permitting process, and install the system. Installation was complete on April 1!   Inspection occurred on April 4, and the system is now waiting for Edison's approval to connect to the grid. We were amazed at how simple the process was and how quickly the project progressed form design to installation with little effort on our part. We believe that Lincoln and Elijah deserve a large amount of credit for making this project run smoothly. Ron and Donna Steinkraus",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZcl7OQwPXMVojP5YYxvOC3-UaRKUdi_4oOdBLS=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Ringham',
    comment:
      "I've  been working with Tyler to put together a package that makes the most sense. It's a work in progress. I'll make another review once the decision has been made. Compliments for a wonderful experience!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYpoghNj8UZw3l1t9Fz0aATaKqdhYvKb-g3vBQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Helen Juan',
    comment:
      'Caleb was very thorough in his presentation.  I was impressed by his ability to alter design options as we discussed the changes I anticipated with our energy usage. Appreciate his agility and ability to answer my numerous questions, plus provide information on anticipated roof repairs for our structure.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxaDfV_gqUVkAFki8ObKnrOxMjg0otBebkxc-TeS=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jay Prakash Singh',
    comment:
      'Working with Alex at EnergyPal made solar simple. They helped me find the best option available and instilled added nonconfidence throughout the entire project.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5SqG8EyUMzNHNtjIWLL6H5FXsUREfQSd-O4dW2u=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Rocco Zinger',
    comment:
      'Anton was very professional and I enjoyed the online assessment.  It was easy to see what we were talking about and I could explain some things in the google view of the home.  Anton took all the time I needed. He answered all the questions I had and explained things in  away that was easy to understand.  I will definitely recommend Anton and Energy Pal to anyone looking to go Solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5QK5ElPDCli1wBIJWCQU-jyngon1Zkc3ieAcRtsQbM=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Nalieth',
    comment:
      'Matthew was thorough on the details and sensitive to my concerns and questions. I felt supported throughout the consultation. It was quick and to the point, but not rushed or pressured. Matthew is one of my most trusted consultants.Thank you.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxY19ysZHqzWTD1btJmyNjqRyYMMDojlzIupVe_w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John and Terry Miron',
    comment:
      'Sarah Ahmed is a knowledgeable and patient solar consultant.  We appreciated her help in putting together a system that met our needs. We will recommend Sarah and Energy Pal to friends seeking an easy, low pressure pathway to buying Solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYC5IT2-Qzd9oaMqllS3QDmvISHSp7gVRJb6AV8=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cindi Kelly',
    comment:
      'Jesse Agrey was amazing during the process.  He was knowledgeable and was able to answer our questions. So excited for our solar system!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5SKS2pcd_nMfzPxJ84gtW_IJ-wmyHNHQQkhf0f9=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Mateo de Colón',
    comment:
      'Working with Mike was a fantastic experience.  He took the time to explain everything clearly, explain again when I needed clarification, was easy to get in touch with and always followed up. I can honestly say working with him was the best customer experience I had and I spoke with many representatives from many different companies.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5T7EI5qWpSX3niqpLEIQS7fEMV3sZundnL-JoN9omo=w120-h120-p-rp-mo-ba4-br100',
    type: 'google',
  },
  {
    name: 'Yasmili Rodriguez',
    comment:
      "Spoke with Ben, and he is amazing, he explained all the information that we needed to know for our home project, I am very exited and can't wait to go solar....thank you",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5Ss0UdXVZUUNhny4xvf3x66vzBpEtO_0EGjCEiRPQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'The Charn',
    comment:
      'Spoke with Ben about getting solar for the home. Provided the requested information and the phone consultation went great. Lots of information to review but presented in a very clear concise way. Requested some changes and they were made immediately. Initial consultation never felt rushed! Great job and experience! Highly recommend the company if you are thinking about going solar!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxaNCdIWg-ql1hXbDcirU3XmFdP4JyzrrhzqW0bl=w120-h120-p-rp-mo-ba4-br100',
    type: 'google',
  },
  {
    name: 'Adrienne Stenson',
    comment:
      'Zayid was very patient and answered all my questions. He’s a very personable gentleman and a credit to his company. I recently moved to my community so unfortunately do not have someone to whom I can recommend solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYWX8J8SYZu03rqRupyFAvOGVKZGqnv6H751A0y=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Kanji Nishijima',
    comment:
      'Amanda has been great.  Knowledgeable, patient, and helpful with suggestions and feedback.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZ8LMWQjEyX2YaZcVoq3y1pIV9gIu8WdKUz_teC=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Yang Zhang',
    comment:
      'Zeyad is my working agent. He is very responsive and educative to all my requests. He walks me through all the solar options, include # of panels, offset %, inverter/panel types and etc. He did all to get me the best quote. Definitely recommend this agency and ESP as your solar solutions.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5SFAhyUGYbVUx2Di25wHHziGbpDMt52FFPloA-pNA=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Patrick Gocha',
    comment:
      'Spencer is extremely knowledgeable about solar energy, the different companies and their products. He took the time to educate me versus pushing me to buy something. Highly recommend him if you are considering solar!!!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5RmULH0cW1_IubCrlbNji2us2FxHNDFEpCMYFoYLQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Em Carreon',
    comment:
      'Mike Levy is very professional, knowledgeable and very helpful.  He is by far the best consultant I have spoken to and dealt with.  He went out of his way to find us the greatest deal he could find.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5SWkVmR_bx32TG9l2fTkwQ7rO_38v-RLlc6kQaiP7w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Carlos C',
    comment:
      'As a new Solar buyer, Simon Chen from Energy Pal was able to answer all my Solar questions even though they were crazy at times. Simon is a great ambassador for Solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYIGZCMBYSftsJysExri-qx3yhq5XMr7l3KifxP=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Pat Mcq',
    comment:
      "Elijah Hassan is a quality person. He helped me fully grasp the home solar energy production system and generously  shared his knowledge and time. He is not pushing for a sales or any company. But, if you want to beat Electric Co's (pg&e) 75% decline in net metering then you need to get into solar before April 2023 and if you wanted to use the 30% federal tax credit this year that's another incentive  that is available  for the next few years. Thanks Elijah!! Get the information  without bias from him.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5T3wwqoICIf5aRdkGGt5qFpeQwZPbNvWO-wz9WzMKw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'S A',
    comment:
      "My contact with Energy Pals, Angie, has been incredible. She deserves 10 stars.  Angie provided me with informative responses to my questions.  She is professional, patient, approachable, friendly and honest.  I felt at ease when I made the decision to go with EnergyPals because of Angie's help.  Angie provided me with thorough knowledge in regard to the best system for my needs.  I was able to make an informed decision and feel relieved.  Prior to learning about EnergyPals, I interviewed three solar companies.  Angie was the reason I chose EnergyPals.  Thank you Angie!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZpBxHcixGhUjtr_JMMR60lVQ-ysRiY91nqjfN5=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Gilbert Warila',
    comment:
      'Kofi is very knowledgeable. He presented all of the issues I have been concerned with. The power usage graphs augmented the size of system needed. Thank you for the bid.  Gilbert',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYuxiFtNYqWzHRhFRwMnPXWtogrxqFVNuH9zmJa=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Diwakar',
    comment:
      'It was great to work with Kevo. He is detailed and very nice to work with. He answered all my questions and doubts and continue to support throughout the journey. I definitely recommend EnergyPal and Kevo to work with.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5Q0XP2ifYmbKQcAdLeH4JL1kTMntrnufk7QYicSEAY=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Choury yam',
    comment:
      "Suniel was a great solar sales rep. Professional, no pressure, prompt to respond. I can't speak of the company itself, since I'm still in the process of signing up. Fingers crossed, Hopefully all goes as promised.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5TANc-wu2iWm09Sf2R2LOZcW3ykWmKW8LXW_njZr8I=w120-h120-p-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Rosa Metzler',
    comment:
      'Simon Chen was very professional and answered all my questions, in a way that was easy to understand.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxb8QFl36uFKnJ_faIerBZEbMa-d78Q1V1HTrD8C=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Paul Nalieth',
    comment:
      'Matthew was thorough on the details and sensitive to my concerns and questions. I felt supported throughout the consultation. It was quick and to the point, but not rushed or pressured. Thank you.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxY19ysZHqzWTD1btJmyNjqRyYMMDojlzIupVe_w=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jeff Linder',
    comment:
      'Occasionally, if the gods are smiling and your "good" karma cup runneth-over, you happen upon a sales person that treats you so caringly a professionally that you hope he will be given the opportunity to help scores and scores of others who are in need of guidance while making a complex and difficult buying decision. Mike Levy is just this man.Even though Mike lives in Nova Scotia and I live in California, Mike worked tirelessly --til 2am local-- to ensure we arrived at a buying decision that seemed right at the time and more importantly seemed even more right when we awoke the next morning. Without hesitation or reservation I so wholeheartedly recommend Mike to all others who are endeavoring to become a member of the solar community. JeffL',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZBVFdEdiHeuTpo5IsJ2zpo1dK7mpvPu9OdhKqR=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Anibal Suarez',
    comment:
      'Shaq at EnergyPal was incredibly valuable in helping us navigate the complexities, options and nuances of home solar and outlining  key benefits that made our final decision clear and obvious. Exceptional attention to detail and thoughtful consideration when designing the perfect solar system to serve our needs. Thanks Shaq!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5RN6yVUbPZV5tmW-YeIUd0yFDvI7Hwxzs_4na61uQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Brenner',
    comment:
      'I thought Spencer was very knowledgeable, highly professional and pleasant to deal with. I also felt he was helpful and sensitive to our needs. He was able to fully articulate what our options were and provided all the information in an easy to understand manner. He was great.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxYtCh-ESlal3BQSWfHtthdwnx4I3Rw623miqCiQ=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Crystal Pond',
    comment:
      'Tyler Schofield was great! Very knowledgeable about the solar panels and answered all of my questions without making me feel bad for asking even the dumb questions! :) I will look forward to working with him.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5R7Cjzggykw-dw09S6AWb29d-URODrQ9OOVT-VVOMk=w120-h120-p-rp-mo-ba4-br100',
    type: 'google',
  },
  {
    name: 'Saumin Patel',
    comment:
      'William Horst was excellent in explaining pros and cons about the solar project with NEM2.0 deadline. Well done Willam and thanks for providing good details.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AGNmyxZBsuxsqdzDoL8KBlqNHBpcDMP7CyVaZZqDuIxO=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Donald Larsen',
    comment:
      'Mike answered all our questions and explained everything very well.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/ACB-R5SMN6jMye4T4IanrW1GAxMXIYaxLWAtQ0gLBM5tVw=w120-h120-p-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Raymond Faria',
    comment:
      'Caleb was extremely helpful and answered all of my questions. Thanks, Ray',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJypNkOJRc5aqPm_h91szxZl1zLUnHQNOfIbCbx-=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'White Nebula Samoyeds',
    comment:
      'Lincoln was extremely knowledgeable and patient with explaining all the options for me. Customer service was 5 starts throughout the solar journey. Lincoln brings humor, life experience and ease in shopping for solar.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJzYB90rx9gW14KHadXxHQrRPAyuzgACkxPffwNh=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christopher Grijalva',
    comment:
      'Caleb was very helpful and knowledgeable.  he took the time to go over all the aspects of the potential project and explained what would happen and why things were being done.  it was helpful to not only see the numbers for the project but he also explained the warranty, financing, tax incentives, and how the project would be installed.  Overall I felt he provided good information so that I can make an informed decision.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GhlPrK3exnAcnake729ZejXH18ivpvWI_QWcaef4Q=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Philip Putney',
    comment:
      'I worked with Scott Pawletzki and he was fantastic. Kept me informed of everything that was going on and answered every question I had for him. Very professional and attentive. Couldn’t have asked for a better experience',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJwyZD95HysDBa3hBi5IGWEavpqOHvNVS3rA5rD2=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Alan Eisenberg',
    comment: 'Very straight forward process and informational.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJwSDk_eRaYLAUiXq83O7e3pFxbaMPvzd5Ssvrw2=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Cabell Harris',
    comment:
      'Great simple presentation. Ron was very knowledgable and patient.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GjJJxVJrLbKdbbD13MKNbjEpaXLFoEBEZGUHxa-AQ=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Christopher Appling',
    comment:
      'Patrick Bos has been a great rep. to talk to on the phone. Professional, patient, very informative and courteous.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJzTJNkqYakXYP2sWSHV17IDkq194scBirp9w0xC=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bryan Steelmon',
    comment:
      "Angie is a world class solar panel project manager that brings service and can do attitude that is unsurpassed... Please give her a chance, I'm very satisfied!!!!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GgQH7iUJJ5XFeE72MqGZNvt6Pt9tp3Zutc0Lz7x=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Johanna Littlewood',
    comment:
      "Caleb wasn't pushy but was clear, punctual, to the point, and very knowledgeable.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxZ1zQmhQYEn69P4k9EAkepQIsONQTD41BxjKce=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Ramona Simpson',
    comment:
      'Angie was very informative and provided very useful information.  She answered all of our questions.  We are in the beginning process of collecting information about going to solar power.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gj0gLtgf1DNif-0e3LnmCiSORvxztfyGj831VmZ=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Majid Vakilynejad',
    comment:
      'Patric Bos who helped us to convert to solar was absolutely helpful and patient to explain everything. This was painless experience and I felt during the time he truly concern and want to make sure that I get the best option possible. I have been extremely satisfied so far.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gi21bhk0X6JtWNI28PhYq20I75N4sNM3c2t7252sQ=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Niqi Li',
    comment:
      "Right after I submitted a solar request online, 5 or 6 solar companies and brokers called me. Glen Duncan from EngeryPal is the one provided the most competitive quote among them. He's been very helpful in sharing knowledge of solar panel models from different manufactures , microinverter, warranty info and how the whole process works. My husband and I were not sure how large our solar system needs to be and what kind of finance term we should choose from. Glen has been extremely patience in guiding us through all of these, and customizing the designs to fit our special needs. Highly recommend!",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJwTMUvK8jeEvkDXM8vtdidCWApBJqA0ly6btOq5Kg=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jc Jimenez',
    comment: 'very informed and clear in their explanations',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GgK2PUU2wh5I1Hc7Pfl42DMfXlLtNDxF43bIDzXxA=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Quan Pham',
    comment:
      'Glen is knowledgeable and literally talk me out of a battery back up system as he did not see a need for one since all I was interested in is keeping my Desktop, some phones, wifi and refrigerator going for up to 24 hours and a battery generator would be enough.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GgkgjbNLSaoc99ERcKQjrqfzbBsyKed_dXAtS4eUw=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Shimon BenBassat',
    comment: 'Jasmine was very helpful and informative in her presentation',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJydac9vN3rg-iwmCx7Ifp69k73aduGvqE_tTfZA=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Richard Dore',
    comment:
      'Very thorough.  I enjoyed talking to Sophi.  Very nice, detailed presentation and she answered my questions.  Just starting to look but I can see they would be a favored company.      ',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxkr3VrZWxcUOAjOOaNWb2-zMXYLCH0RRV6iYIS=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Sairam Gudivada',
    comment:
      'I have never come across anyone that has explained things in the way Ronald has done, not just once but every single time we have spoken, he has been phenomenal. Thanks Ron...',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GjKBBEAhIy0Rlspd8W_kkQqd6wc0VsJhPDuu7hN4A=s40-c-c0x00000000-cc-rp-mo-ba3-br100',
    type: 'google',
  },
  {
    name: 'Mary Anne Dougherty',
    comment:
      'Scott Pawletzki was a personable, and professional energy advisor. He gave a lot of information in a brief period of time. There was no pressure to act in haste but he spoke of the advantages going solar. Scott gave a clear presentation with visuals that helped in understanding the process.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gg3eo8ZsqYVpYE3MbSKl2zepgw1dhJ7tNgXLYjm=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Russell Taylor',
    comment:
      "Glen Duncan, Did a great job explaining EnergyPal's plan for my Solar future. He explained everything so as I could understand not only the Solar plan for today but for the future too. I'm not going Solar at this time but is because of my own personal issues with my health etc. But I would recommend Glen and EnergyPal for your Solar Needs for now and the future.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJwIrhoierqNlHr1B2r1Tjxl_m7zb7qPj0c9pYaU=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bryan Matthews',
    comment:
      'Rejeanne was very pleasant, patient and informative. No pressure just facts, which as a former salesman I appreciated immensely. We will take a few days to digest the data, all things considered very interesting.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GgOg_GslR1UJ-McbCPF3ngw-1q8-f1nZoJZV_HC=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Eileen Ahearn',
    comment:
      'Caleb was very patient with my questions and didn’t try to sell me a system but instead was very informative and explained the details clearly.  This was a great presentation and after I receive a couple other quotes I will be seriously thinking about going with EnergyPal.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJzG5tcwVuDmXVYOa2wPJjoSMAV2YzfdsellxDBU=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'John Pacheco',
    comment:
      'Rejeanne has been a great consultant thus far. She is well informed and very helpful in explaining the process. Only hope the progress proceeds more swiftly. Here is to another successful install in the very near future.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxS4Pmw-lC68y5FY7oKOtIZbvznXAFInZdnL2A4=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Lindsay Barron',
    comment:
      'Lincoln did a great job! He understood his assignment and got it dne!!!!',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJwXPa6CUwnYqIuApIQgieBllMhXMYLr_B64g4mi=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Stephanie Esparza',
    comment:
      'Sophie Robertson was so great and very informative with how the solar program works! It has been a pleasure speaking with her',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJyXsWmJfm-NvQsFdkHbnzWpftQDXVPUMy_dRK9M=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    comment:
      'Lior did an amazing job helping me go solar. I had interviewed three companies and received 3 quotes prior to Lior reaching out. It was somewhat difficult to compare the previous three proposals because of the way they structured their pricing, and the salespeople did not seem to be able to break out items so I could go apples to apples. I Immediately noticed a difference when speaking to Lior. It was not the usual sales call and there was never any pressure. He had the answers to the difficult questions and he answered them directly. I would also like to point out that I am an incredibly picky and difficult customer…. I do most work on my house myself and I’m of the firm belief that I will always put more care into a project than any contractor would. Lior really looked at this as if he were doing something at his own house and I felt more like a friend asking another good friend for guidance, rather than a customer.  He walked me through the process, answered all of my ridiculously detailed questions, did all the legwork to find the right fit for me and my house and I wound up with a much better system (I would say the best system) than I would have if I were to have done this on my own.While it’s easy to give five stars when everything goes smoothly, we had a few hiccups regarding the interconnect process. None were Lior’s fault, and none were Lior’s problem, but the level of communication and attention he provided to a problem that had nothing to do with him, speaks volumes to his character and to his commitment to his customers. He spent countless hours working things out on my behalf, that were not his responsibility. He could have very easily said: someone else has to take care of that. But he is a “buck stops here” kind of guy. He went over and above what I would have expected. The system has been installed for just about 5 months and I could not be happier with it. It has saved me money every month since it was activated, and it was activated in the winter. I am banking hours like crazy. I have been sending my friends and family to Lior for solar and feel completely comfortable doing so. Honestly when I started looking for solar quotes, I felt like there were many less than reputable solar sales guys out there which made it difficult for me to pull the trigger, as I am skeptical by nature. Especially since I put my information in one website and I got about 20 phone calls!   Lior really stood out from that crowd and did the legwork of finding the best solar company. Had I found Energy Pal First, it would have saved me a lot of time and headaches dealing with sales calls!',
    name: 'Stephen Kollmar',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gh4BgbInoLxuC087NUoaOtZApUH1U0jgUW6T1k4=w36-h36-p-c0x00000000-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'David Zhang',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gj-egbM0vhl6_4tmRk2Ezd4-5pNJwrNrrjB959KVA=s40-c-c0x00000000-cc-rp-mo-br100',
    comment:
      "Had a very positive experience with one of EnergyPal's energy advisors - Caleb Siu. He wasn't just trying to sell me a contract, he was informing, educating and advising me to make sure I make a well-thought decision. I especially liked the presentation. It was so effective to see the visuals and play with all different scenarios. Whether you end up engaging with them or not, I strongly recommend you talk to one of their folks.",
  },
  {
    name: 'Anne Jorgens',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GioZwQEYoNImpQSxHcEqwT0nPppJsI4biIUIGaj=s40-c-c0x00000000-cc-rp-mo-br100',
    comment: 'It was great to work with Patrick Bos, Thank You EnergyPal',
  },
  {
    name: 'Steven Giles',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJyYm3CWYClcp0D95MUMvzUaxef0QWC20vP-M4Bf=s40-c-c0x00000000-cc-rp-mo-br100',
    comment:
      'Caleb was very knowledgeable of the solar products - was able to answer all my questions  - best of all was able to adjust my quote based on changes that I had- overall it was a great call',
  },
  {
    name: 'Zac McIntyre',
    comment:
      'Lincoln was very helpful and always available throughout the whole process of going solar.  He loves talking about all things solar and does a fantastic job explaining everything.  I highly recommend Lincoln and EnergyPal since they will have your back throughout the whole process, working with and planning things out with whatever solar company you end up going with.  Call EnergyPal today - you will be in good hands!!',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GibQvdyHSiiDA-dVo--fXJnQCmI38uynaszyE9VEQ=s40-c-c0x00000000-cc-rp-mo-ba2-br100',
  },
  {
    name: 'Holly Blakeley',
    comment:
      'Caleb was a huge help and the consultation was worth having if you are interested in going Solar. He was clear and understanding with the complexities of the system.',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxjZATUNHpoWFzdVq5cVPRSM2zFQoKOO0EaCiSq=s40-c-c0x00000000-cc-rp-mo-br100',
  },
  {
    type: 'google',
    rating: 5,
    name: 'QUANG VO',
    comment:
      'Professional solar systems consultant. Ben Cummings is responsive, friendly, knowledgeable. Will save you $$ with different choices of well-known solar solutions for your home.',
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxBzJl1QCeBvFhnHdUwkwoMChK_9X-5vfhC20xm=s40-c-c0x00000000-cc-rp-mo-br100',
  },
  {
    type: 'google',
    rating: 5,
    name: 'Irene Rubio',
    comment:
      "I can't speak highly enough of this company and personally from the customer service received from Arjun Manohar. Arjun was very helpful, patient, funny, respectful and overall very professional.  He explained the process in detail and gave me the very best price on solar I could find. I got 4 other quotes and nothing compared!   I am very pleased with the company and the service from Arjun.  I highly recommend!",
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJz0uiYW3rRe4FsYjwa0c4LMJpm5uKh5UbWlZwvg=s40-c-c0x00000000-cc-rp-mo-br100',
  },
  {
    type: 'google',
    rating: 5,
    name: 'wild.hare. widow',
    comment:
      'Great experience , Patrick was very  knowledgeable and pleasant  to work  with. Would  highly  recommend.',
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxouGtoJ57d2W3qKsPZL9Dx5O-ECWT6gfqDnePB=s40-c-c0x00000000-cc-rp-mo-br100',
  },
  {
    type: 'google',
    rating: 5,
    name: 'I Murphy',
    comment:
      'Patrick Bos was outstanding to work with. He gave me several options and would have given more if asked. I asked about different panel brands and quantities. He was honest about problems I would have with my property and shade issues. He is no way a hard salesman. He even gave me a 10 pm appointment so I didn’t have to miss work.Highly recommend!',
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxwhCEDqJdfd9rLSctDsnqY92LSiprvJMCtVydB=s40-c-c0x00000000-cc-rp-mo-br100',
  },
  {
    name: 'Sanket Dave',
    comment:
      'I worked with energy consultant Mitch who was patient, responsive and able to provide a good solar proposal beating all other estimates. He walked me through various estimates and options, worked with me on iterating through the design I was finally happy with. He kept me informed on the latest. I would recommend EnergyPal to everyone needing a solar solution.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gg2h0-Tqdy9vcpocHzm8JxfzVYKXO-v_Lt9S6QDDw=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Dr Carlos Parajon',
    comment:
      'Patrick provided us with EXCELLENT customer service.  He is attentive and has answered all our questions.  He is amazing at keeping us updated and has helped us at every step of the process of getting our Solar Panel project on the way.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GjPdMmunO004jp1g_cZe6DrtDN5Y-rDn_zWx69UCA=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jerson Albuquerque',
    comment:
      'Lincoln was great to work with and very patient with any questions I had for him. He help me focus on my needs and specifics for what I needed to achieve to produce over 100% energy. I would highly recommend working with EnergyPal.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GhYAZyNR8yLoK_01WjEQi-KDXKfHd3mN4lDvyzfhg=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Randy Brooks',
    comment:
      "Patrick Bos at Energy Pal was by far the most professional advisor that I spoke with thru this arduous journey of entertaining the wide variety of 'solar sales advisors'. Patrick, from the slimy to you, the pro, were absolutely the best.  After our conversation, I told my wife we were going to go with the 'Canadian'. I did want to let you know how much I thought of your presentation and your company's offerings and I hope you are acknowledged for it.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJydaNKS_j3zBGfj7xFJLOiD7b98J3IO7P42bnI=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Marc Schoen',
    comment: 'Was very responsive to my questions and provided helpful data.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJzhJx4RrvQucMWF1LZXzEfvqqsTltQYTzv9Ryu6=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Aaron Chang',
    comment:
      'Very happy with Mr. O’Connor. He is very friendly and he take his time to answer all your question as needed. He also try his best to work with the price with you as much as he can. We’re looking forward to refer more clients to him.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14Gg1GxjfDYCn9Y4f0M-waASxCfEAaY7jNT9x1bYu=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Skip Allyn',
    comment:
      "I had all my questions answered. I was given more than enough information on solar panels, a report, and options for present usage and additional electircal devices added to the system. The presentation was professional. Appropriate in terms of speed of the presentation, the diagrams, charts and financial figures. I feel better informed about solar panels and my options for having solar panels as a source for my home's energy.",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a-/AOh14GiS8T7H6DaXZ-nvf2kInWB4MrcVEWfMa5UwyH0-Aw=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jerry Porter',
    comment:
      "Energy Pal worked great for me. Uzzi Sultoni helped me make it great. I'm very pleased and think you will be too. Thank you Uzzi and your crew too. That was so easy and I'm very happy ! ! !",
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJxFN7XJduFnsnfnT4ok5R68AhN6s3nNoaL0zjyt=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Vince Lopez',
    comment:
      'Caleb is very knowledgeable of Solar systems; Always willing to update, and finish the job, even after hours.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJyIleJxIvgPfz6KHFI5jp-T4qEm_vBYnyzRi5QI=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Bobby Tisher',
    comment:
      'Great service.  Their team is knowledgeable and will help you select the right solution for your needs.  They also provided the best price compared to all the bids I received.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJzEPcHsWEm2m1tZ0BVU1mU2Y-xUqv-zGePyrB3s=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Gale Conoway',
    comment:
      'we have heard a lot about energy pal in comparison to other solar companies. We have been told that they are extremely competitive with their pricing and they get things done right the first time. The start of our conversation was with Rejeanne and let me tell you she’s sharp as a tack she knows what she’s talking about and she’s very present in the conversation at all times.  Rejeanne allowed me to take my time and ask those questions as I had to ask to feel comfortable with the sale of the system. She was very patient with me because I had a lot of questions. By the end of our conversation I said yes to my Solar Power system and my neighbor across the street also said yes. Dealing with Rejeanne Has been a complete pleasure. If you’re looking for a good partner when it comes to a solar system I would give her a call she will work you and give you the fairest deal out there and she will take care of you from start to finish.  Thank you very much for all your help.',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/a/AATXAJyMyvkN4YQrPb-BtKZeUiKyzUZ3IfMPYUh_fxVf=s40-c-c0x00000000-cc-rp-mo-br100',
    type: 'google',
  },
  {
    name: 'Jerome Edgington',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-cTxc_i72jQk/AAAAAAAAAAI/AAAAAAAAAAA/1mGXrMiLwQw/s40-c-rp-mo-br100/photo.jpg',
    comment: `EnergyPal provided me with a wealth of information and guidance, and some very good proposals, in an unbiased way. The focus was always on my needs and specifics, with no sales pressure. Marcus was always responsive, resourceful and creative in helping me decide on my solar solution to going carbon free. I recommend them wholeheartedly.`,
  },
  {
    name: 'Nicholas Pabon',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-781qGvpUCF4/AAAAAAAAAAI/AAAAAAAAAAA/oMmrb4JwzCg/s40-c-rp-mo-br100/photo.jpg',
    comment: `Lincoln was very patient and explained everything carefully and precisely. I felt like we were not being forced or sold on a product but thought about solar panel and able to make what we feel would be our best option. I highly recommend energy geeks and Lincoln.`,
  },
  {
    name: 'Alfred Vouk',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-XE5G7uUA3gg/AAAAAAAAAAI/AAAAAAAAAAA/cypoNlXhQmw/s40-c-rp-mo-br100/photo.jpg',
    comment: `Mikaela thoroughly explained every step of the process and the technicalities with impressive knowledge and unlimited patience. EnergyPal is lucky to have her. We enjoyed working with Mikaela and are looking forward to our solar installation.`,
  },
  {
    name: 'Dennis Newell',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-syKvE5A5mj8/AAAAAAAAAAI/AAAAAAAAAAA/es7fb_JaxHM/s40-c-rp-mo-br100/photo.jpg',
    comment: `I have worked with John Kennedy from the beginning with my first inquiry into Solar Panels.  I found John more than helpful proven by the fact that I went through with installation and in March of this year I was producing solar energy at my place of residence.  I am more than happy with everything.

    On a personal note I would like to comment on Mr. Kennedy's professionalism and knowledge of solar panels. As a customer I have always been treated with respect and kindness.  Mr. Kennedy's knowledge and expertise were very helpful and very in depth, he was able to explain things in terms that were easy to understand and was available to help in anyway he could. I worked in Customer Support for 22 years and I know how it is supposed to work and I consider Mr, Kennedy and outstanding representative of his company and the product he represents.
    
    I recommend EnergyPal Corporation and their product.  Mr. Kennedy if an outstanding person to work with.  Mr. Kennedy was able to pull the entire team together and I was very satisfied from installation to completion of my freedom from polluting the  global environment by using solar panels.  I personally have experienced generating up to six times the energy I was consuming and returned this energy to the grid in my area.  
    
    Mr. Kennedy and EnergyPal Corporation I consider to be outstanding in the business world today.`,
  },
  {
    name: 'Gary Bates',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-gF6j_hJtom8/AAAAAAAAAAI/AAAAAAAAAAA/Lya4vJnkgpE/s40-c-rp-mo-br100/photo.jpg',
    comment: `Worked with Alex Nicol. Could not have been any more informative. Was a joy to work with. Answered all our questions asap. The whole process went smooth as glass. He coordinated everything and kept us in the loop all the time. Wonderful experience!!!!!!!`,
  },
  {
    name: 'ardyth robinson',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-OQ4Trt_9ixo/AAAAAAAAAAI/AAAAAAAAAAA/VOnmTRb4ssA/s40-c-rp-mo-br100/photo.jpg',
    comment: `I have never had a better experience in making a major decision like this.  Mikaela Preston is a cut above. She educated and walked me through overstep of this new installation and I can assure you there were many questions.  I am confident I have made a decision that is best for me personally. This project coordinator has been an excellent representative professionally, with kind transparency and ethical, business procedure.  She did everything she could to make this event understandable and easy.  No big sales methods needed here.  She clearly is also working for a good product.`,
  },
  {
    name: 'Andrea Lindsay',
    type: 'google',
    rating: 5,
    photo:
      'https://lh5.googleusercontent.com/-1xWpvVpDzfQ/AAAAAAAAAAI/AAAAAAAAAAA/jFTy277KEoo/s40-c-rp-mo-br100/photo.jpg',
    comment: `Mikaela was extremely helpful, knowledgeable, and patient with us as we explored our solar power options. Her manner was courteous and pleasant, and she walked us through the process in a very professional manner.`,
  },
  {
    name: 'Betsy Ortolano',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-fL7WXGSMaJ8/AAAAAAAAAAI/AAAAAAAAAAA/aFDs_XGgxT4/s40-c-rp-mo-br100/photo.jpg',
    comment: `Lincoln was very helpful, answered all my questions and getting our panels installed today!`,
  },
  {
    name: 'kathy mienko',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-SlIsYDOrQtQ/AAAAAAAAAAI/AAAAAAAAAAA/07_OEM0th2U/s40-c-rp-mo-br100/photo.jpg',
    comment: `I just started a solar lease search and Lincoln helped me tremendously. He has shown patience and shared his knowledge all to help me understand and pick the best option.  I am very happy with the service!`,
  },
  {
    name: 'James Crook',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-KpQZR2PXZQc/AAAAAAAAAAI/AAAAAAAAAAA/XmoJr2GwMi8/s40-c-rp-mo-br100/photo.jpg',
    comment: `Well today John Kennedy and I finally were able to connect by phone after a bit of phone tag and I will say that John is a very knowledgeable person. Yes I know that he has to be for his job but to be able to answer the question posed to him and then have him say" well you know there are some more questions you did not ask". Then proceed to give Very important information was a bonus. The system is a confusing one for any individual and to have someone stay on the line and talk you thru all the paperwork and not get frustrated with my questions and fumbles was great. The computer work required seems daunting but with his assistance was accomplished smoothly. Thanks for an enjoyable experience.`,
  },
  {
    name: 'Johnny Thach',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-7k5YwNY_0W8/AAAAAAAAAAI/AAAAAAAAAAA/naHgz-iuTuU/s40-c-rp-mo-br100/photo.jpg',
    comment: `Lincoln was very friendly and well informed on many solar companies and their options on paying for the solar systems. He provided me the best company that would fit my needs perfectly in my state. Any questions I asked were answered articulately. I highly recommend going through Lincoln and EnergyPal to save money on your energy needs. So far it looks like I will save 90% on my bill. Compared to Energy Sage, I got more than just quoted numbers, I got transparency and learned a lot from Lincoln. Thank you for everything Lincoln and EnergyPal!`,
  },
  {
    name: 'Scott Holmwood',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-oqg8QVCffxo/AAAAAAAAAAI/AAAAAAAAAAA/i6tEe7gsst4/s40-c-rp-mo-br100/photo.jpg',
    comment: `After getting tired of paying almost $400 a month in electricity bills, I recently made the decision to go solar at my home. I did some extensive research and decided to contract with EnergyPal. I started my solar journey with Alex Nicol, solar consultant. Alex has made this whole experience easy and care free for us to undertake. He consulted us on the right size system for our usage and home size. Never once tried to “oversell” the product and has explained the entire process in terms that anyone can understand. He broke it down to the basics of why Solar is such a viable energy source now compared to years ago. He mapped out the time line in the process and everything he sold is exactly what we got!! No smoke and mirrors! 
        As he said, Sun Power took over everything, no sub contacted work with any other company.  The installation was completed yesterday and the crew was professional, experienced, and polite. 
       All were waiting on now is Eversource to swap out their meter and the Town to sign off and then we flip the switch and SAVE!!
       Thank you to Alex, and Sun Power for their commitment to customer experience. So far, stellar treatment!! Very impressive`,
  },
  {
    name: 'Russ Hokanson',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-e-UzFI-2ihY/AAAAAAAAAAI/AAAAAAAAAAA/_Nw7eYX_UVw/s40-c-rp-mo-br100/photo.jpg',
    comment: `EnergyPal did a fantastic job!!!  They explained everything they were going to do, completed all of the work on time and cleaned all areas.  I would definitely use them again!!!`,
  },
  {
    name: 'Joseph Bernstein',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-5Hm2flVWn5k/AAAAAAAAAAI/AAAAAAAAAAA/fKsc7sMUwuY/s40-c-rp-mo-br100/photo.jpg',
    comment: `Alexander Nicol has been very knowledgeable helpful and straightforward in our discussions of solar power systems. Even though we did not choose SunPower, we had an excellent experience and a good opinion of Alexander Nicol. and energy geeks
        `,
  },
  {
    name: 'Bryan Cadogan',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-qPk0PHt-KP8/AAAAAAAAAAI/AAAAAAAAAAA/4TcCctIhOxE/s40-c-rp-mo-br100/photo.jpg',
    comment: `Working with Lincoln panasy was a absolute pleasure. I’ve never spoken to anyone so passionate about helping people go solar. You can really tell right away Lincoln is knowable, honest, and really cares about his role in guiding people through the process, and how solar works. He really takes the time to get to know your project site  and will teach you all about solar till  you feel confident about your decision to go solar, or if you decide not to that’s fine also he’s just happy to have the chance to educate someone on solar.`,
  },
  {
    name: 'Mellisa Schrock',
    type: 'google',
    rating: 5,
    photo:
      'https://lh5.googleusercontent.com/-SjjN6mdnp74/AAAAAAAAAAI/AAAAAAAAAAA/hZgt1fYVMQs/s40-c-rp-mo-br100/photo.jpg',
    comment: `I would highly recommend this company for your solar system needs. I never thought I would get solar panels but I’m so thankful I did. Marcus Joo was absolutely great to work with...very informative and always returned my phone calls. The company handled the installation and kept me up to date with the progress. Definitely saving us money throughout the year! Noah and Mellisa`,
  },
  {
    name: 'Celes Davar',
    type: 'google',
    rating: 5,
    photo:
      'https://lh5.googleusercontent.com/-rGAjdgV8TP4/AAAAAAAAAAI/AAAAAAAAAAA/JCtvmS6iZak/s40-c-rp-mo-br100/photo.jpg',
    comment: `We've been wanting to install solar PV for a couple of years. We were having some challenges with getting a solid quote from a solar installer in Nova Scotia, that would address all of the requirements for professional and technical support, accurate costs, timely responses, and a clear budget. We received all of these from Mikaela at EnergyPal. Including a very responsive communication thread to all of our questions. Her knowledge of the process, the content of the contract documents, and helpful customer service were all instrumental in helping us to make a decision to go with their proposal. Thank you very much! Looking forward to the next steps and the install.
        `,
  },
  {
    name: 'Sally Miller',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-SlhGfC9W5YM/AAAAAAAAAAI/AAAAAAAAAAA/00MJXjJCh7M/s40-c-rp-mo-br100/photo.jpg',
    comment: `I'm still a newbie but thus far everything had been outstanding.   Alex has been very helpful on the geeks end and Damian was perfect on the sun power side.  I'm looking forward to not dreading my electric bill in the mail`,
  },
  {
    name: 'Romina K',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-hWSwTO0TrVk/AAAAAAAAAAI/AAAAAAAAAAA/pFM3lr2nEF8/s40-c-rp-mo-br100/photo.jpg',
    comment: `We received our first bill and all I have to say is I'm so thankful for this company. We had a great experience dealing with their kind team. No pressure, very informative, and definitely looking out for my family's best interest. Our $80 savings compared to last year this time proved that. Thanks a bunch.`,
  },
  {
    name: 'Bob Lees',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-OtcYdLTBL4A/AAAAAAAAAAI/AAAAAAAAAAA/tt8z6YNJ8zE/s40-c-rp-mo-br100/photo.jpg',
    comment: `From speaking with Alex back in February, when we decided to have a couple of trees removed, and Alex was so understanding and not pushy about calling back in a few months, I knew I was in great hands!   We resumed the process in early June, and Alex has given me options and advice that really put me at ease.   Very glad to be  a part of the Sunpower - EnergyPal family, and looking forward to lowering my grid footprint. Thank you Alex, EnergyPal and Sunpower!`,
  },
  {
    name: 'Laura Reasons',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-yct2dAbwHFI/AAAAAAAAAAI/AAAAAAAAAAA/bDFRIAZ0vNQ/s40-c-rp-mo-br100/photo.jpg',
    comment: `Lincoln at EnergyPal has been very friendly and knowledgeable.  He did a great job of making difficult concepts easy to understand.  Still going through the process, but so far so good!`,
  },
  {
    name: 'Tony Riccardo',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-G-ZUGmQOq0c/AAAAAAAAAAI/AAAAAAAAAAA/EeL4TlXw4NQ/s40-c-rp-mo-br100/photo.jpg',
    comment: `I had a ready good experience with my consult.  Alex was knowledgeable and relatable.  He took the time to answer all my questions.`,
  },
  {
    name: 'Joakim Gomes',
    type: 'google',
    rating: 5,
    photo:
      'https://lh5.googleusercontent.com/-eWwUr0sCqMc/AAAAAAAAAAI/AAAAAAAAAAA/-H1y3a9jtF8/s40-c-rp-mo-br100/photo.jpg',
    comment: `It was really informative working with John Kennedy from the beginning, he is very forthcoming and knowledgeable on solar panels which helped me in making the decision to go ahead.`,
  },
  {
    name: 'Sobol Family',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-0eh3PUJlliE/AAAAAAAAAAI/AAAAAAAAAAA/4ECjXPneSr0/s40-c-rp-mo-br100/photo.jpg',
    comment: `Great experience working with Lincoln to set us up with a great solar system for our new home.`,
  },
  {
    name: 'Natalie Bassano',
    type: 'google',
    rating: 5,
    photo:
      'https://lh5.googleusercontent.com/-vGzaALC8Db8/AAAAAAAAAAI/AAAAAAAAAAA/oHoWT_wI6Q4/s40-c-rp-mo-br100/photo.jpg',
    comment: `We have had a great experience with EnergyPal, thanks to Lincoln Panasy.  He has taken so much time to explain everything and has been extremely helpful through out the whole process.`,
  },
  {
    name: 'Gerald H. Martin Sr.',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-3fAc3DJrQfg/AAAAAAAAAAI/AAAAAAAAAAA/J_iOVYpCTZQ/s40-c-rp-mo-br100/photo.jpg',
    comment: `I spoke with Mr. Lincoln Panasy ( of EnergyGreeks Corp.) today and signed up with Sunpower to supply solar energy to my home residence. Lincoln was very articulate in explaining the equipment, savings, and overall benefit of changing over to solar energy while  state and federal incentives exist. Lincoln was extremely honest, patient and knowable about the entire process. Lincoln was also very personable  as we discussed how his father and  I shared common automobile knowledge and experience with old school cars. There was a conform zone created that provided the foundation to establish a communication of trust  and assurance. I plan to continue communication with Lincoln as this project progresses.
        Gerald H Martin`,
  },
  {
    name: 'Tom K',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-gwXFsMzq51A/AAAAAAAAAAI/AAAAAAAAAAA/y9Tv1zZhJaQ/s40-c-rp-mo-br100/photo.jpg',
    comment: `Pleasure working with Lincoln Panasy through our almost year-long decision and planning process to go Solar!  He is experienced, engaging, and committed -- fantastic consultant!`,
  },
  {
    name: 'John Molenda',
    type: 'google',
    rating: 5,
    photo:
      'https://lh3.googleusercontent.com/-H4CrDPnLi7Q/AAAAAAAAAAI/AAAAAAAAAAA/8R53kg0jU_A/s40-c-rp-mo-br100/photo.jpg',
    comment: `Very helpful and informative. We started the process of using the sun for power. A big shoutout to Lincoln. Thanks.`,
  },
  {
    name: 'Ling Lovanh',
    type: 'google',
    rating: 5,
    photo:
      'https://lh4.googleusercontent.com/-tlo_gFqYh5I/AAAAAAAAAAI/AAAAAAAAAAA/TpeWrS49N14/s40-c-rp-mo-br100/photo.jpg',
    comment: `Very knowledgeable & professional! Their expertise in their products was very refreshing & they took the time to tell me about all aspects to make sure I was properly educated. I was very impressed with the way they handled everything & am very happy with my decision to get my solar panels :)`,
  },
  {
    name: 'Surround Inc',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-16ODJkTmTK8/AAAAAAAAAAI/AAAAAAAAAAA/zhOcrZD_0z4/s40-c-rp-mo-br100/photo.jpg',
    comment: `They assisted with our company solar project. I'll be sending referrals to you guys with confidence. World class company. Thanks all who were involved. -Mike`,
  },
  {
    name: 'David Morley',
    type: 'google',
    rating: 5,
    photo:
      'https://lh6.googleusercontent.com/-OofJlEwZ5so/AAAAAAAAAAI/AAAAAAAAAAA/Arh8ITp7CDA/s40-c-rp-mo-br100/photo.jpg',
    comment: `Sam has been great to work with, he has been very patient and diligently answered all of our questions.`,
  },
];

export const topSellingVehicles = [
  {
    name: 'Tesla Model Y - (394,497 Sold)',
    slug: 'tesla/tesla-model-y-long-range-awd',
    webp: ModelY,
    png: sunpowerLogoFallback,
    points: [
      'MPGe: 125 combined',
      'Mid/Full - Efficient',
      '75 kWh - 326 miles (4.34 m/kWh)',
    ],
  },
  {
    name: 'Tesla Model 3 - (220,910 Sold)',
    slug: 'tesla/tesla_model_3_standard_range_plus',
    webp: Model3,
    png: recLogoFallback,
    points: [
      'MPGe Standard Range: 138 city - 124 hwy - 133 combined',
      'MPGe Long Range: 136 city - 123 hwy - 130 combined',
      'Compact - Very Efficient',
      'Standard Range 54 kWh - 151 miles (2.79 m/kWh)',
      'Long Range 82 kWh - 568 miles (6.92 m/kWh)',
    ],
  },
  {
    name: 'Chevrolet Bolt (62,045 Sold)',
    slug: 'chevrolet/chevrolet-bolt-ev-65-kwh',
    webp: Bolt,
    png: lgFallbackLogo,
    points: ['Up to 259 mile range', '25 kWh/100 miles', 'Made in USA'],
  },
  {
    name: 'Ford Mustang Mach-E (40,771 Sold)',
    slug: 'ford/ford-mustang-mach-e-er-awd',
    webp: MachE,
    png: solariaFallbackLogo,
    points: [
      'Up to 210 mile range',
      '47 kWh/100 miles',
      'Made in USA and Mexico',
    ],
  },

  {
    name: 'Volkswagen ID.4 - (37,789 Sold)',
    slug: '/volkswagen/vw-id-4-pure-52-kwh',
    webp: ID4,
    png: qcellsFallbackLogo,
    points: [
      'Up to 291 mile range',
      'Large Cargo Area',
      'Made in USA and Germany ',
    ],
  },
  {
    name: 'Solar EV Charging Calculator',
    slug: '/calculator',
    webp: SleekPanel,
    png: SleekPanel,
    points: [
      'Calculate solar EV charging savings.',
      'Advantages of a solar EV charging setup.',
    ],
  },
];

interface State {
  image: StaticImageData;
  state: string;
  link: string;
}
export const states: State[] = [
  {
    image: Arizona,
    state: 'Arizona',
    link: '/home-battery-solar-installers-near-me/az-arizona',
  },
  {
    image: California,
    state: 'California',
    link: '/home-battery-solar-installers-near-me/ca-california',
  },
  {
    image: Colorado,
    state: 'Colorado',
    link: '/home-battery-solar-installers-near-me/co-colorado',
  },
  {
    image: Connecticut,
    state: 'Connecticut',
    link: '/home-battery-solar-installers-near-me/ct-connecticut',
  },
  {
    image: Delaware,
    state: 'Delaware',
    link: '/home-battery-solar-installers-near-me/de-delaware',
  },
  {
    image: Florida,
    state: 'Florida',
    link: '/home-battery-solar-installers-near-me/fl-florida',
  },
  {
    image: Georgia,
    state: 'Georgia',
    link: '/home-battery-solar-installers-near-me/ga-georgia',
  },
  {
    image: Idaho,
    state: 'Idaho',
    link: '/home-battery-solar-installers-near-me/id-idaho',
  },
  {
    image: Illinois,
    state: 'Illinois',
    link: '/home-battery-solar-installers-near-me/il-illinois',
  },
  {
    image: Indiana,
    state: 'Indiana',
    link: '/home-battery-solar-installers-near-me/in-indiana',
  },
  {
    image: Iowa,
    state: 'Iowa',
    link: '/home-battery-solar-installers-near-me/ia-iowa',
  },
  {
    image: Kansas,
    state: 'Kansas',
    link: '/home-battery-solar-installers-near-me/ks-kansas',
  },
  {
    image: Kentucky,
    state: 'Kentucky',
    link: '/home-battery-solar-installers-near-me/ky-kentucky',
  },
  {
    image: Louisiana,
    state: 'Louisiana',
    link: '/home-battery-solar-installers-near-me/la-louisiana',
  },
  {
    image: Maine,
    state: 'Maine',
    link: '/home-battery-solar-installers-near-me/me-maine',
  },
  {
    image: Maryland,
    state: 'Maryland',
    link: '/home-battery-solar-installers-near-me/md-maryland',
  },
  {
    image: Massachusetts,
    state: 'Massachusetts',
    link: '/home-battery-solar-installers-near-me/ma-massachusetts',
  },
  {
    image: Michigan,
    state: 'Michigan',
    link: '/home-battery-solar-installers-near-me/mi-michigan',
  },
  {
    image: Minnesota,
    state: 'Minnesota',
    link: '/home-battery-solar-installers-near-me/mn-minnesota',
  },
  {
    image: Mississippi,
    state: 'Mississippi',
    link: '/home-battery-solar-installers-near-me/ms-mississippi',
  },
  {
    image: Missouri,
    state: 'Missouri',
    link: '/home-battery-solar-installers-near-me/mo-missouri',
  },
  {
    image: Nevada,
    state: 'Nevada',
    link: '/home-battery-solar-installers-near-me/nv-nevada',
  },
  {
    image: NewHampshire,
    state: 'New Hampshire',
    link: '/home-battery-solar-installers-near-me/nh-newhampshire',
  },
  {
    image: NewYork,
    state: 'New York',
    link: '/home-battery-solar-installers-near-me/ny-new-york',
  },
  {
    image: NewJersey,
    state: 'New Jersey',
    link: '/home-battery-solar-installers-near-me/nj-new-jersey',
  },
  {
    image: NewMexico,
    state: 'New Mexico',
    link: '/home-battery-solar-installers-near-me/nm-new-mexico',
  },
  {
    image: NorthCarolina,
    state: 'North Carolina',
    link: '/home-battery-solar-installers-near-me/nc-northcarolina',
  },
  {
    image: Ohio,
    state: 'Ohio',
    link: '/home-battery-solar-installers-near-me/oh-ohio',
  },
  {
    image: Oklahoma,
    state: 'Oklahoma',
    link: '/home-battery-solar-installers-near-me/ok-oklahoma',
  },
  {
    image: Oregon,
    state: 'Oregon',
    link: '/home-battery-solar-installers-near-me/or-oregon',
  },
  {
    image: Pennsylvania,
    state: 'Pennsylvania',
    link: '/home-battery-solar-installers-near-me/pa-pennsylvania',
  },
  {
    image: RhodeIsland,
    state: 'Rhode Island',
    link: '/home-battery-solar-installers-near-me/ri-rhode-island',
  },
  {
    image: SouthCarolina,
    state: 'South Carolina',
    link: '/home-battery-solar-installers-near-me/sc-south-carolina',
  },
  {
    image: Tennessee,
    state: 'Tennessee',
    link: '/home-battery-solar-installers-near-me/tn-tennessee',
  },
  {
    image: Texas,
    state: 'Texas',
    link: '/home-battery-solar-installers-near-me/tx-texas',
  },
  {
    image: Utah,
    state: 'Utah',
    link: '/home-battery-solar-installers-near-me/ut-utah',
  },
  {
    image: Vermont,
    state: 'Vermont',
    link: '/home-battery-solar-installers-near-me/vt-vermont',
  },
  {
    image: Virginia,
    state: 'Virginia',
    link: '/home-battery-solar-installers-near-me/va-virginia',
  },
  {
    image: Washington,
    state: 'Washington',
    link: '/home-battery-solar-installers-near-me/wa-washington',
  },
  {
    image: WashingtonDC,
    state: 'Washington DC',
    link: '/home-battery-solar-installers-near-me/dc-washington-dc',
  },
  {
    image: Wisconsin,
    state: 'Wisconsin',
    link: '/home-battery-solar-installers-near-me/wi-wisconsin',
  },
];

interface Province {
  image: StaticImageData;
  state: string;
  link: string;
}
export const provinces: Province[] = [
  {
    image: Alberta,
    state: 'Alberta',
    link: '/home-battery-solar-installers-near-me/ab-alberta',
  },
  {
    image: BritishColumbia,
    state: 'British Columbia',
    link: '/home-battery-solar-installers-near-me/bc-british-columbia',
  },
  {
    image: Manitoba,
    state: 'Manitoba',
    link: '/home-battery-solar-installers-near-me/mn-manitoba',
  },
  {
    image: NovaScotia,
    state: 'Nova Scotia',
    link: '/home-battery-solar-installers-near-me/ns-nova-scotia',
  },
  {
    image: NewBrunswick,
    state: 'New Brunswick',
    link: '/home-battery-solar-installers-near-me/nb-new-brunswick',
  },
  {
    image: NewfoundlandandLabrador,
    state: 'Newfoundland Labrador',
    link: '/home-battery-solar-installers-near-me/nl-newfoundland-labrador',
  },
  {
    image: Ontario,
    state: 'Ontario',
    link: '/home-battery-solar-installers-near-me/on-ontario',
  },
  {
    image: PrinceEdwardIsland,
    state: 'Prince Edward Island',
    link: '/home-battery-solar-installers-near-me/pei-prince-edward-island',
  },
  {
    image: Quebec,
    state: 'Quebec',
    link: '/home-battery-solar-installers-near-me/qc-quebec',
  },
  {
    image: Saskatchewan,
    state: 'Saskatchewan',
    link: '/home-battery-solar-installers-near-me/sk-saskatchewan',
  },
];

export const installerTopCards = [
  // {
  //   name: 'SunPower',
  //   // EPRating: '4.8',
  //   imageSrc: Sunpower,
  //   rating: '4.6',
  //   reasonsWhy: [
  //     'Maxeon panels give you the most energy per watt and over time.',
  //     'Incredible product quality and complete warranties.',
  //     'The only integrated Manufacturer, Contractor and Warranty Holder.',
  //     'Selected by NASA, Apple headquarters and other top institutions.',
  //   ],
  //   installerStrengths: [
  //     'Multi-billion dollar public company on the NASDAQ [SPWR].',
  //     'Founded in 1985, SunPower pioneered solar manufacturing.',
  //     'Maxeon panels have the highest efficiency with a lower degradation rate.',
  //     '25-year Complete Confidence solar and roof warranty.',
  //     'Excellent project management to get your job done.',
  //   ],
  //   concerns: [
  //     'Sometimes project communication is underwhelming. Overall quality of product, warranty and post installation service are top notch.',
  //   ],
  //   reviews: [
  //     {
  //       name: 'Darren',
  //       content:
  //         "My family and I decided to go with SunPower and have panels installed. We were extremely hesitant that the numbers Arvin was quoting were too good to be true and that the install process would damage the roof. We were wrong! The number were true and the install was perfect. The entire process was as promised and now (5 months in) my electricity bills are a fraction of what they used to be. I'd like to thank Arvin and the entire SunPower team for performing flawlessly and keeping me updated throughout the permit, install and set up process.",
  //       rating: '5',
  //       date: '9/18/23',
  //       location: 'Northvale, NJ',
  //     },
  //     {
  //       name: 'Mark',
  //       content:
  //         "When we enrolled with SunPower, it was not high pressure. It was very professional. When it came time to get the specific proposal, I knew exactly what we were getting, where the panels were gonna be located on our roof, what the power output we were expecting and how much the project was gonna cost. The installation went well and they took a look at our roof to make sure that it was in good shape and that we didn't have to reroof or reshingle beforehand. They went into the attic and made sure that all the roof support was in good shape, since these panels had a fair amount of weight to the roof. They were careful about making sure that they weren't just selling us something because that would work for them, but that would work well for us and not cause any problems to the structure of our house.",
  //       rating: '5',
  //       date: '3/24/23',
  //       location: 'Danville, CA',
  //     },
  //   ],
  //   link: '/solar-installer-reviews/sunpower',

  //   headquarters: '51 Rio Robles San Jose, CA 95134',
  //   serviceArea: 'AZ, CA, CO, CT, IL, MA, NC, NY, NJ, VA',
  // },
  {
    name: 'Sunnova Solar Power',
    // EPRating: '4.4',
    imageSrc: Sunnova, // Replace with the actual image source
    rating: '4.2',
    reasonsWhy: [
      'Production guarantee on all financing (loan/lease/PPA).',
      'Incredible 25-year solar installation and battery warranties.',
      'Access to many great local installers within the network.',
    ],
    installerStrengths: [
      'Multi-billion dollar public company on the NYSE [NOVA].',
      'Most consumer-friendly power purchasing agreements.',
      'All-inclusive 25-year Protect Plan provides extra coverage.',
      'Extended 25-year battery warranty best in the industry.',
    ],
    concerns: [
      'Strictest underwriting guidelines disqualify many applicants.',
      'Project communication can sometimes be confusing, but installation process and warranties are top-notch.',
    ],
    reviews: [
      {
        name: 'Ryan',
        content:
          'Good system. Produces as expected. Overall happy with the purchase. Recently had the system go down due to a defective part. Took about 2 months to get replacement parts. Just the way of the world right now but frustrating as it was over a period of what is 2 high producing months. Add in the usage of AC and a pool pump it was two fold. Zero solar production and high electric bills because of regular summer usage. In totality a good system that I would recommend. Just wished that replacement parts were more readily available for what is only an approximately 2 year old system.',
        rating: '5',
        date: '09/13/2023',
        location: 'Blandon, Pennsylvania',
      },
      {
        name: 'Dowjo',
        content: 'I like the system and the set-up.',
        rating: '4',
        date: '09/12/2023',
        location: 'Mira Loma, California ',
      },
    ],
    link: '/solar-installer-reviews/sunnova',

    headquarters: '20 Greenway Plaza, Houston TX, 77046',
    serviceArea:
      'CA, NV, AZ, UT, TX, CO, NM, MN, MI, IL, TN, GA, FL, SC, NC, VA, OH, MA, NJ, CT, RI, NY, PA',
  },
  {
    name: 'Axia by Qcells',
    imageSrc: Axia,
    rating: '4.1',
    reasonsWhy: [
      'A complete range of solar solutions from panel manufacturing to installation and financing.',
      'Proven track record and custom centric approach.',
      'Great product quality and complete warranties.',
    ],
    installerStrengths: [
      '25-year product and workmanship warranties, and up to 30 years of performance warranty.',
      'Qcells panels are installed on over 30% of residential solar systems in the US.',
      'Axia is backed by Qcells, the largest solar panel manufacturer in the U.S.',
    ],
    concerns: [
      'Axia by Qcells has a smaller installer territory and are currently limited to California, Florida and Texas.',
    ],
    reviews: [
      {
        name: 'Noam Crawford',
        content:
          "We had an amazing experience with Axia solar. I did my due diligence researching solar & batteries & this company checked all the boxes. They also have amazing customer service. Jasper and Annabelle walked us through the whole process & we couldn't be happier.",
        rating: '5',
        date: '2/5/2018',
        location: 'Windsor, CA',
      },
      {
        name: 'Shuai Z',
        content:
          "We worked with Axia Solar on installing the solar panels on our roof and we're absolutely happy with the service and quality Axia Solar provided. Alex and Cory did an excellent job in the whole process and took care of everything for us in the proposal, contracting, permitting and installation process. They always replied to our messages and addressed our concerns promptly within the same day. Highly recommend!",
        rating: '5',
        date: '2/5/2018',
        location: 'Irvine, CA',
      },
    ],
    link: '/solar-installer-reviews/axia-solar',

    headquarters: '400 Spectrum Center Drive Suite 1400, Irvine CA, 92618',
    serviceArea: 'CA, TX, FL',
  },

  {
    name: 'Blue Raven Solar',
    imageSrc: BlueRaven,
    rating: '4.47',
    reasonsWhy: [
      'Strong installation & project management expertise.',
      '2 year production guarantee on all systems & financing.',
      'Uses microinverters exclusively for better system reliability.',
    ],
    installerStrengths: [
      'Rapidly growing national solar installer covering 10+ states.',
      '10 Year workmanship and roof penetration warranties.',
      'Culture of meticulous project management.',
    ],
    concerns: ['Installation timelines can be slower.'],
    reviews: [
      {
        name: 'Jerry Covington',
        content:
          'The installers were quick and professional. They had all my panels installed and all of the wiring done in less than 5 hrs. I would definitely recommend them and Blue Raven Solar.',
        rating: '5',
        date: '09/17/23',
        location: 'Kansas City, Missouri ',
      },
      {
        name: 'Josh',
        content:
          'Fast, thorough, and great with communication/setting expectations. Would recommend to friends and family. Brady did a great job coming to my house to explain the cost breakdown and helping get everything approved and ready for installation. Jay did a great job with the actual install. I’m still waiting for the final approval from Idaho Power but I’m liking what I see so far!',
        rating: '5',
        date: '09/15/23',
        location: 'Nampa, Idaho ',
      },
    ],
    link: '/solar-installer-reviews//blue-raven-solar',

    headquarters: '1403 N. Research Way Orem, UT  84097',
    serviceArea: 'UT, NV, ID, WA, OR, CO, TX, IL, IN, OH, VA, NC, SC, FL',
  },
  {
    name: 'Suntuity Solar',
    // EPRating: '4.0',
    imageSrc: Suntuity,
    rating: '3.8',
    reasonsWhy: [
      'Many years of experience.',
      'Comprehensive service offerings.',
      'Many financing options through Energypal.',
    ],
    installerStrengths: [
      'Offers a 10-year workmanship and a separate 10-year roofing warranty.',
      'Very good installation pricing and access to quality panels.',
      'Has been in operation since 2008.',
    ],
    concerns: ['Installation timelines can be slower.'],
    reviews: [
      {
        name: 'Paul Breitenstine',
        content:
          'Had a great experience with this company and working with Giamo Zepp. He helped make sure everything was taken care of and went smoothly. I highly recommend him and this company',
        rating: '5',
        date: '08/09/2023',
        location: 'Berlin, New Jersey',
      },
      {
        name: 'S Pallante',
        content:
          'I am a customer of Suntuity Solar. I had a wonderful experience working with sales rep. Aaron Buckley. Everything went smoothly. He came to inspections and installation day and showed me how to monitor everything in the app. All my questions were answered. My solar panels are kicking and I am saving tons of money. It was definitely a great decision.',
        rating: '5',
        date: '07/03/2023',
        location: 'Westville, New Jersey',
      },
    ],
    link: '/solar-installer-reviews/suntuity-reviews',
    headquarters: '2137 Nj-35, Holmdel, New Jersey, 07733, United States',
    serviceArea: 'FL, IL, MA, MD, PA, NJ, SC, RI',
  },
];
export const installerTopCardsCA = [
  // {
  //   name: 'SunPower',
  //   // EPRating: '4.8',
  //   imageSrc: Sunpower,
  //   rating: '4.6',
  //   reasonsWhy: [
  //     'Maxeon panels give you the most energy per watt and over time.',
  //     'Incredible product quality and complete warranties.',
  //     'The only integrated Manufacturer, Contractor and Warranty Holder.',
  //     'Selected by NASA, Apple headquarters and other top institutions.',
  //   ],
  //   installerStrengths: [
  //     'Multi-billion dollar public company on the NASDAQ [SPWR].',
  //     'Founded in 1985, SunPower pioneered solar manufacturing.',
  //     'Maxeon panels have the highest efficiency with a lower degradation rate.',
  //     '25-year Complete Confidence solar and roof warranty.',
  //     'Excellent project management to get your job done.',
  //   ],
  //   concerns: [
  //     'Sometimes project communication is underwhelming. Overall quality of product, warranty and post installation service are top notch.',
  //   ],
  //   reviews: [
  //     {
  //       name: 'Darren',
  //       content:
  //         "My family and I decided to go with SunPower and have panels installed. We were extremely hesitant that the numbers Arvin was quoting were too good to be true and that the install process would damage the roof. We were wrong! The number were true and the install was perfect. The entire process was as promised and now (5 months in) my electricity bills are a fraction of what they used to be. I'd like to thank Arvin and the entire SunPower team for performing flawlessly and keeping me updated throughout the permit, install and set up process.",
  //       rating: '5',
  //       date: '9/18/23',
  //       location: 'Northvale, NJ',
  //     },
  //     {
  //       name: 'Mark',
  //       content:
  //         "When we enrolled with SunPower, it was not high pressure. It was very professional. When it came time to get the specific proposal, I knew exactly what we were getting, where the panels were gonna be located on our roof, what the power output we were expecting and how much the project was gonna cost. The installation went well and they took a look at our roof to make sure that it was in good shape and that we didn't have to reroof or reshingle beforehand. They went into the attic and made sure that all the roof support was in good shape, since these panels had a fair amount of weight to the roof. They were careful about making sure that they weren't just selling us something because that would work for them, but that would work well for us and not cause any problems to the structure of our house.",
  //       rating: '5',
  //       date: '3/24/23',
  //       location: 'Danville, CA',
  //     },
  //   ],
  //   link: '/solar-installer-reviews/sunpower',

  //   headquarters: '51 Rio Robles San Jose, CA 95134',
  //   serviceArea: 'AZ, CA, CO, CT, IL, MA, NC, NY, NJ, VA',
  // },
  {
    name: 'Sunnova Solar Power',
    // EPRating: '4.4',
    imageSrc: Sunnova, // Replace with the actual image source
    rating: '4.2',
    reasonsWhy: [
      'Production guarantee on all financing (loan/lease/PPA).',
      'Incredible 25-year solar installation and battery warranties.',
      'Access to many great local installers within the network.',
    ],
    installerStrengths: [
      'Multi-billion dollar public company on the NYSE [NOVA].',
      'Most consumer-friendly power purchasing agreements.',
      'All-inclusive 25-year Protect Plan provides extra coverage.',
      'Extended 25-year battery warranty best in the industry.',
    ],
    concerns: [
      'Strictest underwriting guidelines disqualify many applicants.',
      'Project communication can sometimes be confusing, but installation process and warranties are top-notch.',
    ],
    reviews: [
      {
        name: 'Ryan',
        content:
          'Good system. Produces as expected. Overall happy with the purchase. Recently had the system go down due to a defective part. Took about 2 months to get replacement parts. Just the way of the world right now but frustrating as it was over a period of what is 2 high producing months. Add in the usage of AC and a pool pump it was two fold. Zero solar production and high electric bills because of regular summer usage. In totality a good system that I would recommend. Just wished that replacement parts were more readily available for what is only an approximately 2 year old system.',
        rating: '5',
        date: '09/13/2023',
        location: 'Blandon, Pennsylvania',
      },
      {
        name: 'Dowjo',
        content: 'I like the system and the set-up.',
        rating: '4',
        date: '09/12/2023',
        location: 'Mira Loma, California ',
      },
    ],
    link: '/solar-installer-reviews/sunnova',

    headquarters: '20 Greenway Plaza, Houston TX, 77046',
    serviceArea:
      'CA, NV, AZ, UT, TX, CO, NM, MN, MI, IL, TN, GA, FL, SC, NC, VA, OH, MA, NJ, CT, RI, NY, PA',
  },
  {
    name: 'Axia by Qcells',
    imageSrc: Axia,
    rating: '4.1',
    reasonsWhy: [
      'No frills approach results in great installation pricing.',
      'Access to many top financing options.',
      'Excellent warranties.',
    ],
    installerStrengths: [
      '25 Year workmanship and roof penetration warranties.',
      'Grew from an electrical contractor with 35 years of history.',
      'Great low pricing due to large scale (1000+ installs/month).',
    ],
    concerns: [
      'Large installation territory can result in slower communications and issue resolution.',
    ],
    reviews: [
      {
        name: 'Noam Crawford',
        content:
          "We had an amazing experience with Axia solar. I did my due diligence researching solar & batteries & this company checked all the boxes. They also have amazing customer service. Jasper and Annabelle walked us through the whole process & we couldn't be happier.",
        rating: '5',
        date: '2/5/2018',
        location: 'Windsor, CA',
      },
      {
        name: 'Shuai Z',
        content:
          "We worked with Axia Solar on installing the solar panels on our roof and we're absolutely happy with the service and quality Axia Solar provided. Alex and Cory did an excellent job in the whole process and took care of everything for us in the proposal, contracting, permitting and installation process. They always replied to our messages and addressed our concerns promptly within the same day. Highly recommend!",
        rating: '5',
        date: '2/5/2018',
        location: 'Irvine, CA',
      },
    ],
    link: '/solar-installer-reviews/axia-solar',

    headquarters: '400 Spectrum Center Drive Suite 1400, Irvine CA, 92618',
    serviceArea: 'CA, TX, FL',
  },
];

export const SunPowerCard = {
  name: 'SunPower',
  imageSrc: Sunpower,
  rating: '4.6',
  reasonsWhy: [
    'Maxeon panels give you the most energy per watt and over time.',
    'Incredible product quality and complete warranties.',
    'The only integrated Manufacturer, Contractor and Warranty Holder.',
    'Selected by NASA, Apple headquarters and other top institutions.',
  ],
  installerStrengths: [
    'Multi-billion dollar public company on the NASDAQ [SPWR].',
    'Founded in 1985, SunPower pioneered solar manufacturing.',
    'Maxeon panels have the highest efficiency with a lower degradation rate.',
    '25-year Complete Confidence solar and roof warranty.',
    'Excellent project management to get your job done.',
  ],
  concerns: [
    'Sometimes project communication is underwhelming. Overall quality of product, warranty and post installation service are top notch.',
  ],
  reviews: [
    {
      name: 'Darren',
      content:
        "My family and I decided to go with SunPower and have panels installed. We were extremely hesitant that the numbers Arvin was quoting were too good to be true and that the install process would damage the roof. We were wrong! The number were true and the install was perfect. The entire process was as promised and now (5 months in) my electricity bills are a fraction of what they used to be. I'd like to thank Arvin and the entire SunPower team for performing flawlessly and keeping me updated throughout the permit, install and set up process.",
      rating: '5',
      date: '9/18/23',
      location: 'Northvale, NJ',
    },
    {
      name: 'Mark',
      content:
        "When we enrolled with SunPower, it was not high pressure. It was very professional. When it came time to get the specific proposal, I knew exactly what we were getting, where the panels were gonna be located on our roof, what the power output we were expecting and how much the project was gonna cost. The installation went well and they took a look at our roof to make sure that it was in good shape and that we didn't have to reroof or reshingle beforehand. They went into the attic and made sure that all the roof support was in good shape, since these panels had a fair amount of weight to the roof. They were careful about making sure that they weren't just selling us something because that would work for them, but that would work well for us and not cause any problems to the structure of our house.",
      rating: '5',
      date: '3/24/23',
      location: 'Danville, CA',
    },
  ],
  link: '/solar-installer-reviews/sunpower',

  headquarters: '51 Rio Robles San Jose, CA 95134',
  serviceArea: 'AZ, CA, CO, CT, IL, MA, NC, NY, NJ, VA',
};

export const SunnovaCard = {
  name: 'Sunnova Solar Power',
  // EPRating: '4.4',
  imageSrc: Sunnova, // Replace with the actual image source
  rating: '4.2',
  reasonsWhy: [
    'Production guarantee on all financing (loan/lease/PPA).',
    'Incredible 25-year solar installation and battery warranties.',
    'Access to many great local installers within the network.',
  ],
  installerStrengths: [
    'Multi-billion dollar public company on the NYSE [NOVA].',
    'Most consumer-friendly power purchasing agreements.',
    'All-inclusive 25-year Protect Plan provides extra coverage.',
    'Extended 25-year battery warranty best in the industry.',
  ],
  concerns: [
    'Strictest underwriting guidelines disqualify many applicants.',
    'Project communication can sometimes be confusing, but installation process and warranties are top-notch.',
  ],
  reviews: [
    {
      name: 'Ryan',
      content:
        'Good system. Produces as expected. Overall happy with the purchase. Recently had the system go down due to a defective part. Took about 2 months to get replacement parts. Just the way of the world right now but frustrating as it was over a period of what is 2 high producing months. Add in the usage of AC and a pool pump it was two fold. Zero solar production and high electric bills because of regular summer usage. In totality a good system that I would recommend. Just wished that replacement parts were more readily available for what is only an approximately 2 year old system.',
      rating: '5',
      date: '09/13/2023',
      location: 'Blandon, Pennsylvania',
    },
    {
      name: 'Dowjo',
      content: 'I like the system and the set-up.',
      rating: '4',
      date: '09/12/2023',
      location: 'Mira Loma, California ',
    },
  ],
  link: '/solar-installer-reviews/sunnova',

  headquarters: '20 Greenway Plaza, Houston TX, 77046',
  serviceArea:
    'CA, NV, AZ, UT, TX, CO, NM, MN, MI, IL, TN, GA, FL, SC, NC, VA, OH, MA, NJ, CT, RI, NY, PA',
};

export const TitanCard = {
  name: 'Titan Solar Power',
  // EPRating: '4.2',
  imageSrc: TitanSolar, // Replace with the actual image source
  rating: '4.1',
  reasonsWhy: [
    'No frills approach results in great installation pricing.',
    'Access to many top financing options.',
    'Excellent warranties.',
  ],
  installerStrengths: [
    '25 Year workmanship and roof penetration warranties.',
    'Grew from an electrical contractor with 35 years of history.',
    'Great low pricing due to large scale (1000+ installs/month).',
  ],
  concerns: [
    'Large installation territory can result in slower communications and issue resolution.',
  ],
  reviews: [
    {
      name: 'Jake Stevans',
      content:
        "Still brand new and the panels haven't started producing any power yet. But they look good on the roof, happy with the whole installation process so far. Phil M and the support team have been responsive when I reach out to them so no issues there. Phil always gets back to me via call or text right away whenever I reach out.",
      rating: '5',
      date: '10/12/2020',
      location: 'Las Vegas, NV ',
    },
    {
      name: 'Aurora Cruz',
      content:
        "DON'T LISTEN TO THE HYPE, WE LOVE TITAN! Titan was such a great company for me....I was able to ask a few of their representatives why they have some upset customers and they where very clear and transparent with me. Being a business owner myself, I understood what they meant when they said they had a bad year and quite extensive turnover of staff.... trying to get people that represented their brand, company, integrity and ethics correctly took a while company wide remodel. The director or owner ended up starting over, letting go anyone who showed diminished care for their clients. Its a tough process and I've been there...bad staff are common, lazy workers even more so. Impatience is thriving in 2022, we know this! So, I take my hat off that they put their foot down and made sure to get out all the bad apples though that is no easy task. PRODUCT: I've NEVER had a problem with TITAN at all. They've always been wonderful to work with, thorough, timely and competent. PANELS: Their panels have held up substatially, i have neighbors who's panels broke down and actually started to come apart after 3 years because they chose another company that was cheaper. Jokes on them!...mine are still looking and producing like bran new after 6! PRICING If you put them up against companies that use product comparable or of similar quality, then their pricing is very reasonable. BUT if you compare them to the local mom and pop that wants everyone to be FOOLED and go with them before their panels start breaking then you will be the dunce come 2025. Everyone, actually, that I know who went with the 'cheaper' company got what they paid for compared to me. I'm the only one in the neighborhood that has withstood all hail, wind and snow storms without any problems. I think people like to talk about the bad more than they do the good and if everyone I knew who purchase from a company that used them as their installers posted on here, I guarantee their rating would look more like 4.5 Ask people you KNOW after TIME how their panels are. See how 'cheaper' companies out there that use china's version of Titans AMERICAN product don't hold up. I would recommend them to my family and friends...oh wait, I DO recommend them to my family and friends! They are doing my mothers, aunt's and cousin's this next month and I look forward to their amazing reviews of this awesome company!",
      rating: '2/5/2018',
      date: '02/21/19',
      location: 'Reno, NV',
    },
  ],
  link: '/solar-installer-reviews/titan-solar-power',

  headquarters: '525 West Baseline Road, Mesa AZ, 85210',
  serviceArea: 'AZ, CA, CO, FL, GA, MO, NC, NM, NV, SC, TX, UT',
};

export const AxiaCard = {
  name: 'Axia by Qcells',
  imageSrc: Axia,
  rating: '4.1',
  reasonsWhy: [
    'A complete range of solar solutions from panel manufacturing to installation and financing.',
    'Proven track record and custom centric approach.',
    'Great product quality and complete warranties.',
  ],
  installerStrengths: [
    '25-year product and workmanship warranties, and up to 30 years of performance warranty.',
    'Qcells panels are installed on over 30% of residential solar systems in the US.',
    'Axia is backed by Qcells, the largest solar panel manufacturer in the U.S.',
  ],
  concerns: [
    'Axia by Qcells has a smaller installer territory and are currently limited to California, Florida and Texas.',
  ],
  reviews: [
    {
      name: 'Noam Crawford',
      content:
        "We had an amazing experience with Axia solar. I did my due diligence researching solar & batteries & this company checked all the boxes. They also have amazing customer service. Jasper and Annabelle walked us through the whole process & we couldn't be happier.",
      rating: '5',
      date: '2/5/2018',
      location: 'Windsor, CA',
    },
    {
      name: 'Shuai Z',
      content:
        "We worked with Axia Solar on installing the solar panels on our roof and we're absolutely happy with the service and quality Axia Solar provided. Alex and Cory did an excellent job in the whole process and took care of everything for us in the proposal, contracting, permitting and installation process. They always replied to our messages and addressed our concerns promptly within the same day. Highly recommend!",
      rating: '5',
      date: '2/5/2018',
      location: 'Irvine, CA',
    },
  ],
  link: '/solar-installer-reviews/axia-solar',

  headquarters: '400 Spectrum Center Drive Suite 1400, Irvine CA, 92618',
  serviceArea: 'CA, TX, FL',
};
export const BlueRavenCard = {
  name: 'Blue Raven Solar',
  imageSrc: BlueRaven,
  rating: '4.47',
  reasonsWhy: [
    'Strong installation & project management expertise.',
    '2 year production guarantee on all systems & financing.',
    'Uses microinverters exclusively for better system reliability.',
  ],
  installerStrengths: [
    'Rapidly growing national solar installer covering 10+ states.',
    '10 Year workmanship and roof penetration warranties.',
    'Culture of meticulous project management.',
  ],
  concerns: ['Installation timelines can be slower.'],
  reviews: [
    {
      name: 'Jerry Covington',
      content:
        'The installers were quick and professional. They had all my panels installed and all of the wiring done in less than 5 hrs. I would definitely recommend them and Blue Raven Solar.',
      rating: '5',
      date: '09/17/23',
      location: 'Kansas City, Missouri ',
    },
    {
      name: 'Josh',
      content:
        'Fast, thorough, and great with communication/setting expectations. Would recommend to friends and family. Brady did a great job coming to my house to explain the cost breakdown and helping get everything approved and ready for installation. Jay did a great job with the actual install. I’m still waiting for the final approval from Idaho Power but I’m liking what I see so far!',
      rating: '5',
      date: '09/15/23',
      location: 'Nampa, Idaho ',
    },
  ],
  link: '/solar-installer-reviews//blue-raven-solar',

  headquarters: '1403 N. Research Way Orem, UT  84097',
  serviceArea: 'UT, NV, ID, WA, OR, CO, TX, IL, IN, OH, VA, NC, SC, FL',
};

export const PalmettoCard = {
  name: 'Palmetto',
  imageSrc: Palmetto, // Replace with the actual image source
  rating: '3.9',
  reasonsWhy: [
    'Great installation pricing on good quality solar panels.',
    'Many financing options through Energypal.',
    'Software-enabled project management and customer service.',
  ],
  installerStrengths: [
    'National contractor with ample funding and financial backing.',
    'Very good installation pricing and access to quality panels.',
    'Standard 10-year workmanship and 5-year roof penetration warranties, or upgrade with Palmetto Protect plan.',
    'Includes custom monitoring app for solar production.',
  ],
  concerns: ['Current battery offering is not attractive.'],
  reviews: [
    {
      name: 'Donaldson',
      content:
        'We have had a great experience so far with Lauren and the Palmetto team! They provided all of the information and details in an informative and none pushy way. Lauren has been available for any questions that we had, and response time is great! The installation team was fast, efficient and kind. Our panels are now up and running and we look forward to an energy efficient home!',
      rating: '5',
      date: '02/06/2023',
      location: 'Pittsburgh, Pennsylvania',
    },
    {
      name: 'Teresa Marie',
      content: 'Service guys were nice and professional.',
      rating: '5',
      date: '02/01/2023',
      location: 'Dover, Pennsylvania ',
    },
  ],
  link: '/solar-installer-reviews/palmetto-solar',

  headquarters: '1505 King Street Suite #200 Charleston, SC 29405',
  serviceArea:
    'SC, NC, GA, VA, FL, NY, MA, CT, NJ, PA, OH, MI, WI, IL, MI, TX, NM, CO, AZ, UT, CA',
};

export const SuntuityCard = {
  name: 'Suntuity Solar',
  // EPRating: '4.0',
  imageSrc: Suntuity,
  rating: '3.8',
  reasonsWhy: [
    'Many years of experience.',
    'Comprehensive service offerings.',
    'Many financing options through Energypal.',
  ],
  installerStrengths: [
    'Offers a 10-year workmanship and a separate 10-year roofing warranty.',
    'Very good installation pricing and access to quality panels.',
    'Has been in operation since 2008.',
  ],
  concerns: ['Installation timelines can be slower.'],
  reviews: [
    {
      name: 'Paul Breitenstine',
      content:
        'Had a great experience with this company and working with Giamo Zepp. He helped make sure everything was taken care of and went smoothly. I highly recommend him and this company',
      rating: '5',
      date: '08/09/2023',
      location: 'Berlin, New Jersey',
    },
    {
      name: 'S Pallante',
      content:
        'I am a customer of Suntuity Solar. I had a wonderful experience working with sales rep. Aaron Buckley. Everything went smoothly. He came to inspections and installation day and showed me how to monitor everything in the app. All my questions were answered. My solar panels are kicking and I am saving tons of money. It was definitely a great decision.',
      rating: '5',
      date: '07/03/2023',
      location: 'Westville, New Jersey',
    },
  ],
  link: '/solar-installer-reviews/suntuity-reviews',
  headquarters: '2137 Nj-35, Holmdel, New Jersey, 07733, United States',
  serviceArea: 'FL, IL, MA, MD, PA, NJ, SC, RI',
};

export const CompleteSolarCard = {
  name: 'Complete Solar',
  // EPRating: '4.0',
  imageSrc: CompleteSolar,
  rating: '4.0',
  reasonsWhy: [
    'Access to Premium and Standard Black on Black Solar Panels.',
    'Excellent Project Management.',
    'Access to many top financing options.',
  ],
  installerStrengths: [
    'Excellent standard and premium equipment options.',
    'Large territory and diversified operations.',
    'Dedicated outbound project communications team to keep customers informed. ',
  ],
  concerns: [
    'Large installation territory and operations can result in multiple points of contact.',
  ],
  reviews: [
    {
      name: 'Paul Breitenstine',
      content:
        "Complete Solar didn't waste any time and got right to it like they said they were going to do it. We got along well with them and we communicated back and forth. I watched them put the panels up and everything that was needed. They also explained to me what they were doing, how and why they were doing it.",
      rating: '5',
      date: 'April 14, 2023',
      location: 'Tempe, AZ ',
    },
    {
      name: 'Ann Pfaff-Doss',
      content:
        'I had Complete Solar Solutions install my system four years ago. At the time, they were the only company I spoke to who were able to get me all of the rebates and credits without my filing for tax breaks. There was some broken roof tiles (typical for installations) and they paid my roofing company for the repair -- no questions asked. The installation crew was great. They went over and above what was required of them. There is a website where I can monitor operation of the system. Customer service has always been responsive.',
      rating: '5',
      date: '2/5/2018',
      location: 'USA',
    },
  ],
  link: '/solar-installer-reviews/complete-solar',
  headquarters: '3000 Executive Pkwy Suite 504 San Ramon, CA 94583',
  serviceArea: 'CA, CT, FL, NJ, MA, AZ, NC, TX, GA, UT, ID, VA, CO, SC, NH',
};

export const SunPowerArticleCard = {
  name: 'SunPower',
  // EPRating: '4.0',
  imageSrc: Sunpower,
  rating: '4.6',
  reasonsWhy: [
    'Founded in 1985, SunPower is consistently among the very top rated Solar installers due to their customer service and best in class technology.',
    'SunPower Equinox system is an all-in-one residential solar solution designed to integrate high-efficiency solar panels, microinverters, mounting hardware, and monitoring software into a cohesive package.',
    'Offering panels at efficiencies as high as 22.7%, the highest percentage commercially available for residential installations.',
  ],
  installerStrengths: [
    'Lowest overall customer complaint rate of any major solar installer in the US.',
    'Highest Efficiency panels available for residential installation.',
    'Warranty includes part shipping and installation, coverage unique to SunPower.',
    'The 40 year expected lifespan of the system delivers the best long-term ROI on solar arrays.',
  ],
  concerns: [
    'SunPower’s marginally higher upfront cost can be a deterrent to customers looking for the fastest payback period for panel installation.',
  ],
};

export const TeslaArticleCard = {
  name: 'Tesla',
  // EPRating: '4.0',
  imageSrc: TeslaEnergy,
  rating: '4.6',
  reasonsWhy: [
    'Tesla is most well known for their Electric Vehicles, although founder Elon Musk is also known for ventures such as Space-X, Purchasing Twitter, now “X”, and The Boring Company.',
    'Tesla Solar has installed solar arrays at break-neck speed and is now one of the largest solar installers in the US.',
    'A Non-functional Solar Roof tile prototype was unveiled in 2016 to shareholders, with the first solar roof tile installed in 2017.',
    'Tesla sells high quality mid-tier Korean QCells panels under their brand, and Chinese Amalden photovoltaic glass for their solar roof.',
  ],
  installerStrengths: [
    'Tesla Branded QCell panels offer an affordable and quality product.',
    'Warranty includes part shipping and installation, coverage unique to SunPower.',
    'Operates in 40 states (Tesla used to install in all 50 states but has seemingly reduced their installations to focus on states with high install rates)',
  ],
  concerns: [
    'Customers has cited long wait times for products and poor customer service during and after installation',
    'Sales process does not always reveal that the products are not manufactured by Tesla and presents them as Tesla products ',
  ],
  link: '/solar-installer-reviews/tesla',
  headquarters: '51 Rio Robles San Jose, CA 95134',
  serviceArea: 'AZ, CA, CO, CT, IL, MA, NC, NY, NJ, VA',
};
export const Top4CAInstallers = [
  // {
  //   name: 'SunPower',
  //   knownFor: 'Product quality and complete warranties',
  //   states: 40,
  //   purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
  //   workmanshipWarranty: '25 Years',
  //   equipmentWarranty: '25 Years',
  //   rating: '4.6/5',
  // },
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Axia by Qcells',
    knownFor: 'Great installation pricing and warranties',
    states: 3,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
];

export const Top3CAInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Titan Solar Power',
    knownFor: 'Great installation pricing and warranties',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
];
export const Top3MAInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Palmetto',
    knownFor: 'Exceptional service and installation pricing',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.9/5',
  },
];

export const Top3CTInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
];
export const Top3FLInstallers = [
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Titan Solar Power',
    knownFor: 'Great installation pricing and warranties',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Suntuity Solar',
    knownFor: 'Thorough offerings with many years of experience',
    states: 21,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.8/5',
  },
];

export const Top3ILInstallers = [
  {
    name: 'Titan Solar Power',
    knownFor: 'Great installation pricing and warranties',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
  {
    name: 'Palmetto',
    knownFor: 'Exceptional service and installation pricing',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.9/5',
  },
];

export const Top3NCInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Titan Solar Power',
    knownFor: 'Great installation pricing and warranties',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
];

export const Top3NJInstallers = [
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Titan Solar Power',
    knownFor: 'Great installation pricing and warranties',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Suntuity Solar',
    knownFor: 'Thorough offerings with many years of experience',
    states: 21,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.8/5',
  },
];
export const Top3NVInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
  {
    name: 'Palmetto',
    knownFor: 'Exceptional service and installation pricing',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.9/5',
  },
];
export const Top3OHInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Axia',
    knownFor: 'Great installation pricing and warranties',
    states: 3,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
];
export const Top3TXInstallers = [
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Axia',
    knownFor: 'Great installation pricing and warranties',
    states: 3,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
];
export const Top6USAInstallers = [
  {
    name: 'SunPower',
    knownFor: 'Product quality and complete warranties',
    states: 40,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.6/5',
  },
  {
    name: 'Sunnova Solar',
    knownFor: 'Incredible installation and battery warranties',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.2/5',
  },
  {
    name: 'Axia',
    knownFor: 'Great installation pricing and warranties',
    states: 3,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '25 Years',
    equipmentWarranty: '25 Years',
    rating: '4.1/5',
  },
  {
    name: 'Blue Raven Solar',
    knownFor: 'Reputable company with strong project management expertise',
    states: 18,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '4.47/5',
  },
  {
    name: 'Palmetto',
    knownFor: 'Exceptional service and installation pricing',
    states: 20,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.9/5',
  },
  {
    name: 'Suntuity Solar',
    knownFor: 'Thorough offerings with many years of experience',
    states: 21,
    purchaseOptions: ['Lease', 'PPA', 'Loan', 'Cash'],
    workmanshipWarranty: '10 Years',
    equipmentWarranty: '25 Years',
    rating: '3.8/5',
  },
];
